import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Color: { input: any; output: any };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  HTML: { input: any; output: any };
  ISO8601DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
  URL: { input: string; output: string };
  UnsignedInt64: { input: any; output: any };
};

/**
 * A version of the API, as defined by [Shopify API versioning](https://shopify.dev/api/usage/versioning).
 * Versions are commonly referred to by their handle (for example, `2021-10`).
 *
 */
export type ShopifyGenApiVersion = {
  __typename?: 'ApiVersion';
  /** The human-readable name of the version. */
  displayName: Scalars['String']['output'];
  /** The unique identifier of an ApiVersion. All supported API versions have a date-based (YYYY-MM) or `unstable` handle. */
  handle: Scalars['String']['output'];
  /** Whether the version is actively supported by Shopify. Supported API versions are guaranteed to be stable. Unsupported API versions include unstable, release candidate, and end-of-life versions that are marked as unsupported. For more information, refer to [Versioning](https://shopify.dev/api/usage/versioning). */
  supported: Scalars['Boolean']['output'];
};

/**
 * The input fields for submitting Apple Pay payment method information for checkout.
 *
 */
export type ShopifyGenApplePayWalletContentInput = {
  /** The customer's billing address. */
  billingAddress: ShopifyGenMailingAddressInput;
  /** The data for the Apple Pay wallet. */
  data: Scalars['String']['input'];
  /** The header data for the Apple Pay wallet. */
  header: ShopifyGenApplePayWalletHeaderInput;
  /** The last digits of the card used to create the payment. */
  lastDigits?: InputMaybe<Scalars['String']['input']>;
  /** The signature for the Apple Pay wallet. */
  signature: Scalars['String']['input'];
  /** The version for the Apple Pay wallet. */
  version: Scalars['String']['input'];
};

/**
 * The input fields for submitting wallet payment method information for checkout.
 *
 */
export type ShopifyGenApplePayWalletHeaderInput = {
  /** The application data for the Apple Pay wallet. */
  applicationData?: InputMaybe<Scalars['String']['input']>;
  /** The ephemeral public key for the Apple Pay wallet. */
  ephemeralPublicKey: Scalars['String']['input'];
  /** The public key hash for the Apple Pay wallet. */
  publicKeyHash: Scalars['String']['input'];
  /** The transaction ID for the Apple Pay wallet. */
  transactionId: Scalars['String']['input'];
};

/** Details about the gift card used on the checkout. */
export type ShopifyGenAppliedGiftCard = ShopifyGenNode & {
  __typename?: 'AppliedGiftCard';
  /** The amount that was taken from the gift card by applying it. */
  amountUsed: ShopifyGenMoneyV2;
  /**
   * The amount that was taken from the gift card by applying it.
   * @deprecated Use `amountUsed` instead.
   */
  amountUsedV2: ShopifyGenMoneyV2;
  /** The amount left on the gift card. */
  balance: ShopifyGenMoneyV2;
  /**
   * The amount left on the gift card.
   * @deprecated Use `balance` instead.
   */
  balanceV2: ShopifyGenMoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last characters of the gift card. */
  lastCharacters: Scalars['String']['output'];
  /** The amount that was applied to the checkout in its currency. */
  presentmentAmountUsed: ShopifyGenMoneyV2;
};

/** An article in an online store blog. */
export type ShopifyGenArticle = ShopifyGenHasMetafields &
  ShopifyGenNode &
  ShopifyGenOnlineStorePublishable &
  ShopifyGenTrackable & {
    __typename?: 'Article';
    /**
     * The article's author.
     * @deprecated Use `authorV2` instead.
     */
    author: ShopifyGenArticleAuthor;
    /** The article's author. */
    authorV2?: Maybe<ShopifyGenArticleAuthor>;
    /** The blog that the article belongs to. */
    blog: ShopifyGenBlog;
    /** List of comments posted on the article. */
    comments: ShopifyGenCommentConnection;
    /** Stripped content of the article, single line with HTML tags removed. */
    content: Scalars['String']['output'];
    /** The content of the article, complete with HTML formatting. */
    contentHtml: Scalars['HTML']['output'];
    /** Stripped excerpt of the article, single line with HTML tags removed. */
    excerpt?: Maybe<Scalars['String']['output']>;
    /** The excerpt of the article, complete with HTML formatting. */
    excerptHtml?: Maybe<Scalars['HTML']['output']>;
    /** A human-friendly unique string for the Article automatically generated from its title. */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The image associated with the article. */
    image?: Maybe<ShopifyGenImage>;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /** The date and time when the article was published. */
    publishedAt: Scalars['DateTime']['output'];
    /** The article’s SEO information. */
    seo?: Maybe<ShopifyGenSeo>;
    /**
     * A categorization that a article can be tagged with.
     *
     */
    tags: Array<Scalars['String']['output']>;
    /** The article’s name. */
    title: Scalars['String']['output'];
    /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
    trackingParameters?: Maybe<Scalars['String']['output']>;
  };

/** An article in an online store blog. */
export type ShopifyGenArticleCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An article in an online store blog. */
export type ShopifyGenArticleContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/** An article in an online store blog. */
export type ShopifyGenArticleExcerptArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/** An article in an online store blog. */
export type ShopifyGenArticleMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** An article in an online store blog. */
export type ShopifyGenArticleMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** The author of an article. */
export type ShopifyGenArticleAuthor = {
  __typename?: 'ArticleAuthor';
  /** The author's bio. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The author’s email. */
  email: Scalars['String']['output'];
  /** The author's first name. */
  firstName: Scalars['String']['output'];
  /** The author's last name. */
  lastName: Scalars['String']['output'];
  /** The author's full name. */
  name: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple Articles.
 *
 */
export type ShopifyGenArticleConnection = {
  __typename?: 'ArticleConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenArticleEdge>;
  /** A list of the nodes contained in ArticleEdge. */
  nodes: Array<ShopifyGenArticle>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Article and a cursor during pagination.
 *
 */
export type ShopifyGenArticleEdge = {
  __typename?: 'ArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ArticleEdge. */
  node: ShopifyGenArticle;
};

/** The set of valid sort keys for the Article query. */
export enum ShopifyGenArticleSortKeys {
  /** Sort by the `author` value. */
  Author = 'AUTHOR',
  /** Sort by the `blog_title` value. */
  BlogTitle = 'BLOG_TITLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
}

/** Represents a generic custom attribute, such as whether an order is a customer's first. */
export type ShopifyGenAttribute = {
  __typename?: 'Attribute';
  /**
   * The key or name of the attribute. For example, `"customersFirstOrder"`.
   *
   */
  key: Scalars['String']['output'];
  /**
   * The value of the attribute. For example, `"true"`.
   *
   */
  value?: Maybe<Scalars['String']['output']>;
};

/** The input fields for an attribute. */
export type ShopifyGenAttributeInput = {
  /** Key or name of the attribute. */
  key: Scalars['String']['input'];
  /** Value of the attribute. */
  value: Scalars['String']['input'];
};

/**
 * Automatic discount applications capture the intentions of a discount that was automatically applied.
 *
 */
export type ShopifyGenAutomaticDiscountApplication =
  ShopifyGenDiscountApplication & {
    __typename?: 'AutomaticDiscountApplication';
    /** The method by which the discount's value is allocated to its entitled items. */
    allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
    /** Which lines of targetType that the discount is allocated over. */
    targetSelection: ShopifyGenDiscountApplicationTargetSelection;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The title of the application. */
    title: Scalars['String']['output'];
    /** The value of the discount application. */
    value: ShopifyGenPricingValue;
  };

/** Represents a cart line common fields. */
export type ShopifyGenBaseCartLine = {
  /** An attribute associated with the cart line. */
  attribute?: Maybe<ShopifyGenAttribute>;
  /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
  attributes: Array<ShopifyGenAttribute>;
  /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
  cost: ShopifyGenCartLineCost;
  /** The discounts that have been applied to the cart line. */
  discountAllocations: Array<ShopifyGenCartDiscountAllocation>;
  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   * @deprecated Use `cost` instead.
   */
  estimatedCost: ShopifyGenCartLineEstimatedCost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The merchandise that the buyer intends to purchase. */
  merchandise: ShopifyGenMerchandise;
  /** The quantity of the merchandise that the customer intends to purchase. */
  quantity: Scalars['Int']['output'];
  /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
  sellingPlanAllocation?: Maybe<ShopifyGenSellingPlanAllocation>;
};

/** Represents a cart line common fields. */
export type ShopifyGenBaseCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/**
 * An auto-generated type for paginating through multiple BaseCartLines.
 *
 */
export type ShopifyGenBaseCartLineConnection = {
  __typename?: 'BaseCartLineConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenBaseCartLineEdge>;
  /** A list of the nodes contained in BaseCartLineEdge. */
  nodes: Array<ShopifyGenBaseCartLine>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one BaseCartLine and a cursor during pagination.
 *
 */
export type ShopifyGenBaseCartLineEdge = {
  __typename?: 'BaseCartLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of BaseCartLineEdge. */
  node: ShopifyGenBaseCartLine;
};

/** An online store blog. */
export type ShopifyGenBlog = ShopifyGenHasMetafields &
  ShopifyGenNode &
  ShopifyGenOnlineStorePublishable & {
    __typename?: 'Blog';
    /** Find an article by its handle. */
    articleByHandle?: Maybe<ShopifyGenArticle>;
    /** List of the blog's articles. */
    articles: ShopifyGenArticleConnection;
    /** The authors who have contributed to the blog. */
    authors: Array<ShopifyGenArticleAuthor>;
    /**
     * A human-friendly unique string for the Blog automatically generated from its title.
     *
     */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /** The blog's SEO information. */
    seo?: Maybe<ShopifyGenSeo>;
    /** The blogs’s title. */
    title: Scalars['String']['output'];
  };

/** An online store blog. */
export type ShopifyGenBlogArticleByHandleArgs = {
  handle: Scalars['String']['input'];
};

/** An online store blog. */
export type ShopifyGenBlogArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenArticleSortKeys>;
};

/** An online store blog. */
export type ShopifyGenBlogMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** An online store blog. */
export type ShopifyGenBlogMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * An auto-generated type for paginating through multiple Blogs.
 *
 */
export type ShopifyGenBlogConnection = {
  __typename?: 'BlogConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenBlogEdge>;
  /** A list of the nodes contained in BlogEdge. */
  nodes: Array<ShopifyGenBlog>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Blog and a cursor during pagination.
 *
 */
export type ShopifyGenBlogEdge = {
  __typename?: 'BlogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of BlogEdge. */
  node: ShopifyGenBlog;
};

/** The set of valid sort keys for the Blog query. */
export enum ShopifyGenBlogSortKeys {
  /** Sort by the `handle` value. */
  Handle = 'HANDLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
}

/**
 * The store's [branding configuration](https://help.shopify.com/en/manual/promoting-marketing/managing-brand-assets).
 *
 */
export type ShopifyGenBrand = {
  __typename?: 'Brand';
  /** The colors of the store's brand. */
  colors: ShopifyGenBrandColors;
  /** The store's cover image. */
  coverImage?: Maybe<ShopifyGenMediaImage>;
  /** The store's default logo. */
  logo?: Maybe<ShopifyGenMediaImage>;
  /** The store's short description. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** The store's slogan. */
  slogan?: Maybe<Scalars['String']['output']>;
  /** The store's preferred logo for square UI elements. */
  squareLogo?: Maybe<ShopifyGenMediaImage>;
};

/**
 * A group of related colors for the shop's brand.
 *
 */
export type ShopifyGenBrandColorGroup = {
  __typename?: 'BrandColorGroup';
  /** The background color. */
  background?: Maybe<Scalars['Color']['output']>;
  /** The foreground color. */
  foreground?: Maybe<Scalars['Color']['output']>;
};

/**
 * The colors of the shop's brand.
 *
 */
export type ShopifyGenBrandColors = {
  __typename?: 'BrandColors';
  /** The shop's primary brand colors. */
  primary: Array<ShopifyGenBrandColorGroup>;
  /** The shop's secondary brand colors. */
  secondary: Array<ShopifyGenBrandColorGroup>;
};

/**
 * The input fields for obtaining the buyer's identity.
 *
 */
export type ShopifyGenBuyerInput = {
  /** The identifier of the company location. */
  companyLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The customer access token retrieved from the [Customer Accounts API](https://shopify.dev/docs/api/customer#step-obtain-access-token). */
  customerAccessToken: Scalars['String']['input'];
};

/** Card brand, such as Visa or Mastercard, which can be used for payments. */
export enum ShopifyGenCardBrand {
  /** American Express. */
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** Diners Club. */
  DinersClub = 'DINERS_CLUB',
  /** Discover. */
  Discover = 'DISCOVER',
  /** JCB. */
  Jcb = 'JCB',
  /** Mastercard. */
  Mastercard = 'MASTERCARD',
  /** Visa. */
  Visa = 'VISA',
}

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCart = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Cart';
    /** The gift cards that have been applied to the cart. */
    appliedGiftCards: Array<ShopifyGenAppliedGiftCard>;
    /** An attribute associated with the cart. */
    attribute?: Maybe<ShopifyGenAttribute>;
    /** The attributes associated with the cart. Attributes are represented as key-value pairs. */
    attributes: Array<ShopifyGenAttribute>;
    /** Information about the buyer that's interacting with the cart. */
    buyerIdentity: ShopifyGenCartBuyerIdentity;
    /** The URL of the checkout for the cart. */
    checkoutUrl: Scalars['URL']['output'];
    /** The estimated costs that the buyer will pay at checkout. The costs are subject to change and changes will be reflected at checkout. The `cost` field uses the `buyerIdentity` field to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing). */
    cost: ShopifyGenCartCost;
    /** The date and time when the cart was created. */
    createdAt: Scalars['DateTime']['output'];
    /** The delivery properties of the cart. */
    delivery: ShopifyGenCartDelivery;
    /**
     * The delivery groups available for the cart, based on the buyer identity default
     * delivery address preference or the default address of the logged-in customer.
     *
     */
    deliveryGroups: ShopifyGenCartDeliveryGroupConnection;
    /** The discounts that have been applied to the entire cart. */
    discountAllocations: Array<ShopifyGenCartDiscountAllocation>;
    /** The case-insensitive discount codes that the customer added at checkout. */
    discountCodes: Array<ShopifyGenCartDiscountCode>;
    /**
     * The estimated costs that the buyer will pay at checkout. The estimated costs are subject to change and changes will be reflected at checkout. The `estimatedCost` field uses the `buyerIdentity` field to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
     * @deprecated Use `cost` instead.
     */
    estimatedCost: ShopifyGenCartEstimatedCost;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A list of lines containing information about the items the customer intends to purchase. */
    lines: ShopifyGenBaseCartLineConnection;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** A note that's associated with the cart. For example, the note can be a personalized message to the buyer. */
    note?: Maybe<Scalars['String']['output']>;
    /** The total number of items in the cart. */
    totalQuantity: Scalars['Int']['output'];
    /** The date and time when the cart was updated. */
    updatedAt: Scalars['DateTime']['output'];
  };

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCartAttributeArgs = {
  key: Scalars['String']['input'];
};

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCartDeliveryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  withCarrierRates?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCartLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCartMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type ShopifyGenCartMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** A delivery address of the buyer that is interacting with the cart. */
export type ShopifyGenCartAddress = ShopifyGenCartDeliveryAddress;

/** The input fields to provide exactly one of a variety of delivery address types. */
export type ShopifyGenCartAddressInput = {
  /** Copies details from the customer address to an address on this cart. */
  copyFromCustomerAddressId?: InputMaybe<Scalars['ID']['input']>;
  /** A delivery address stored on this cart. */
  deliveryAddress?: InputMaybe<ShopifyGenCartDeliveryAddressInput>;
};

/** Return type for `cartAttributesUpdate` mutation. */
export type ShopifyGenCartAttributesUpdatePayload = {
  __typename?: 'CartAttributesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** The discounts automatically applied to the cart line based on prerequisites that have been met. */
export type ShopifyGenCartAutomaticDiscountAllocation =
  ShopifyGenCartDiscountAllocation & {
    __typename?: 'CartAutomaticDiscountAllocation';
    /** The discount that have been applied on the cart line. */
    discountApplication: ShopifyGenCartDiscountApplication;
    /** The discounted amount that has been applied to the cart line. */
    discountedAmount: ShopifyGenMoneyV2;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The title of the allocated discount. */
    title: Scalars['String']['output'];
  };

/** Return type for `cartBillingAddressUpdate` mutation. */
export type ShopifyGenCartBillingAddressUpdatePayload = {
  __typename?: 'CartBillingAddressUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Represents information about the buyer that is interacting with the cart. */
export type ShopifyGenCartBuyerIdentity = {
  __typename?: 'CartBuyerIdentity';
  /** The country where the buyer is located. */
  countryCode?: Maybe<ShopifyGenCountryCode>;
  /** The customer account associated with the cart. */
  customer?: Maybe<ShopifyGenCustomer>;
  /**
   * An ordered set of delivery addresses tied to the buyer that is interacting with the cart.
   * The rank of the preferences is determined by the order of the addresses in the array. Preferences
   * can be used to populate relevant fields in the checkout flow.
   *
   * As of the `2025-01` release, `buyerIdentity.deliveryAddressPreferences` is deprecated.
   * Delivery addresses are now part of the `CartDelivery` object and managed with three new mutations:
   * - `cartDeliveryAddressAdd`
   * - `cartDeliveryAddressUpdate`
   * - `cartDeliveryAddressDelete`
   *
   * @deprecated Use `cart.delivery` instead.
   */
  deliveryAddressPreferences: Array<ShopifyGenDeliveryAddress>;
  /** The email address of the buyer that's interacting with the cart. */
  email?: Maybe<Scalars['String']['output']>;
  /** The phone number of the buyer that's interacting with the cart. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection.
   * Preferences are not synced back to the cart if they are overwritten.
   *
   */
  preferences?: Maybe<ShopifyGenCartPreferences>;
  /** The purchasing company associated with the cart. */
  purchasingCompany?: Maybe<ShopifyGenPurchasingCompany>;
};

/**
 * Specifies the input fields to update the buyer information associated with a cart.
 * Buyer identity is used to determine
 * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * and should match the customer's shipping address.
 *
 */
export type ShopifyGenCartBuyerIdentityInput = {
  /** The company location of the buyer that is interacting with the cart. */
  companyLocationId?: InputMaybe<Scalars['ID']['input']>;
  /** The country where the buyer is located. */
  countryCode?: InputMaybe<ShopifyGenCountryCode>;
  /** The access token used to identify the customer associated with the cart. */
  customerAccessToken?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the buyer that is interacting with the cart. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the buyer that is interacting with the cart. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection.
   * Preferences are not synced back to the cart if they are overwritten.
   *
   */
  preferences?: InputMaybe<ShopifyGenCartPreferencesInput>;
};

/** Return type for `cartBuyerIdentityUpdate` mutation. */
export type ShopifyGenCartBuyerIdentityUpdatePayload = {
  __typename?: 'CartBuyerIdentityUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/**
 * Represents how credit card details are provided for a direct payment.
 *
 */
export enum ShopifyGenCartCardSource {
  /**
   * The credit card was provided by a third party and vaulted on their system.
   * Using this value requires a separate permission from Shopify.
   *
   */
  SavedCreditCard = 'SAVED_CREDIT_CARD',
}

/** The discount that has been applied to the cart line using a discount code. */
export type ShopifyGenCartCodeDiscountAllocation =
  ShopifyGenCartDiscountAllocation & {
    __typename?: 'CartCodeDiscountAllocation';
    /** The code used to apply the discount. */
    code: Scalars['String']['output'];
    /** The discount that have been applied on the cart line. */
    discountApplication: ShopifyGenCartDiscountApplication;
    /** The discounted amount that has been applied to the cart line. */
    discountedAmount: ShopifyGenMoneyV2;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
  };

/** The completion action to checkout a cart. */
export type ShopifyGenCartCompletionAction = ShopifyGenCompletePaymentChallenge;

/** The required completion action to checkout a cart. */
export type ShopifyGenCartCompletionActionRequired = {
  __typename?: 'CartCompletionActionRequired';
  /** The action required to complete the cart completion attempt. */
  action?: Maybe<ShopifyGenCartCompletionAction>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
};

/** The result of a cart completion attempt. */
export type ShopifyGenCartCompletionAttemptResult =
  | ShopifyGenCartCompletionActionRequired
  | ShopifyGenCartCompletionFailed
  | ShopifyGenCartCompletionProcessing
  | ShopifyGenCartCompletionSuccess;

/** A failed completion to checkout a cart. */
export type ShopifyGenCartCompletionFailed = {
  __typename?: 'CartCompletionFailed';
  /** The errors that caused the checkout to fail. */
  errors: Array<ShopifyGenCompletionError>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
};

/** A cart checkout completion that's still processing. */
export type ShopifyGenCartCompletionProcessing = {
  __typename?: 'CartCompletionProcessing';
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
  /** The number of milliseconds to wait before polling again. */
  pollDelay: Scalars['Int']['output'];
};

/** A successful completion to checkout a cart and a created order. */
export type ShopifyGenCartCompletionSuccess = {
  __typename?: 'CartCompletionSuccess';
  /** The date and time when the job completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
  /** The ID of the order that's created in Shopify. */
  orderId: Scalars['ID']['output'];
  /** The URL of the order confirmation in Shopify. */
  orderUrl: Scalars['URL']['output'];
};

/**
 * The costs that the buyer will pay at checkout.
 * The cart cost uses [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity) to determine
 * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
 *
 */
export type ShopifyGenCartCost = {
  __typename?: 'CartCost';
  /** The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to `subtotalAmount`. */
  checkoutChargeAmount: ShopifyGenMoneyV2;
  /** The amount, before taxes and cart-level discounts, for the customer to pay. */
  subtotalAmount: ShopifyGenMoneyV2;
  /** Whether the subtotal amount is estimated. */
  subtotalAmountEstimated: Scalars['Boolean']['output'];
  /** The total amount for the customer to pay. */
  totalAmount: ShopifyGenMoneyV2;
  /** Whether the total amount is estimated. */
  totalAmountEstimated: Scalars['Boolean']['output'];
  /**
   * The duty amount for the customer to pay at checkout.
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalDutyAmount?: Maybe<ShopifyGenMoneyV2>;
  /**
   * Whether the total duty amount is estimated.
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalDutyAmountEstimated: Scalars['Boolean']['output'];
  /**
   * The tax amount for the customer to pay at checkout.
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalTaxAmount?: Maybe<ShopifyGenMoneyV2>;
  /**
   * Whether the total tax amount is estimated.
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalTaxAmountEstimated: Scalars['Boolean']['output'];
};

/** Return type for `cartCreate` mutation. */
export type ShopifyGenCartCreatePayload = {
  __typename?: 'CartCreatePayload';
  /** The new cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** The discounts automatically applied to the cart line based on prerequisites that have been met. */
export type ShopifyGenCartCustomDiscountAllocation =
  ShopifyGenCartDiscountAllocation & {
    __typename?: 'CartCustomDiscountAllocation';
    /** The discount that have been applied on the cart line. */
    discountApplication: ShopifyGenCartDiscountApplication;
    /** The discounted amount that has been applied to the cart line. */
    discountedAmount: ShopifyGenMoneyV2;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The title of the allocated discount. */
    title: Scalars['String']['output'];
  };

/**
 * The delivery properties of the cart.
 *
 */
export type ShopifyGenCartDelivery = {
  __typename?: 'CartDelivery';
  /** Selectable addresses to present to the buyer on the cart. */
  addresses: Array<ShopifyGenCartSelectableAddress>;
};

/**
 * The delivery properties of the cart.
 *
 */
export type ShopifyGenCartDeliveryAddressesArgs = {
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a mailing address for customers and shipping. */
export type ShopifyGenCartDeliveryAddress = {
  __typename?: 'CartDeliveryAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the customer's company or organization. */
  company?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   *
   */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address, customized by the provided arguments. */
  formatted: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** The last name of the customer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the customer address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the customer address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The full name of the customer, based on firstName and lastName. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   *
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Represents a mailing address for customers and shipping. */
export type ShopifyGenCartDeliveryAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']['input']>;
  withName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields to create or update a cart address. */
export type ShopifyGenCartDeliveryAddressInput = {
  /**
   * The first line of the address. Typically the street address or PO Box number.
   *
   */
  address1?: InputMaybe<Scalars['String']['input']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the city, district, village, or town.
   *
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the customer's company or organization.
   *
   */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The name of the country. */
  countryCode?: InputMaybe<ShopifyGenCountryCode>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The region of the address, such as the province, state, or district. */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `cartDeliveryAddressesAdd` mutation. */
export type ShopifyGenCartDeliveryAddressesAddPayload = {
  __typename?: 'CartDeliveryAddressesAddPayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Return type for `cartDeliveryAddressesRemove` mutation. */
export type ShopifyGenCartDeliveryAddressesRemovePayload = {
  __typename?: 'CartDeliveryAddressesRemovePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Return type for `cartDeliveryAddressesUpdate` mutation. */
export type ShopifyGenCartDeliveryAddressesUpdatePayload = {
  __typename?: 'CartDeliveryAddressesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Preferred location used to find the closest pick up point based on coordinates. */
export type ShopifyGenCartDeliveryCoordinatesPreference = {
  __typename?: 'CartDeliveryCoordinatesPreference';
  /**
   * The two-letter code for the country of the preferred location.
   *
   * For example, US.
   *
   */
  countryCode: ShopifyGenCountryCode;
  /** The geographic latitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points. */
  latitude: Scalars['Float']['output'];
  /** The geographic longitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points. */
  longitude: Scalars['Float']['output'];
};

/** Preferred location used to find the closest pick up point based on coordinates. */
export type ShopifyGenCartDeliveryCoordinatesPreferenceInput = {
  /**
   * The two-letter code for the country of the preferred location.
   *
   * For example, US.
   *
   */
  countryCode: ShopifyGenCountryCode;
  /** The geographic latitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points. */
  latitude: Scalars['Float']['input'];
  /** The geographic longitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points. */
  longitude: Scalars['Float']['input'];
};

/** Information about the options available for one or more line items to be delivered to a specific address. */
export type ShopifyGenCartDeliveryGroup = {
  __typename?: 'CartDeliveryGroup';
  /** A list of cart lines for the delivery group. */
  cartLines: ShopifyGenBaseCartLineConnection;
  /** The destination address for the delivery group. */
  deliveryAddress: ShopifyGenMailingAddress;
  /** The delivery options available for the delivery group. */
  deliveryOptions: Array<ShopifyGenCartDeliveryOption>;
  /** The type of merchandise in the delivery group. */
  groupType: ShopifyGenCartDeliveryGroupType;
  /** The ID for the delivery group. */
  id: Scalars['ID']['output'];
  /** The selected delivery option for the delivery group. */
  selectedDeliveryOption?: Maybe<ShopifyGenCartDeliveryOption>;
};

/** Information about the options available for one or more line items to be delivered to a specific address. */
export type ShopifyGenCartDeliveryGroupCartLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple CartDeliveryGroups.
 *
 */
export type ShopifyGenCartDeliveryGroupConnection = {
  __typename?: 'CartDeliveryGroupConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenCartDeliveryGroupEdge>;
  /** A list of the nodes contained in CartDeliveryGroupEdge. */
  nodes: Array<ShopifyGenCartDeliveryGroup>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one CartDeliveryGroup and a cursor during pagination.
 *
 */
export type ShopifyGenCartDeliveryGroupEdge = {
  __typename?: 'CartDeliveryGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CartDeliveryGroupEdge. */
  node: ShopifyGenCartDeliveryGroup;
};

/**
 * Defines what type of merchandise is in the delivery group.
 *
 */
export enum ShopifyGenCartDeliveryGroupType {
  /**
   * The delivery group only contains merchandise that is either a one time purchase or a first delivery of
   * subscription merchandise.
   *
   */
  OneTimePurchase = 'ONE_TIME_PURCHASE',
  /** The delivery group only contains subscription merchandise. */
  Subscription = 'SUBSCRIPTION',
}

/** The input fields for the cart's delivery properties. */
export type ShopifyGenCartDeliveryInput = {
  /**
   * Selectable addresses to present to the buyer on the cart.
   *
   * The input must not contain more than `250` values.
   */
  addresses?: InputMaybe<Array<ShopifyGenCartSelectableAddressInput>>;
};

/** Information about a delivery option. */
export type ShopifyGenCartDeliveryOption = {
  __typename?: 'CartDeliveryOption';
  /** The code of the delivery option. */
  code?: Maybe<Scalars['String']['output']>;
  /** The method for the delivery option. */
  deliveryMethodType: ShopifyGenDeliveryMethodType;
  /** The description of the delivery option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The estimated cost for the delivery option. */
  estimatedCost: ShopifyGenMoneyV2;
  /** The unique identifier of the delivery option. */
  handle: Scalars['String']['output'];
  /** The title of the delivery option. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection.
 * Preferences are not synced back to the cart if they are overwritten.
 *
 */
export type ShopifyGenCartDeliveryPreference = {
  __typename?: 'CartDeliveryPreference';
  /** Preferred location used to find the closest pick up point based on coordinates. */
  coordinates?: Maybe<ShopifyGenCartDeliveryCoordinatesPreference>;
  /** The preferred delivery methods such as shipping, local pickup or through pickup points. */
  deliveryMethod: Array<ShopifyGenPreferenceDeliveryMethodType>;
  /**
   * The pickup handle prefills checkout fields with the location for either local pickup or pickup points delivery methods.
   * It accepts both location ID for local pickup and external IDs for pickup points.
   *
   */
  pickupHandle: Array<Scalars['String']['output']>;
};

/** Delivery preferences can be used to prefill the delivery section at checkout. */
export type ShopifyGenCartDeliveryPreferenceInput = {
  /** The coordinates of a delivery location in order of preference. */
  coordinates?: InputMaybe<ShopifyGenCartDeliveryCoordinatesPreferenceInput>;
  /**
   * The preferred delivery methods such as shipping, local pickup or through pickup points.
   *
   * The input must not contain more than `250` values.
   */
  deliveryMethod?: InputMaybe<Array<ShopifyGenPreferenceDeliveryMethodType>>;
  /**
   * The pickup handle prefills checkout fields with the location for either local pickup or pickup points delivery methods.
   * It accepts both location ID for local pickup and external IDs for pickup points.
   *
   * The input must not contain more than `250` values.
   */
  pickupHandle?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * The input fields for submitting direct payment method information for checkout.
 *
 */
export type ShopifyGenCartDirectPaymentMethodInput = {
  /** Indicates if the customer has accepted the subscription terms. Defaults to false. */
  acceptedSubscriptionTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's billing address. */
  billingAddress: ShopifyGenMailingAddressInput;
  /** The source of the credit card payment. */
  cardSource?: InputMaybe<ShopifyGenCartCardSource>;
  /** The session ID for the direct payment method used to create the payment. */
  sessionId: Scalars['String']['input'];
};

/** The discounts that have been applied to the cart line. */
export type ShopifyGenCartDiscountAllocation = {
  /** The discount that have been applied on the cart line. */
  discountApplication: ShopifyGenCartDiscountApplication;
  /** The discounted amount that has been applied to the cart line. */
  discountedAmount: ShopifyGenMoneyV2;
  /** The type of line that the discount is applicable towards. */
  targetType: ShopifyGenDiscountApplicationTargetType;
};

/**
 * The discount application capture the intentions of a discount source at
 *         the time of application.
 */
export type ShopifyGenCartDiscountApplication = {
  __typename?: 'CartDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: ShopifyGenDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: ShopifyGenDiscountApplicationTargetType;
  /** The value of the discount application. */
  value: ShopifyGenPricingValue;
};

/** The discount codes applied to the cart. */
export type ShopifyGenCartDiscountCode = {
  __typename?: 'CartDiscountCode';
  /** Whether the discount code is applicable to the cart's current contents. */
  applicable: Scalars['Boolean']['output'];
  /** The code for the discount. */
  code: Scalars['String']['output'];
};

/** Return type for `cartDiscountCodesUpdate` mutation. */
export type ShopifyGenCartDiscountCodesUpdatePayload = {
  __typename?: 'CartDiscountCodesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Possible error codes that can be returned by `CartUserError`. */
export enum ShopifyGenCartErrorCode {
  /** The specified address field contains emojis. */
  AddressFieldContainsEmojis = 'ADDRESS_FIELD_CONTAINS_EMOJIS',
  /** The specified address field contains HTML tags. */
  AddressFieldContainsHtmlTags = 'ADDRESS_FIELD_CONTAINS_HTML_TAGS',
  /** The specified address field contains a URL. */
  AddressFieldContainsUrl = 'ADDRESS_FIELD_CONTAINS_URL',
  /** The specified address field does not match the expected pattern. */
  AddressFieldDoesNotMatchExpectedPattern = 'ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN',
  /** The specified address field is required. */
  AddressFieldIsRequired = 'ADDRESS_FIELD_IS_REQUIRED',
  /** The specified address field is too long. */
  AddressFieldIsTooLong = 'ADDRESS_FIELD_IS_TOO_LONG',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Company location not found or not allowed. */
  InvalidCompanyLocation = 'INVALID_COMPANY_LOCATION',
  /** The delivery address was not found. */
  InvalidDeliveryAddressId = 'INVALID_DELIVERY_ADDRESS_ID',
  /** Delivery group was not found in cart. */
  InvalidDeliveryGroup = 'INVALID_DELIVERY_GROUP',
  /** Delivery option was not valid. */
  InvalidDeliveryOption = 'INVALID_DELIVERY_OPTION',
  /** The quantity must be a multiple of the specified increment. */
  InvalidIncrement = 'INVALID_INCREMENT',
  /** Merchandise line was not found in cart. */
  InvalidMerchandiseLine = 'INVALID_MERCHANDISE_LINE',
  /** The metafields were not valid. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** The payment wasn't valid. */
  InvalidPayment = 'INVALID_PAYMENT',
  /** Cannot update payment on an empty cart */
  InvalidPaymentEmptyCart = 'INVALID_PAYMENT_EMPTY_CART',
  /** The given zip code is invalid for the provided country. */
  InvalidZipCodeForCountry = 'INVALID_ZIP_CODE_FOR_COUNTRY',
  /** The given zip code is invalid for the provided province. */
  InvalidZipCodeForProvince = 'INVALID_ZIP_CODE_FOR_PROVINCE',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The quantity must be below the specified maximum for the item. */
  MaximumExceeded = 'MAXIMUM_EXCEEDED',
  /** The quantity must be above the specified minimum for the item. */
  MinimumNotMet = 'MINIMUM_NOT_MET',
  /** The customer access token is required when setting a company location. */
  MissingCustomerAccessToken = 'MISSING_CUSTOMER_ACCESS_TOKEN',
  /** Missing discount code. */
  MissingDiscountCode = 'MISSING_DISCOUNT_CODE',
  /** Missing note. */
  MissingNote = 'MISSING_NOTE',
  /** The note length must be below the specified maximum. */
  NoteTooLong = 'NOTE_TOO_LONG',
  /** Only one delivery address can be selected. */
  OnlyOneDeliveryAddressCanBeSelected = 'ONLY_ONE_DELIVERY_ADDRESS_CAN_BE_SELECTED',
  /** The payment method is not supported. */
  PaymentMethodNotSupported = 'PAYMENT_METHOD_NOT_SUPPORTED',
  /** The given province cannot be found. */
  ProvinceNotFound = 'PROVINCE_NOT_FOUND',
  /** Too many delivery addresses on Cart. */
  TooManyDeliveryAddresses = 'TOO_MANY_DELIVERY_ADDRESSES',
  /** A general error occurred during address validation. */
  UnspecifiedAddressError = 'UNSPECIFIED_ADDRESS_ERROR',
  /** Validation failed. */
  ValidationCustom = 'VALIDATION_CUSTOM',
  /** The given zip code is unsupported. */
  ZipCodeNotSupported = 'ZIP_CODE_NOT_SUPPORTED',
}

/** The estimated costs that the buyer will pay at checkout. The estimated cost uses [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity) to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing). */
export type ShopifyGenCartEstimatedCost = {
  __typename?: 'CartEstimatedCost';
  /** The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to`subtotal_amount`. */
  checkoutChargeAmount: ShopifyGenMoneyV2;
  /** The estimated amount, before taxes and discounts, for the customer to pay. */
  subtotalAmount: ShopifyGenMoneyV2;
  /** The estimated total amount for the customer to pay. */
  totalAmount: ShopifyGenMoneyV2;
  /** The estimated duty amount for the customer to pay at checkout. */
  totalDutyAmount?: Maybe<ShopifyGenMoneyV2>;
  /** The estimated tax amount for the customer to pay at checkout. */
  totalTaxAmount?: Maybe<ShopifyGenMoneyV2>;
};

/**
 * The input fields for submitting a billing address without a selected payment method.
 *
 */
export type ShopifyGenCartFreePaymentMethodInput = {
  /** The customer's billing address. */
  billingAddress: ShopifyGenMailingAddressInput;
};

/** Return type for `cartGiftCardCodesRemove` mutation. */
export type ShopifyGenCartGiftCardCodesRemovePayload = {
  __typename?: 'CartGiftCardCodesRemovePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Return type for `cartGiftCardCodesUpdate` mutation. */
export type ShopifyGenCartGiftCardCodesUpdatePayload = {
  __typename?: 'CartGiftCardCodesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** The input fields to create a cart. */
export type ShopifyGenCartInput = {
  /**
   * An array of key-value pairs that contains additional information about the cart.
   *
   * The input must not contain more than `250` values.
   */
  attributes?: InputMaybe<Array<ShopifyGenAttributeInput>>;
  /**
   * The customer associated with the cart. Used to determine [international pricing]
   * (https://shopify.dev/custom-storefronts/internationalization/international-pricing).
   * Buyer identity should match the customer's shipping address.
   *
   */
  buyerIdentity?: InputMaybe<ShopifyGenCartBuyerIdentityInput>;
  /** The delivery-related fields for the cart. */
  delivery?: InputMaybe<ShopifyGenCartDeliveryInput>;
  /**
   * The case-insensitive discount codes that the customer added at checkout.
   *
   * The input must not contain more than `250` values.
   */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The case-insensitive gift card codes.
   *
   * The input must not contain more than `250` values.
   */
  giftCardCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * A list of merchandise lines to add to the cart.
   *
   * The input must not contain more than `250` values.
   */
  lines?: InputMaybe<Array<ShopifyGenCartLineInput>>;
  /**
   * The metafields to associate with this cart.
   *
   * The input must not contain more than `250` values.
   */
  metafields?: InputMaybe<Array<ShopifyGenCartInputMetafieldInput>>;
  /**
   * A note that's associated with the cart. For example, the note can be a personalized message to the buyer.
   *
   */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for a cart metafield value to set. */
export type ShopifyGenCartInputMetafieldInput = {
  /** The key name of the metafield. */
  key: Scalars['String']['input'];
  /**
   * The type of data that the cart metafield stores.
   * The type of data must be a [supported type](https://shopify.dev/apps/metafields/types).
   *
   */
  type: Scalars['String']['input'];
  /**
   * The data to store in the cart metafield. The data is always stored as a string, regardless of the metafield's type.
   *
   */
  value: Scalars['String']['input'];
};

/** Represents information about the merchandise in the cart. */
export type ShopifyGenCartLine = ShopifyGenBaseCartLine &
  ShopifyGenNode & {
    __typename?: 'CartLine';
    /** An attribute associated with the cart line. */
    attribute?: Maybe<ShopifyGenAttribute>;
    /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
    attributes: Array<ShopifyGenAttribute>;
    /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
    cost: ShopifyGenCartLineCost;
    /** The discounts that have been applied to the cart line. */
    discountAllocations: Array<ShopifyGenCartDiscountAllocation>;
    /**
     * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
     * @deprecated Use `cost` instead.
     */
    estimatedCost: ShopifyGenCartLineEstimatedCost;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The merchandise that the buyer intends to purchase. */
    merchandise: ShopifyGenMerchandise;
    /** The quantity of the merchandise that the customer intends to purchase. */
    quantity: Scalars['Int']['output'];
    /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
    sellingPlanAllocation?: Maybe<ShopifyGenSellingPlanAllocation>;
  };

/** Represents information about the merchandise in the cart. */
export type ShopifyGenCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/** The cost of the merchandise line that the buyer will pay at checkout. */
export type ShopifyGenCartLineCost = {
  __typename?: 'CartLineCost';
  /** The amount of the merchandise line. */
  amountPerQuantity: ShopifyGenMoneyV2;
  /** The compare at amount of the merchandise line. */
  compareAtAmountPerQuantity?: Maybe<ShopifyGenMoneyV2>;
  /** The cost of the merchandise line before line-level discounts. */
  subtotalAmount: ShopifyGenMoneyV2;
  /** The total cost of the merchandise line. */
  totalAmount: ShopifyGenMoneyV2;
};

/**
 * The estimated cost of the merchandise line that the buyer will pay at checkout.
 *
 */
export type ShopifyGenCartLineEstimatedCost = {
  __typename?: 'CartLineEstimatedCost';
  /** The amount of the merchandise line. */
  amount: ShopifyGenMoneyV2;
  /** The compare at amount of the merchandise line. */
  compareAtAmount?: Maybe<ShopifyGenMoneyV2>;
  /** The estimated cost of the merchandise line before discounts. */
  subtotalAmount: ShopifyGenMoneyV2;
  /** The estimated total cost of the merchandise line. */
  totalAmount: ShopifyGenMoneyV2;
};

/** The input fields to create a merchandise line on a cart. */
export type ShopifyGenCartLineInput = {
  /**
   * An array of key-value pairs that contains additional information about the merchandise line.
   *
   * The input must not contain more than `250` values.
   */
  attributes?: InputMaybe<Array<ShopifyGenAttributeInput>>;
  /** The ID of the merchandise that the buyer intends to purchase. */
  merchandiseId: Scalars['ID']['input'];
  /** The quantity of the merchandise. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the selling plan that the merchandise is being purchased with. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields to update a line item on a cart. */
export type ShopifyGenCartLineUpdateInput = {
  /**
   * An array of key-value pairs that contains additional information about the merchandise line.
   *
   * The input must not contain more than `250` values.
   */
  attributes?: InputMaybe<Array<ShopifyGenAttributeInput>>;
  /** The ID of the merchandise line. */
  id: Scalars['ID']['input'];
  /** The ID of the merchandise for the line item. */
  merchandiseId?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the line item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the selling plan that the merchandise is being purchased with. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `cartLinesAdd` mutation. */
export type ShopifyGenCartLinesAddPayload = {
  __typename?: 'CartLinesAddPayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Return type for `cartLinesRemove` mutation. */
export type ShopifyGenCartLinesRemovePayload = {
  __typename?: 'CartLinesRemovePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Return type for `cartLinesUpdate` mutation. */
export type ShopifyGenCartLinesUpdatePayload = {
  __typename?: 'CartLinesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** The input fields to delete a cart metafield. */
export type ShopifyGenCartMetafieldDeleteInput = {
  /**
   * The key name of the cart metafield. Can either be a composite key (`namespace.key`) or a simple key
   *  that relies on the default app-reserved namespace.
   *
   */
  key: Scalars['String']['input'];
  /** The ID of the cart resource. */
  ownerId: Scalars['ID']['input'];
};

/** Return type for `cartMetafieldDelete` mutation. */
export type ShopifyGenCartMetafieldDeletePayload = {
  __typename?: 'CartMetafieldDeletePayload';
  /** The ID of the deleted cart metafield. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenMetafieldDeleteUserError>;
};

/** The input fields for a cart metafield value to set. */
export type ShopifyGenCartMetafieldsSetInput = {
  /** The key name of the cart metafield. */
  key: Scalars['String']['input'];
  /** The ID of the cart resource. */
  ownerId: Scalars['ID']['input'];
  /**
   * The type of data that the cart metafield stores.
   * The type of data must be a [supported type](https://shopify.dev/apps/metafields/types).
   *
   */
  type: Scalars['String']['input'];
  /**
   * The data to store in the cart metafield. The data is always stored as a string, regardless of the metafield's type.
   *
   */
  value: Scalars['String']['input'];
};

/** Return type for `cartMetafieldsSet` mutation. */
export type ShopifyGenCartMetafieldsSetPayload = {
  __typename?: 'CartMetafieldsSetPayload';
  /** The list of cart metafields that were set. */
  metafields?: Maybe<Array<ShopifyGenMetafield>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenMetafieldsSetUserError>;
};

/** Return type for `cartNoteUpdate` mutation. */
export type ShopifyGenCartNoteUpdatePayload = {
  __typename?: 'CartNoteUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** An error occurred during the cart operation. */
export type ShopifyGenCartOperationError = {
  __typename?: 'CartOperationError';
  /** The error code. */
  code: Scalars['String']['output'];
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * The input fields for updating the payment method that will be used to checkout.
 *
 */
export type ShopifyGenCartPaymentInput = {
  /** The amount that the customer will be charged at checkout. */
  amount: ShopifyGenMoneyInput;
  /**
   * The input fields to use when checking out a cart with a direct payment method (like a credit card).
   *
   */
  directPaymentMethod?: InputMaybe<ShopifyGenCartDirectPaymentMethodInput>;
  /**
   * The input fields to use to checkout a cart without providing a payment method.
   * Use this payment method input if the total cost of the cart is 0.
   *
   */
  freePaymentMethod?: InputMaybe<ShopifyGenCartFreePaymentMethodInput>;
  /**
   * An ID of the order placed on the originating platform.
   * Note that this value doesn't correspond to the Shopify Order ID.
   *
   */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * The input fields to use when checking out a cart with a wallet payment method (like Shop Pay or Apple Pay).
   *
   */
  walletPaymentMethod?: InputMaybe<ShopifyGenCartWalletPaymentMethodInput>;
};

/** Return type for `cartPaymentUpdate` mutation. */
export type ShopifyGenCartPaymentUpdatePayload = {
  __typename?: 'CartPaymentUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/**
 * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection.
 * Preferences are not synced back to the cart if they are overwritten.
 *
 */
export type ShopifyGenCartPreferences = {
  __typename?: 'CartPreferences';
  /** Delivery preferences can be used to prefill the delivery section in at checkout. */
  delivery?: Maybe<ShopifyGenCartDeliveryPreference>;
  /**
   * Wallet preferences are used to populate relevant payment fields in the checkout flow.
   * Accepted value: `["shop_pay"]`.
   *
   */
  wallet?: Maybe<Array<Scalars['String']['output']>>;
};

/** The input fields represent preferences for the buyer that is interacting with the cart. */
export type ShopifyGenCartPreferencesInput = {
  /** Delivery preferences can be used to prefill the delivery section in at checkout. */
  delivery?: InputMaybe<ShopifyGenCartDeliveryPreferenceInput>;
  /**
   * Wallet preferences are used to populate relevant payment fields in the checkout flow.
   * Accepted value: `["shop_pay"]`.
   *
   * The input must not contain more than `250` values.
   */
  wallet?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `cartPrepareForCompletion` mutation. */
export type ShopifyGenCartPrepareForCompletionPayload = {
  __typename?: 'CartPrepareForCompletionPayload';
  /** The result of cart preparation for completion. */
  result?: Maybe<ShopifyGenCartPrepareForCompletionResult>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
};

/** The result of cart preparation. */
export type ShopifyGenCartPrepareForCompletionResult =
  | ShopifyGenCartStatusNotReady
  | ShopifyGenCartStatusReady
  | ShopifyGenCartThrottled;

/**
 * A selectable delivery address for a cart.
 *
 */
export type ShopifyGenCartSelectableAddress = {
  __typename?: 'CartSelectableAddress';
  /** The delivery address. */
  address: ShopifyGenCartAddress;
  /** A unique identifier for the address, specific to this cart. */
  id: Scalars['ID']['output'];
  /** This delivery address will not be associated with the buyer after a successful checkout. */
  oneTimeUse: Scalars['Boolean']['output'];
  /** Sets exactly one address as pre-selected for the buyer. */
  selected: Scalars['Boolean']['output'];
};

/** The input fields for a selectable delivery address in a cart. */
export type ShopifyGenCartSelectableAddressInput = {
  /** Exactly one kind of delivery address. */
  address: ShopifyGenCartAddressInput;
  /** When true, this delivery address will not be associated with the buyer after a successful checkout. */
  oneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sets exactly one address as pre-selected for the buyer. */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines what kind of address validation is requested. */
  validationStrategy?: InputMaybe<ShopifyGenDeliveryAddressValidationStrategy>;
};

/** The input fields to update a line item on a cart. */
export type ShopifyGenCartSelectableAddressUpdateInput = {
  /** Exactly one kind of delivery address. */
  address?: InputMaybe<ShopifyGenCartAddressInput>;
  /** The id of the selectable address. */
  id: Scalars['ID']['input'];
  /** When true, this delivery address will not be associated with the buyer after a successful checkout. */
  oneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sets exactly one address as pre-selected for the buyer. */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines what kind of address validation is requested. */
  validationStrategy?: InputMaybe<ShopifyGenDeliveryAddressValidationStrategy>;
};

/**
 * The input fields for updating the selected delivery options for a delivery group.
 *
 */
export type ShopifyGenCartSelectedDeliveryOptionInput = {
  /** The ID of the cart delivery group. */
  deliveryGroupId: Scalars['ID']['input'];
  /** The handle of the selected delivery option. */
  deliveryOptionHandle: Scalars['String']['input'];
};

/** Return type for `cartSelectedDeliveryOptionsUpdate` mutation. */
export type ShopifyGenCartSelectedDeliveryOptionsUpdatePayload = {
  __typename?: 'CartSelectedDeliveryOptionsUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
  /** A list of warnings that occurred during the mutation. */
  warnings: Array<ShopifyGenCartWarning>;
};

/** Cart is not ready for payment update and completion. */
export type ShopifyGenCartStatusNotReady = {
  __typename?: 'CartStatusNotReady';
  /** The result of cart preparation for completion. */
  cart?: Maybe<ShopifyGenCart>;
  /** The list of errors that caused the cart to not be ready for payment update and completion. */
  errors: Array<ShopifyGenCartOperationError>;
};

/** Cart is ready for payment update and completion. */
export type ShopifyGenCartStatusReady = {
  __typename?: 'CartStatusReady';
  /** The result of cart preparation for completion. */
  cart?: Maybe<ShopifyGenCart>;
};

/** Return type for `cartSubmitForCompletion` mutation. */
export type ShopifyGenCartSubmitForCompletionPayload = {
  __typename?: 'CartSubmitForCompletionPayload';
  /** The result of cart submission for completion. */
  result?: Maybe<ShopifyGenCartSubmitForCompletionResult>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenCartUserError>;
};

/** The result of cart submit completion. */
export type ShopifyGenCartSubmitForCompletionResult =
  | ShopifyGenSubmitAlreadyAccepted
  | ShopifyGenSubmitFailed
  | ShopifyGenSubmitSuccess
  | ShopifyGenSubmitThrottled;

/**
 * Response signifying that the access to cart request is currently being throttled.
 * The client can retry after `poll_after`.
 *
 */
export type ShopifyGenCartThrottled = {
  __typename?: 'CartThrottled';
  /** The polling delay. */
  pollAfter: Scalars['DateTime']['output'];
};

/** Represents an error that happens during execution of a cart mutation. */
export type ShopifyGenCartUserError = ShopifyGenDisplayableError & {
  __typename?: 'CartUserError';
  /** The error code. */
  code?: Maybe<ShopifyGenCartErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * The input fields for submitting wallet payment method information for checkout.
 *
 */
export type ShopifyGenCartWalletPaymentMethodInput = {
  /** The payment method information for the Apple Pay wallet. */
  applePayWalletContent?: InputMaybe<ShopifyGenApplePayWalletContentInput>;
  /** The payment method information for the Shop Pay wallet. */
  shopPayWalletContent?: InputMaybe<ShopifyGenShopPayWalletContentInput>;
};

/** A warning that occurred during a cart mutation. */
export type ShopifyGenCartWarning = {
  __typename?: 'CartWarning';
  /** The code of the warning. */
  code: ShopifyGenCartWarningCode;
  /** The message text of the warning. */
  message: Scalars['String']['output'];
  /** The target of the warning. */
  target: Scalars['ID']['output'];
};

/** The code for the cart warning. */
export enum ShopifyGenCartWarningCode {
  /** A delivery address with the same details already exists on this cart. */
  DuplicateDeliveryAddress = 'DUPLICATE_DELIVERY_ADDRESS',
  /** The merchandise does not have enough stock. */
  MerchandiseNotEnoughStock = 'MERCHANDISE_NOT_ENOUGH_STOCK',
  /** The merchandise is out of stock. */
  MerchandiseOutOfStock = 'MERCHANDISE_OUT_OF_STOCK',
  /** Gift cards are not available as a payment method. */
  PaymentsGiftCardsUnavailable = 'PAYMENTS_GIFT_CARDS_UNAVAILABLE',
}

/**
 * A filter used to view a subset of products in a collection matching a specific category value.
 *
 */
export type ShopifyGenCategoryFilter = {
  /** The id of the category to filter on. */
  id: Scalars['String']['input'];
};

/**
 * A collection represents a grouping of products that a shop owner can create to
 * organize them or make their shops easier to browse.
 *
 */
export type ShopifyGenCollection = ShopifyGenHasMetafields &
  ShopifyGenNode &
  ShopifyGenOnlineStorePublishable &
  ShopifyGenTrackable & {
    __typename?: 'Collection';
    /** Stripped description of the collection, single line with HTML tags removed. */
    description: Scalars['String']['output'];
    /** The description of the collection, complete with HTML formatting. */
    descriptionHtml: Scalars['HTML']['output'];
    /**
     * A human-friendly unique string for the collection automatically generated from its title.
     * Limit of 255 characters.
     *
     */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** Image associated with the collection. */
    image?: Maybe<ShopifyGenImage>;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /** List of products in the collection. */
    products: ShopifyGenProductConnection;
    /** The collection's SEO information. */
    seo: ShopifyGenSeo;
    /** The collection’s name. Limit of 255 characters. */
    title: Scalars['String']['output'];
    /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
    trackingParameters?: Maybe<Scalars['String']['output']>;
    /** The date and time when the collection was last modified. */
    updatedAt: Scalars['DateTime']['output'];
  };

/**
 * A collection represents a grouping of products that a shop owner can create to
 * organize them or make their shops easier to browse.
 *
 */
export type ShopifyGenCollectionDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A collection represents a grouping of products that a shop owner can create to
 * organize them or make their shops easier to browse.
 *
 */
export type ShopifyGenCollectionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A collection represents a grouping of products that a shop owner can create to
 * organize them or make their shops easier to browse.
 *
 */
export type ShopifyGenCollectionMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * A collection represents a grouping of products that a shop owner can create to
 * organize them or make their shops easier to browse.
 *
 */
export type ShopifyGenCollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ShopifyGenProductFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenProductCollectionSortKeys>;
};

/**
 * An auto-generated type for paginating through multiple Collections.
 *
 */
export type ShopifyGenCollectionConnection = {
  __typename?: 'CollectionConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenCollectionEdge>;
  /** A list of the nodes contained in CollectionEdge. */
  nodes: Array<ShopifyGenCollection>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
  /** The total count of Collections. */
  totalCount: Scalars['UnsignedInt64']['output'];
};

/**
 * An auto-generated type which holds one Collection and a cursor during pagination.
 *
 */
export type ShopifyGenCollectionEdge = {
  __typename?: 'CollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionEdge. */
  node: ShopifyGenCollection;
};

/** The set of valid sort keys for the Collection query. */
export enum ShopifyGenCollectionSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
}

/** A comment on an article. */
export type ShopifyGenComment = ShopifyGenNode & {
  __typename?: 'Comment';
  /** The comment’s author. */
  author: ShopifyGenCommentAuthor;
  /** Stripped content of the comment, single line with HTML tags removed. */
  content: Scalars['String']['output'];
  /** The content of the comment, complete with HTML formatting. */
  contentHtml: Scalars['HTML']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** A comment on an article. */
export type ShopifyGenCommentContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/** The author of a comment. */
export type ShopifyGenCommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The author's email. */
  email: Scalars['String']['output'];
  /** The author’s name. */
  name: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple Comments.
 *
 */
export type ShopifyGenCommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenCommentEdge>;
  /** A list of the nodes contained in CommentEdge. */
  nodes: Array<ShopifyGenComment>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Comment and a cursor during pagination.
 *
 */
export type ShopifyGenCommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CommentEdge. */
  node: ShopifyGenComment;
};

/** Represents information about a company which is also a customer of the shop. */
export type ShopifyGenCompany = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Company';
    /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was created in Shopify. */
    createdAt: Scalars['DateTime']['output'];
    /** A unique externally-supplied ID for the company. */
    externalId?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The name of the company. */
    name: Scalars['String']['output'];
    /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was last modified. */
    updatedAt: Scalars['DateTime']['output'];
  };

/** Represents information about a company which is also a customer of the shop. */
export type ShopifyGenCompanyMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Represents information about a company which is also a customer of the shop. */
export type ShopifyGenCompanyMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** A company's main point of contact. */
export type ShopifyGenCompanyContact = ShopifyGenNode & {
  __typename?: 'CompanyContact';
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was created in Shopify. */
  createdAt: Scalars['DateTime']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The company contact's locale (language). */
  locale?: Maybe<Scalars['String']['output']>;
  /** The company contact's job title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was last modified. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A company's location. */
export type ShopifyGenCompanyLocation = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'CompanyLocation';
    /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was created in Shopify. */
    createdAt: Scalars['DateTime']['output'];
    /** A unique externally-supplied ID for the company. */
    externalId?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The preferred locale of the company location. */
    locale?: Maybe<Scalars['String']['output']>;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The name of the company location. */
    name: Scalars['String']['output'];
    /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was last modified. */
    updatedAt: Scalars['DateTime']['output'];
  };

/** A company's location. */
export type ShopifyGenCompanyLocationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** A company's location. */
export type ShopifyGenCompanyLocationMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** The action for the 3DS payment redirect. */
export type ShopifyGenCompletePaymentChallenge = {
  __typename?: 'CompletePaymentChallenge';
  /** The URL for the 3DS payment redirect. */
  redirectUrl?: Maybe<Scalars['URL']['output']>;
};

/** An error that occurred during a cart completion attempt. */
export type ShopifyGenCompletionError = {
  __typename?: 'CompletionError';
  /** The error code. */
  code: ShopifyGenCompletionErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** The code of the error that occurred during a cart completion attempt. */
export enum ShopifyGenCompletionErrorCode {
  Error = 'ERROR',
  InventoryReservationError = 'INVENTORY_RESERVATION_ERROR',
  PaymentAmountTooSmall = 'PAYMENT_AMOUNT_TOO_SMALL',
  PaymentCallIssuer = 'PAYMENT_CALL_ISSUER',
  PaymentCardDeclined = 'PAYMENT_CARD_DECLINED',
  PaymentError = 'PAYMENT_ERROR',
  PaymentGatewayNotEnabledError = 'PAYMENT_GATEWAY_NOT_ENABLED_ERROR',
  PaymentInsufficientFunds = 'PAYMENT_INSUFFICIENT_FUNDS',
  PaymentInvalidBillingAddress = 'PAYMENT_INVALID_BILLING_ADDRESS',
  PaymentInvalidCreditCard = 'PAYMENT_INVALID_CREDIT_CARD',
  PaymentInvalidCurrency = 'PAYMENT_INVALID_CURRENCY',
  PaymentInvalidPaymentMethod = 'PAYMENT_INVALID_PAYMENT_METHOD',
  PaymentTransientError = 'PAYMENT_TRANSIENT_ERROR',
}

/** Represents information about the grouped merchandise in the cart. */
export type ShopifyGenComponentizableCartLine = ShopifyGenBaseCartLine &
  ShopifyGenNode & {
    __typename?: 'ComponentizableCartLine';
    /** An attribute associated with the cart line. */
    attribute?: Maybe<ShopifyGenAttribute>;
    /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
    attributes: Array<ShopifyGenAttribute>;
    /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
    cost: ShopifyGenCartLineCost;
    /** The discounts that have been applied to the cart line. */
    discountAllocations: Array<ShopifyGenCartDiscountAllocation>;
    /**
     * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
     * @deprecated Use `cost` instead.
     */
    estimatedCost: ShopifyGenCartLineEstimatedCost;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The components of the line item. */
    lineComponents: Array<ShopifyGenCartLine>;
    /** The merchandise that the buyer intends to purchase. */
    merchandise: ShopifyGenMerchandise;
    /** The quantity of the merchandise that the customer intends to purchase. */
    quantity: Scalars['Int']['output'];
    /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
    sellingPlanAllocation?: Maybe<ShopifyGenSellingPlanAllocation>;
  };

/** Represents information about the grouped merchandise in the cart. */
export type ShopifyGenComponentizableCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/** Details for count of elements. */
export type ShopifyGenCount = {
  __typename?: 'Count';
  /** Count of elements. */
  count: Scalars['Int']['output'];
  /** Precision of count, how exact is the value. */
  precision: ShopifyGenCountPrecision;
};

/** The precision of the value returned by a count field. */
export enum ShopifyGenCountPrecision {
  /** The count is at least the value. A limit was reached. */
  AtLeast = 'AT_LEAST',
  /** The count is exactly the value. */
  Exact = 'EXACT',
}

/** A country. */
export type ShopifyGenCountry = {
  __typename?: 'Country';
  /** The languages available for the country. */
  availableLanguages: Array<ShopifyGenLanguage>;
  /** The currency of the country. */
  currency: ShopifyGenCurrency;
  /** The ISO code of the country. */
  isoCode: ShopifyGenCountryCode;
  /** The market that includes this country. */
  market?: Maybe<ShopifyGenMarket>;
  /** The name of the country. */
  name: Scalars['String']['output'];
  /** The unit system used in the country. */
  unitSystem: ShopifyGenUnitSystem;
};

/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
 * If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
 * of another country. For example, the territories associated with Spain are represented by the country code `ES`,
 * and the territories associated with the United States of America are represented by the country code `US`.
 *
 */
export enum ShopifyGenCountryCode {
  /** Ascension Island. */
  Ac = 'AC',
  /** Andorra. */
  Ad = 'AD',
  /** United Arab Emirates. */
  Ae = 'AE',
  /** Afghanistan. */
  Af = 'AF',
  /** Antigua & Barbuda. */
  Ag = 'AG',
  /** Anguilla. */
  Ai = 'AI',
  /** Albania. */
  Al = 'AL',
  /** Armenia. */
  Am = 'AM',
  /** Netherlands Antilles. */
  An = 'AN',
  /** Angola. */
  Ao = 'AO',
  /** Argentina. */
  Ar = 'AR',
  /** Austria. */
  At = 'AT',
  /** Australia. */
  Au = 'AU',
  /** Aruba. */
  Aw = 'AW',
  /** Åland Islands. */
  Ax = 'AX',
  /** Azerbaijan. */
  Az = 'AZ',
  /** Bosnia & Herzegovina. */
  Ba = 'BA',
  /** Barbados. */
  Bb = 'BB',
  /** Bangladesh. */
  Bd = 'BD',
  /** Belgium. */
  Be = 'BE',
  /** Burkina Faso. */
  Bf = 'BF',
  /** Bulgaria. */
  Bg = 'BG',
  /** Bahrain. */
  Bh = 'BH',
  /** Burundi. */
  Bi = 'BI',
  /** Benin. */
  Bj = 'BJ',
  /** St. Barthélemy. */
  Bl = 'BL',
  /** Bermuda. */
  Bm = 'BM',
  /** Brunei. */
  Bn = 'BN',
  /** Bolivia. */
  Bo = 'BO',
  /** Caribbean Netherlands. */
  Bq = 'BQ',
  /** Brazil. */
  Br = 'BR',
  /** Bahamas. */
  Bs = 'BS',
  /** Bhutan. */
  Bt = 'BT',
  /** Bouvet Island. */
  Bv = 'BV',
  /** Botswana. */
  Bw = 'BW',
  /** Belarus. */
  By = 'BY',
  /** Belize. */
  Bz = 'BZ',
  /** Canada. */
  Ca = 'CA',
  /** Cocos (Keeling) Islands. */
  Cc = 'CC',
  /** Congo - Kinshasa. */
  Cd = 'CD',
  /** Central African Republic. */
  Cf = 'CF',
  /** Congo - Brazzaville. */
  Cg = 'CG',
  /** Switzerland. */
  Ch = 'CH',
  /** Côte d’Ivoire. */
  Ci = 'CI',
  /** Cook Islands. */
  Ck = 'CK',
  /** Chile. */
  Cl = 'CL',
  /** Cameroon. */
  Cm = 'CM',
  /** China. */
  Cn = 'CN',
  /** Colombia. */
  Co = 'CO',
  /** Costa Rica. */
  Cr = 'CR',
  /** Cuba. */
  Cu = 'CU',
  /** Cape Verde. */
  Cv = 'CV',
  /** Curaçao. */
  Cw = 'CW',
  /** Christmas Island. */
  Cx = 'CX',
  /** Cyprus. */
  Cy = 'CY',
  /** Czechia. */
  Cz = 'CZ',
  /** Germany. */
  De = 'DE',
  /** Djibouti. */
  Dj = 'DJ',
  /** Denmark. */
  Dk = 'DK',
  /** Dominica. */
  Dm = 'DM',
  /** Dominican Republic. */
  Do = 'DO',
  /** Algeria. */
  Dz = 'DZ',
  /** Ecuador. */
  Ec = 'EC',
  /** Estonia. */
  Ee = 'EE',
  /** Egypt. */
  Eg = 'EG',
  /** Western Sahara. */
  Eh = 'EH',
  /** Eritrea. */
  Er = 'ER',
  /** Spain. */
  Es = 'ES',
  /** Ethiopia. */
  Et = 'ET',
  /** Finland. */
  Fi = 'FI',
  /** Fiji. */
  Fj = 'FJ',
  /** Falkland Islands. */
  Fk = 'FK',
  /** Faroe Islands. */
  Fo = 'FO',
  /** France. */
  Fr = 'FR',
  /** Gabon. */
  Ga = 'GA',
  /** United Kingdom. */
  Gb = 'GB',
  /** Grenada. */
  Gd = 'GD',
  /** Georgia. */
  Ge = 'GE',
  /** French Guiana. */
  Gf = 'GF',
  /** Guernsey. */
  Gg = 'GG',
  /** Ghana. */
  Gh = 'GH',
  /** Gibraltar. */
  Gi = 'GI',
  /** Greenland. */
  Gl = 'GL',
  /** Gambia. */
  Gm = 'GM',
  /** Guinea. */
  Gn = 'GN',
  /** Guadeloupe. */
  Gp = 'GP',
  /** Equatorial Guinea. */
  Gq = 'GQ',
  /** Greece. */
  Gr = 'GR',
  /** South Georgia & South Sandwich Islands. */
  Gs = 'GS',
  /** Guatemala. */
  Gt = 'GT',
  /** Guinea-Bissau. */
  Gw = 'GW',
  /** Guyana. */
  Gy = 'GY',
  /** Hong Kong SAR. */
  Hk = 'HK',
  /** Heard & McDonald Islands. */
  Hm = 'HM',
  /** Honduras. */
  Hn = 'HN',
  /** Croatia. */
  Hr = 'HR',
  /** Haiti. */
  Ht = 'HT',
  /** Hungary. */
  Hu = 'HU',
  /** Indonesia. */
  Id = 'ID',
  /** Ireland. */
  Ie = 'IE',
  /** Israel. */
  Il = 'IL',
  /** Isle of Man. */
  Im = 'IM',
  /** India. */
  In = 'IN',
  /** British Indian Ocean Territory. */
  Io = 'IO',
  /** Iraq. */
  Iq = 'IQ',
  /** Iran. */
  Ir = 'IR',
  /** Iceland. */
  Is = 'IS',
  /** Italy. */
  It = 'IT',
  /** Jersey. */
  Je = 'JE',
  /** Jamaica. */
  Jm = 'JM',
  /** Jordan. */
  Jo = 'JO',
  /** Japan. */
  Jp = 'JP',
  /** Kenya. */
  Ke = 'KE',
  /** Kyrgyzstan. */
  Kg = 'KG',
  /** Cambodia. */
  Kh = 'KH',
  /** Kiribati. */
  Ki = 'KI',
  /** Comoros. */
  Km = 'KM',
  /** St. Kitts & Nevis. */
  Kn = 'KN',
  /** North Korea. */
  Kp = 'KP',
  /** South Korea. */
  Kr = 'KR',
  /** Kuwait. */
  Kw = 'KW',
  /** Cayman Islands. */
  Ky = 'KY',
  /** Kazakhstan. */
  Kz = 'KZ',
  /** Laos. */
  La = 'LA',
  /** Lebanon. */
  Lb = 'LB',
  /** St. Lucia. */
  Lc = 'LC',
  /** Liechtenstein. */
  Li = 'LI',
  /** Sri Lanka. */
  Lk = 'LK',
  /** Liberia. */
  Lr = 'LR',
  /** Lesotho. */
  Ls = 'LS',
  /** Lithuania. */
  Lt = 'LT',
  /** Luxembourg. */
  Lu = 'LU',
  /** Latvia. */
  Lv = 'LV',
  /** Libya. */
  Ly = 'LY',
  /** Morocco. */
  Ma = 'MA',
  /** Monaco. */
  Mc = 'MC',
  /** Moldova. */
  Md = 'MD',
  /** Montenegro. */
  Me = 'ME',
  /** St. Martin. */
  Mf = 'MF',
  /** Madagascar. */
  Mg = 'MG',
  /** North Macedonia. */
  Mk = 'MK',
  /** Mali. */
  Ml = 'ML',
  /** Myanmar (Burma). */
  Mm = 'MM',
  /** Mongolia. */
  Mn = 'MN',
  /** Macao SAR. */
  Mo = 'MO',
  /** Martinique. */
  Mq = 'MQ',
  /** Mauritania. */
  Mr = 'MR',
  /** Montserrat. */
  Ms = 'MS',
  /** Malta. */
  Mt = 'MT',
  /** Mauritius. */
  Mu = 'MU',
  /** Maldives. */
  Mv = 'MV',
  /** Malawi. */
  Mw = 'MW',
  /** Mexico. */
  Mx = 'MX',
  /** Malaysia. */
  My = 'MY',
  /** Mozambique. */
  Mz = 'MZ',
  /** Namibia. */
  Na = 'NA',
  /** New Caledonia. */
  Nc = 'NC',
  /** Niger. */
  Ne = 'NE',
  /** Norfolk Island. */
  Nf = 'NF',
  /** Nigeria. */
  Ng = 'NG',
  /** Nicaragua. */
  Ni = 'NI',
  /** Netherlands. */
  Nl = 'NL',
  /** Norway. */
  No = 'NO',
  /** Nepal. */
  Np = 'NP',
  /** Nauru. */
  Nr = 'NR',
  /** Niue. */
  Nu = 'NU',
  /** New Zealand. */
  Nz = 'NZ',
  /** Oman. */
  Om = 'OM',
  /** Panama. */
  Pa = 'PA',
  /** Peru. */
  Pe = 'PE',
  /** French Polynesia. */
  Pf = 'PF',
  /** Papua New Guinea. */
  Pg = 'PG',
  /** Philippines. */
  Ph = 'PH',
  /** Pakistan. */
  Pk = 'PK',
  /** Poland. */
  Pl = 'PL',
  /** St. Pierre & Miquelon. */
  Pm = 'PM',
  /** Pitcairn Islands. */
  Pn = 'PN',
  /** Palestinian Territories. */
  Ps = 'PS',
  /** Portugal. */
  Pt = 'PT',
  /** Paraguay. */
  Py = 'PY',
  /** Qatar. */
  Qa = 'QA',
  /** Réunion. */
  Re = 'RE',
  /** Romania. */
  Ro = 'RO',
  /** Serbia. */
  Rs = 'RS',
  /** Russia. */
  Ru = 'RU',
  /** Rwanda. */
  Rw = 'RW',
  /** Saudi Arabia. */
  Sa = 'SA',
  /** Solomon Islands. */
  Sb = 'SB',
  /** Seychelles. */
  Sc = 'SC',
  /** Sudan. */
  Sd = 'SD',
  /** Sweden. */
  Se = 'SE',
  /** Singapore. */
  Sg = 'SG',
  /** St. Helena. */
  Sh = 'SH',
  /** Slovenia. */
  Si = 'SI',
  /** Svalbard & Jan Mayen. */
  Sj = 'SJ',
  /** Slovakia. */
  Sk = 'SK',
  /** Sierra Leone. */
  Sl = 'SL',
  /** San Marino. */
  Sm = 'SM',
  /** Senegal. */
  Sn = 'SN',
  /** Somalia. */
  So = 'SO',
  /** Suriname. */
  Sr = 'SR',
  /** South Sudan. */
  Ss = 'SS',
  /** São Tomé & Príncipe. */
  St = 'ST',
  /** El Salvador. */
  Sv = 'SV',
  /** Sint Maarten. */
  Sx = 'SX',
  /** Syria. */
  Sy = 'SY',
  /** Eswatini. */
  Sz = 'SZ',
  /** Tristan da Cunha. */
  Ta = 'TA',
  /** Turks & Caicos Islands. */
  Tc = 'TC',
  /** Chad. */
  Td = 'TD',
  /** French Southern Territories. */
  Tf = 'TF',
  /** Togo. */
  Tg = 'TG',
  /** Thailand. */
  Th = 'TH',
  /** Tajikistan. */
  Tj = 'TJ',
  /** Tokelau. */
  Tk = 'TK',
  /** Timor-Leste. */
  Tl = 'TL',
  /** Turkmenistan. */
  Tm = 'TM',
  /** Tunisia. */
  Tn = 'TN',
  /** Tonga. */
  To = 'TO',
  /** Türkiye. */
  Tr = 'TR',
  /** Trinidad & Tobago. */
  Tt = 'TT',
  /** Tuvalu. */
  Tv = 'TV',
  /** Taiwan. */
  Tw = 'TW',
  /** Tanzania. */
  Tz = 'TZ',
  /** Ukraine. */
  Ua = 'UA',
  /** Uganda. */
  Ug = 'UG',
  /** U.S. Outlying Islands. */
  Um = 'UM',
  /** United States. */
  Us = 'US',
  /** Uruguay. */
  Uy = 'UY',
  /** Uzbekistan. */
  Uz = 'UZ',
  /** Vatican City. */
  Va = 'VA',
  /** St. Vincent & Grenadines. */
  Vc = 'VC',
  /** Venezuela. */
  Ve = 'VE',
  /** British Virgin Islands. */
  Vg = 'VG',
  /** Vietnam. */
  Vn = 'VN',
  /** Vanuatu. */
  Vu = 'VU',
  /** Wallis & Futuna. */
  Wf = 'WF',
  /** Samoa. */
  Ws = 'WS',
  /** Kosovo. */
  Xk = 'XK',
  /** Yemen. */
  Ye = 'YE',
  /** Mayotte. */
  Yt = 'YT',
  /** South Africa. */
  Za = 'ZA',
  /** Zambia. */
  Zm = 'ZM',
  /** Zimbabwe. */
  Zw = 'ZW',
  /** Unknown Region. */
  Zz = 'ZZ',
}

/** The part of the image that should remain after cropping. */
export enum ShopifyGenCropRegion {
  /** Keep the bottom of the image. */
  Bottom = 'BOTTOM',
  /** Keep the center of the image. */
  Center = 'CENTER',
  /** Keep the left of the image. */
  Left = 'LEFT',
  /** Keep the right of the image. */
  Right = 'RIGHT',
  /** Keep the top of the image. */
  Top = 'TOP',
}

/** A currency. */
export type ShopifyGenCurrency = {
  __typename?: 'Currency';
  /** The ISO code of the currency. */
  isoCode: ShopifyGenCurrencyCode;
  /** The name of the currency. */
  name: Scalars['String']['output'];
  /** The symbol of the currency. */
  symbol: Scalars['String']['output'];
};

/**
 * The three-letter currency codes that represent the world currencies used in
 * stores. These include standard ISO 4217 codes, legacy codes,
 * and non-standard codes.
 *
 */
export enum ShopifyGenCurrencyCode {
  /** United Arab Emirates Dirham (AED). */
  Aed = 'AED',
  /** Afghan Afghani (AFN). */
  Afn = 'AFN',
  /** Albanian Lek (ALL). */
  All = 'ALL',
  /** Armenian Dram (AMD). */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder. */
  Ang = 'ANG',
  /** Angolan Kwanza (AOA). */
  Aoa = 'AOA',
  /** Argentine Pesos (ARS). */
  Ars = 'ARS',
  /** Australian Dollars (AUD). */
  Aud = 'AUD',
  /** Aruban Florin (AWG). */
  Awg = 'AWG',
  /** Azerbaijani Manat (AZN). */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark (BAM). */
  Bam = 'BAM',
  /** Barbadian Dollar (BBD). */
  Bbd = 'BBD',
  /** Bangladesh Taka (BDT). */
  Bdt = 'BDT',
  /** Bulgarian Lev (BGN). */
  Bgn = 'BGN',
  /** Bahraini Dinar (BHD). */
  Bhd = 'BHD',
  /** Burundian Franc (BIF). */
  Bif = 'BIF',
  /** Bermudian Dollar (BMD). */
  Bmd = 'BMD',
  /** Brunei Dollar (BND). */
  Bnd = 'BND',
  /** Bolivian Boliviano (BOB). */
  Bob = 'BOB',
  /** Brazilian Real (BRL). */
  Brl = 'BRL',
  /** Bahamian Dollar (BSD). */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum (BTN). */
  Btn = 'BTN',
  /** Botswana Pula (BWP). */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN). */
  Byn = 'BYN',
  /**
   * Belarusian Ruble (BYR).
   * @deprecated `BYR` is deprecated. Use `BYN` available from version `2021-01` onwards instead.
   */
  Byr = 'BYR',
  /** Belize Dollar (BZD). */
  Bzd = 'BZD',
  /** Canadian Dollars (CAD). */
  Cad = 'CAD',
  /** Congolese franc (CDF). */
  Cdf = 'CDF',
  /** Swiss Francs (CHF). */
  Chf = 'CHF',
  /** Chilean Peso (CLP). */
  Clp = 'CLP',
  /** Chinese Yuan Renminbi (CNY). */
  Cny = 'CNY',
  /** Colombian Peso (COP). */
  Cop = 'COP',
  /** Costa Rican Colones (CRC). */
  Crc = 'CRC',
  /** Cape Verdean escudo (CVE). */
  Cve = 'CVE',
  /** Czech Koruny (CZK). */
  Czk = 'CZK',
  /** Djiboutian Franc (DJF). */
  Djf = 'DJF',
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Dominican Peso (DOP). */
  Dop = 'DOP',
  /** Algerian Dinar (DZD). */
  Dzd = 'DZD',
  /** Egyptian Pound (EGP). */
  Egp = 'EGP',
  /** Eritrean Nakfa (ERN). */
  Ern = 'ERN',
  /** Ethiopian Birr (ETB). */
  Etb = 'ETB',
  /** Euro (EUR). */
  Eur = 'EUR',
  /** Fijian Dollars (FJD). */
  Fjd = 'FJD',
  /** Falkland Islands Pounds (FKP). */
  Fkp = 'FKP',
  /** United Kingdom Pounds (GBP). */
  Gbp = 'GBP',
  /** Georgian Lari (GEL). */
  Gel = 'GEL',
  /** Ghanaian Cedi (GHS). */
  Ghs = 'GHS',
  /** Gibraltar Pounds (GIP). */
  Gip = 'GIP',
  /** Gambian Dalasi (GMD). */
  Gmd = 'GMD',
  /** Guinean Franc (GNF). */
  Gnf = 'GNF',
  /** Guatemalan Quetzal (GTQ). */
  Gtq = 'GTQ',
  /** Guyanese Dollar (GYD). */
  Gyd = 'GYD',
  /** Hong Kong Dollars (HKD). */
  Hkd = 'HKD',
  /** Honduran Lempira (HNL). */
  Hnl = 'HNL',
  /** Croatian Kuna (HRK). */
  Hrk = 'HRK',
  /** Haitian Gourde (HTG). */
  Htg = 'HTG',
  /** Hungarian Forint (HUF). */
  Huf = 'HUF',
  /** Indonesian Rupiah (IDR). */
  Idr = 'IDR',
  /** Israeli New Shekel (NIS). */
  Ils = 'ILS',
  /** Indian Rupees (INR). */
  Inr = 'INR',
  /** Iraqi Dinar (IQD). */
  Iqd = 'IQD',
  /** Iranian Rial (IRR). */
  Irr = 'IRR',
  /** Icelandic Kronur (ISK). */
  Isk = 'ISK',
  /** Jersey Pound. */
  Jep = 'JEP',
  /** Jamaican Dollars (JMD). */
  Jmd = 'JMD',
  /** Jordanian Dinar (JOD). */
  Jod = 'JOD',
  /** Japanese Yen (JPY). */
  Jpy = 'JPY',
  /** Kenyan Shilling (KES). */
  Kes = 'KES',
  /** Kyrgyzstani Som (KGS). */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Kiribati Dollar (KID). */
  Kid = 'KID',
  /** Comorian Franc (KMF). */
  Kmf = 'KMF',
  /** South Korean Won (KRW). */
  Krw = 'KRW',
  /** Kuwaiti Dinar (KWD). */
  Kwd = 'KWD',
  /** Cayman Dollars (KYD). */
  Kyd = 'KYD',
  /** Kazakhstani Tenge (KZT). */
  Kzt = 'KZT',
  /** Laotian Kip (LAK). */
  Lak = 'LAK',
  /** Lebanese Pounds (LBP). */
  Lbp = 'LBP',
  /** Sri Lankan Rupees (LKR). */
  Lkr = 'LKR',
  /** Liberian Dollar (LRD). */
  Lrd = 'LRD',
  /** Lesotho Loti (LSL). */
  Lsl = 'LSL',
  /** Lithuanian Litai (LTL). */
  Ltl = 'LTL',
  /** Latvian Lati (LVL). */
  Lvl = 'LVL',
  /** Libyan Dinar (LYD). */
  Lyd = 'LYD',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu (MDL). */
  Mdl = 'MDL',
  /** Malagasy Ariary (MGA). */
  Mga = 'MGA',
  /** Macedonia Denar (MKD). */
  Mkd = 'MKD',
  /** Burmese Kyat (MMK). */
  Mmk = 'MMK',
  /** Mongolian Tugrik. */
  Mnt = 'MNT',
  /** Macanese Pataca (MOP). */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (MRU). */
  Mru = 'MRU',
  /** Mauritian Rupee (MUR). */
  Mur = 'MUR',
  /** Maldivian Rufiyaa (MVR). */
  Mvr = 'MVR',
  /** Malawian Kwacha (MWK). */
  Mwk = 'MWK',
  /** Mexican Pesos (MXN). */
  Mxn = 'MXN',
  /** Malaysian Ringgits (MYR). */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira (NGN). */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (NIO). */
  Nio = 'NIO',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Nepalese Rupee (NPR). */
  Npr = 'NPR',
  /** New Zealand Dollars (NZD). */
  Nzd = 'NZD',
  /** Omani Rial (OMR). */
  Omr = 'OMR',
  /** Panamian Balboa (PAB). */
  Pab = 'PAB',
  /** Peruvian Nuevo Sol (PEN). */
  Pen = 'PEN',
  /** Papua New Guinean Kina (PGK). */
  Pgk = 'PGK',
  /** Philippine Peso (PHP). */
  Php = 'PHP',
  /** Pakistani Rupee (PKR). */
  Pkr = 'PKR',
  /** Polish Zlotych (PLN). */
  Pln = 'PLN',
  /** Paraguayan Guarani (PYG). */
  Pyg = 'PYG',
  /** Qatari Rial (QAR). */
  Qar = 'QAR',
  /** Romanian Lei (RON). */
  Ron = 'RON',
  /** Serbian dinar (RSD). */
  Rsd = 'RSD',
  /** Russian Rubles (RUB). */
  Rub = 'RUB',
  /** Rwandan Franc (RWF). */
  Rwf = 'RWF',
  /** Saudi Riyal (SAR). */
  Sar = 'SAR',
  /** Solomon Islands Dollar (SBD). */
  Sbd = 'SBD',
  /** Seychellois Rupee (SCR). */
  Scr = 'SCR',
  /** Sudanese Pound (SDG). */
  Sdg = 'SDG',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK',
  /** Singapore Dollars (SGD). */
  Sgd = 'SGD',
  /** Saint Helena Pounds (SHP). */
  Shp = 'SHP',
  /** Sierra Leonean Leone (SLL). */
  Sll = 'SLL',
  /** Somali Shilling (SOS). */
  Sos = 'SOS',
  /** Surinamese Dollar (SRD). */
  Srd = 'SRD',
  /** South Sudanese Pound (SSP). */
  Ssp = 'SSP',
  /**
   * Sao Tome And Principe Dobra (STD).
   * @deprecated `STD` is deprecated. Use `STN` available from version `2022-07` onwards instead.
   */
  Std = 'STD',
  /** Sao Tome And Principe Dobra (STN). */
  Stn = 'STN',
  /** Syrian Pound (SYP). */
  Syp = 'SYP',
  /** Swazi Lilangeni (SZL). */
  Szl = 'SZL',
  /** Thai baht (THB). */
  Thb = 'THB',
  /** Tajikistani Somoni (TJS). */
  Tjs = 'TJS',
  /** Turkmenistani Manat (TMT). */
  Tmt = 'TMT',
  /** Tunisian Dinar (TND). */
  Tnd = 'TND',
  /** Tongan Pa'anga (TOP). */
  Top = 'TOP',
  /** Turkish Lira (TRY). */
  Try = 'TRY',
  /** Trinidad and Tobago Dollars (TTD). */
  Ttd = 'TTD',
  /** Taiwan Dollars (TWD). */
  Twd = 'TWD',
  /** Tanzanian Shilling (TZS). */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia (UAH). */
  Uah = 'UAH',
  /** Ugandan Shilling (UGX). */
  Ugx = 'UGX',
  /** United States Dollars (USD). */
  Usd = 'USD',
  /** Uruguayan Pesos (UYU). */
  Uyu = 'UYU',
  /** Uzbekistan som (UZS). */
  Uzs = 'UZS',
  /** Venezuelan Bolivares (VED). */
  Ved = 'VED',
  /**
   * Venezuelan Bolivares (VEF).
   * @deprecated `VEF` is deprecated. Use `VES` available from version `2020-10` onwards instead.
   */
  Vef = 'VEF',
  /** Venezuelan Bolivares Soberanos (VES). */
  Ves = 'VES',
  /** Vietnamese đồng (VND). */
  Vnd = 'VND',
  /** Vanuatu Vatu (VUV). */
  Vuv = 'VUV',
  /** Samoan Tala (WST). */
  Wst = 'WST',
  /** Central African CFA Franc (XAF). */
  Xaf = 'XAF',
  /** East Caribbean Dollar (XCD). */
  Xcd = 'XCD',
  /** West African CFA franc (XOF). */
  Xof = 'XOF',
  /** CFP Franc (XPF). */
  Xpf = 'XPF',
  /** Unrecognized currency. */
  Xxx = 'XXX',
  /** Yemeni Rial (YER). */
  Yer = 'YER',
  /** South African Rand (ZAR). */
  Zar = 'ZAR',
  /** Zambian Kwacha (ZMW). */
  Zmw = 'ZMW',
}

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type ShopifyGenCustomer = ShopifyGenHasMetafields & {
  __typename?: 'Customer';
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing: Scalars['Boolean']['output'];
  /** A list of addresses for the customer. */
  addresses: ShopifyGenMailingAddressConnection;
  /** The date and time when the customer was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer’s default address. */
  defaultAddress?: Maybe<ShopifyGenMailingAddress>;
  /** The customer’s name, email or phone number. */
  displayName: Scalars['String']['output'];
  /** The customer’s email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer’s first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A unique ID for the customer. */
  id: Scalars['ID']['output'];
  /** The customer’s last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
  metafield?: Maybe<ShopifyGenMetafield>;
  /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
  metafields: Array<Maybe<ShopifyGenMetafield>>;
  /** The number of orders that the customer has made at the store in their lifetime. */
  numberOfOrders: Scalars['UnsignedInt64']['output'];
  /** The orders associated with the customer. */
  orders: ShopifyGenOrderConnection;
  /** The customer’s phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * A comma separated list of tags that have been added to the customer.
   * Additional access scope required: unauthenticated_read_customer_tags.
   *
   */
  tags: Array<Scalars['String']['output']>;
  /** The date and time when the customer information was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type ShopifyGenCustomerAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type ShopifyGenCustomerMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type ShopifyGenCustomerMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type ShopifyGenCustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenOrderSortKeys>;
};

/** A CustomerAccessToken represents the unique token required to make modifications to the customer object. */
export type ShopifyGenCustomerAccessToken = {
  __typename?: 'CustomerAccessToken';
  /** The customer’s access token. */
  accessToken: Scalars['String']['output'];
  /** The date and time when the customer access token expires. */
  expiresAt: Scalars['DateTime']['output'];
};

/** The input fields required to create a customer access token. */
export type ShopifyGenCustomerAccessTokenCreateInput = {
  /** The email associated to the customer. */
  email: Scalars['String']['input'];
  /** The login password to be used by the customer. */
  password: Scalars['String']['input'];
};

/** Return type for `customerAccessTokenCreate` mutation. */
export type ShopifyGenCustomerAccessTokenCreatePayload = {
  __typename?: 'CustomerAccessTokenCreatePayload';
  /** The newly created customer access token object. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerAccessTokenCreateWithMultipass` mutation. */
export type ShopifyGenCustomerAccessTokenCreateWithMultipassPayload = {
  __typename?: 'CustomerAccessTokenCreateWithMultipassPayload';
  /** An access token object associated with the customer. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
};

/** Return type for `customerAccessTokenDelete` mutation. */
export type ShopifyGenCustomerAccessTokenDeletePayload = {
  __typename?: 'CustomerAccessTokenDeletePayload';
  /** The destroyed access token. */
  deletedAccessToken?: Maybe<Scalars['String']['output']>;
  /** ID of the destroyed customer access token. */
  deletedCustomerAccessTokenId?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerAccessTokenRenew` mutation. */
export type ShopifyGenCustomerAccessTokenRenewPayload = {
  __typename?: 'CustomerAccessTokenRenewPayload';
  /** The renewed customer access token object. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerActivateByUrl` mutation. */
export type ShopifyGenCustomerActivateByUrlPayload = {
  __typename?: 'CustomerActivateByUrlPayload';
  /** The customer that was activated. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** A new customer access token for the customer. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
};

/** The input fields to activate a customer. */
export type ShopifyGenCustomerActivateInput = {
  /** The activation token required to activate the customer. */
  activationToken: Scalars['String']['input'];
  /** New password that will be set during activation. */
  password: Scalars['String']['input'];
};

/** Return type for `customerActivate` mutation. */
export type ShopifyGenCustomerActivatePayload = {
  __typename?: 'CustomerActivatePayload';
  /** The customer object. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerAddressCreate` mutation. */
export type ShopifyGenCustomerAddressCreatePayload = {
  __typename?: 'CustomerAddressCreatePayload';
  /** The new customer address object. */
  customerAddress?: Maybe<ShopifyGenMailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerAddressDelete` mutation. */
export type ShopifyGenCustomerAddressDeletePayload = {
  __typename?: 'CustomerAddressDeletePayload';
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /** ID of the deleted customer address. */
  deletedCustomerAddressId?: Maybe<Scalars['String']['output']>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerAddressUpdate` mutation. */
export type ShopifyGenCustomerAddressUpdatePayload = {
  __typename?: 'CustomerAddressUpdatePayload';
  /** The customer’s updated mailing address. */
  customerAddress?: Maybe<ShopifyGenMailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** The input fields to create a new customer. */
export type ShopifyGenCustomerCreateInput = {
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer’s email. */
  email: Scalars['String']['input'];
  /** The customer’s first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The login password used by the customer. */
  password: Scalars['String']['input'];
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `customerCreate` mutation. */
export type ShopifyGenCustomerCreatePayload = {
  __typename?: 'CustomerCreatePayload';
  /** The created customer object. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerDefaultAddressUpdate` mutation. */
export type ShopifyGenCustomerDefaultAddressUpdatePayload = {
  __typename?: 'CustomerDefaultAddressUpdatePayload';
  /** The updated customer object. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Possible error codes that can be returned by `CustomerUserError`. */
export enum ShopifyGenCustomerErrorCode {
  /** Customer already enabled. */
  AlreadyEnabled = 'ALREADY_ENABLED',
  /** Input email contains an invalid domain name. */
  BadDomain = 'BAD_DOMAIN',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Input contains HTML tags. */
  ContainsHtmlTags = 'CONTAINS_HTML_TAGS',
  /** Input contains URL. */
  ContainsUrl = 'CONTAINS_URL',
  /** Customer is disabled. */
  CustomerDisabled = 'CUSTOMER_DISABLED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Multipass token is not valid. */
  InvalidMultipassRequest = 'INVALID_MULTIPASS_REQUEST',
  /** Address does not exist. */
  NotFound = 'NOT_FOUND',
  /** Input password starts or ends with whitespace. */
  PasswordStartsOrEndsWithWhitespace = 'PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** Invalid activation token. */
  TokenInvalid = 'TOKEN_INVALID',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unidentified customer. */
  UnidentifiedCustomer = 'UNIDENTIFIED_CUSTOMER',
}

/** Return type for `customerRecover` mutation. */
export type ShopifyGenCustomerRecoverPayload = {
  __typename?: 'CustomerRecoverPayload';
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Return type for `customerResetByUrl` mutation. */
export type ShopifyGenCustomerResetByUrlPayload = {
  __typename?: 'CustomerResetByUrlPayload';
  /** The customer object which was reset. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** The input fields to reset a customer's password. */
export type ShopifyGenCustomerResetInput = {
  /** New password that will be set as part of the reset password process. */
  password: Scalars['String']['input'];
  /** The reset token required to reset the customer’s password. */
  resetToken: Scalars['String']['input'];
};

/** Return type for `customerReset` mutation. */
export type ShopifyGenCustomerResetPayload = {
  __typename?: 'CustomerResetPayload';
  /** The customer object which was reset. */
  customer?: Maybe<ShopifyGenCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** The input fields to update the Customer information. */
export type ShopifyGenCustomerUpdateInput = {
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer’s email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The login password used by the customer. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_. To remove the phone number, specify `null`.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `customerUpdate` mutation. */
export type ShopifyGenCustomerUpdatePayload = {
  __typename?: 'CustomerUpdatePayload';
  /** The updated customer object. */
  customer?: Maybe<ShopifyGenCustomer>;
  /**
   * The newly created customer access token. If the customer's password is updated, all previous access tokens
   * (including the one used to perform this mutation) become invalid, and a new token is generated.
   *
   */
  customerAccessToken?: Maybe<ShopifyGenCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<ShopifyGenCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<ShopifyGenUserError>;
};

/** Represents an error that happens during execution of a customer mutation. */
export type ShopifyGenCustomerUserError = ShopifyGenDisplayableError & {
  __typename?: 'CustomerUserError';
  /** The error code. */
  code?: Maybe<ShopifyGenCustomerErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** A delivery address of the buyer that is interacting with the cart. */
export type ShopifyGenDeliveryAddress = ShopifyGenMailingAddress;

/**
 * The input fields for delivery address preferences.
 *
 */
export type ShopifyGenDeliveryAddressInput = {
  /**
   * The ID of a customer address that is associated with the buyer that is interacting with the cart.
   *
   */
  customerAddressId?: InputMaybe<Scalars['ID']['input']>;
  /** A delivery address preference of a buyer that is interacting with the cart. */
  deliveryAddress?: InputMaybe<ShopifyGenMailingAddressInput>;
  /** Defines what kind of address validation is requested. */
  deliveryAddressValidationStrategy?: InputMaybe<ShopifyGenDeliveryAddressValidationStrategy>;
  /**
   * Whether the given delivery address is considered to be a one-time use address. One-time use addresses do not
   * get persisted to the buyer's personal addresses when checking out.
   *
   */
  oneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Defines the types of available validation strategies for delivery addresses.
 *
 */
export enum ShopifyGenDeliveryAddressValidationStrategy {
  /** Only the country code is validated. */
  CountryCodeOnly = 'COUNTRY_CODE_ONLY',
  /**
   * Strict validation is performed, i.e. all fields in the address are validated
   * according to Shopify's checkout rules. If the address fails validation, the cart will not be updated.
   *
   */
  Strict = 'STRICT',
}

/** List of different delivery method types. */
export enum ShopifyGenDeliveryMethodType {
  /** Local Delivery. */
  Local = 'LOCAL',
  /** None. */
  None = 'NONE',
  /** Shipping to a Pickup Point. */
  PickupPoint = 'PICKUP_POINT',
  /** Local Pickup. */
  PickUp = 'PICK_UP',
  /** Retail. */
  Retail = 'RETAIL',
  /** Shipping. */
  Shipping = 'SHIPPING',
}

/** Digital wallet, such as Apple Pay, which can be used for accelerated checkouts. */
export enum ShopifyGenDigitalWallet {
  /** Android Pay. */
  AndroidPay = 'ANDROID_PAY',
  /** Apple Pay. */
  ApplePay = 'APPLE_PAY',
  /** Google Pay. */
  GooglePay = 'GOOGLE_PAY',
  /** Shopify Pay. */
  ShopifyPay = 'SHOPIFY_PAY',
}

/**
 * An amount discounting the line that has been allocated by a discount.
 *
 */
export type ShopifyGenDiscountAllocation = {
  __typename?: 'DiscountAllocation';
  /** Amount of discount allocated. */
  allocatedAmount: ShopifyGenMoneyV2;
  /** The discount this allocated amount originated from. */
  discountApplication: ShopifyGenDiscountApplication;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application.
 *
 */
export type ShopifyGenDiscountApplication = {
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: ShopifyGenDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: ShopifyGenDiscountApplicationTargetType;
  /** The value of the discount application. */
  value: ShopifyGenPricingValue;
};

/** The method by which the discount's value is allocated onto its entitled lines. */
export enum ShopifyGenDiscountApplicationAllocationMethod {
  /** The value is spread across all entitled lines. */
  Across = 'ACROSS',
  /** The value is applied onto every entitled line. */
  Each = 'EACH',
  /**
   * The value is specifically applied onto a particular line.
   * @deprecated Use ACROSS instead.
   */
  One = 'ONE',
}

/**
 * An auto-generated type for paginating through multiple DiscountApplications.
 *
 */
export type ShopifyGenDiscountApplicationConnection = {
  __typename?: 'DiscountApplicationConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenDiscountApplicationEdge>;
  /** A list of the nodes contained in DiscountApplicationEdge. */
  nodes: Array<ShopifyGenDiscountApplication>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one DiscountApplication and a cursor during pagination.
 *
 */
export type ShopifyGenDiscountApplicationEdge = {
  __typename?: 'DiscountApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountApplicationEdge. */
  node: ShopifyGenDiscountApplication;
};

/**
 * The lines on the order to which the discount is applied, of the type defined by
 * the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
 * `LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
 * The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.
 *
 */
export enum ShopifyGenDiscountApplicationTargetSelection {
  /** The discount is allocated onto all the lines. */
  All = 'ALL',
  /** The discount is allocated onto only the lines that it's entitled for. */
  Entitled = 'ENTITLED',
  /** The discount is allocated onto explicitly chosen lines. */
  Explicit = 'EXPLICIT',
}

/**
 * The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards.
 *
 */
export enum ShopifyGenDiscountApplicationTargetType {
  /** The discount applies onto line items. */
  LineItem = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  ShippingLine = 'SHIPPING_LINE',
}

/**
 * Discount code applications capture the intentions of a discount code at
 * the time that it is applied.
 *
 */
export type ShopifyGenDiscountCodeApplication =
  ShopifyGenDiscountApplication & {
    __typename?: 'DiscountCodeApplication';
    /** The method by which the discount's value is allocated to its entitled items. */
    allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
    /** Specifies whether the discount code was applied successfully. */
    applicable: Scalars['Boolean']['output'];
    /** The string identifying the discount code that was used at the time of application. */
    code: Scalars['String']['output'];
    /** Which lines of targetType that the discount is allocated over. */
    targetSelection: ShopifyGenDiscountApplicationTargetSelection;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The value of the discount application. */
    value: ShopifyGenPricingValue;
  };

/** Represents an error in the input of a mutation. */
export type ShopifyGenDisplayableError = {
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Represents a web address. */
export type ShopifyGenDomain = {
  __typename?: 'Domain';
  /** The host name of the domain (eg: `example.com`). */
  host: Scalars['String']['output'];
  /** Whether SSL is enabled or not. */
  sslEnabled: Scalars['Boolean']['output'];
  /** The URL of the domain (eg: `https://example.com`). */
  url: Scalars['URL']['output'];
};

/** Represents a video hosted outside of Shopify. */
export type ShopifyGenExternalVideo = ShopifyGenMedia &
  ShopifyGenNode & {
    __typename?: 'ExternalVideo';
    /** A word or phrase to share the nature or contents of a media. */
    alt?: Maybe<Scalars['String']['output']>;
    /** The embed URL of the video for the respective host. */
    embedUrl: Scalars['URL']['output'];
    /**
     * The URL.
     * @deprecated Use `originUrl` instead.
     */
    embeddedUrl: Scalars['URL']['output'];
    /** The host of the external video. */
    host: ShopifyGenMediaHost;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The media content type. */
    mediaContentType: ShopifyGenMediaContentType;
    /** The origin URL of the video on the respective host. */
    originUrl: Scalars['URL']['output'];
    /** The presentation for a media. */
    presentation?: Maybe<ShopifyGenMediaPresentation>;
    /** The preview image for the media. */
    previewImage?: Maybe<ShopifyGenImage>;
  };

/** A filter that is supported on the parent field. */
export type ShopifyGenFilter = {
  __typename?: 'Filter';
  /** A unique identifier. */
  id: Scalars['String']['output'];
  /** A human-friendly string for this filter. */
  label: Scalars['String']['output'];
  /**
   * Describes how to present the filter values.
   * Returns a value only for filters of type `LIST`. Returns null for other types.
   *
   */
  presentation?: Maybe<ShopifyGenFilterPresentation>;
  /** An enumeration that denotes the type of data this filter represents. */
  type: ShopifyGenFilterType;
  /** The list of values for this filter. */
  values: Array<ShopifyGenFilterValue>;
};

/**
 * Defines how to present the filter values, specifies the presentation of the filter.
 *
 */
export enum ShopifyGenFilterPresentation {
  /** Image presentation, filter values display an image. */
  Image = 'IMAGE',
  /** Swatch presentation, filter values display color or image patterns. */
  Swatch = 'SWATCH',
  /** Text presentation, no additional visual display for filter values. */
  Text = 'TEXT',
}

/**
 * The type of data that the filter group represents.
 *
 * For more information, refer to [Filter products in a collection with the Storefront API]
 * (https://shopify.dev/custom-storefronts/products-collections/filter-products).
 *
 */
export enum ShopifyGenFilterType {
  /** A boolean value. */
  Boolean = 'BOOLEAN',
  /** A list of selectable values. */
  List = 'LIST',
  /** A range of prices. */
  PriceRange = 'PRICE_RANGE',
}

/** A selectable value within a filter. */
export type ShopifyGenFilterValue = {
  __typename?: 'FilterValue';
  /** The number of results that match this filter value. */
  count: Scalars['Int']['output'];
  /** A unique identifier. */
  id: Scalars['String']['output'];
  /** The visual representation when the filter's presentation is `IMAGE`. */
  image?: Maybe<ShopifyGenMediaImage>;
  /**
   * An input object that can be used to filter by this value on the parent field.
   *
   * The value is provided as a helper for building dynamic filtering UI. For
   * example, if you have a list of selected `FilterValue` objects, you can combine
   * their respective `input` values to use in a subsequent query.
   *
   */
  input: Scalars['JSON']['output'];
  /** A human-friendly string for this filter value. */
  label: Scalars['String']['output'];
  /** The visual representation when the filter's presentation is `SWATCH`. */
  swatch?: Maybe<ShopifyGenSwatch>;
};

/** Represents a single fulfillment in an order. */
export type ShopifyGenFulfillment = {
  __typename?: 'Fulfillment';
  /** List of the fulfillment's line items. */
  fulfillmentLineItems: ShopifyGenFulfillmentLineItemConnection;
  /** The name of the tracking company. */
  trackingCompany?: Maybe<Scalars['String']['output']>;
  /**
   * Tracking information associated with the fulfillment,
   * such as the tracking number and tracking URL.
   *
   */
  trackingInfo: Array<ShopifyGenFulfillmentTrackingInfo>;
};

/** Represents a single fulfillment in an order. */
export type ShopifyGenFulfillmentFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a single fulfillment in an order. */
export type ShopifyGenFulfillmentTrackingInfoArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a single line item in a fulfillment. There is at most one fulfillment line item for each order line item. */
export type ShopifyGenFulfillmentLineItem = {
  __typename?: 'FulfillmentLineItem';
  /** The associated order's line item. */
  lineItem: ShopifyGenOrderLineItem;
  /** The amount fulfilled in this fulfillment. */
  quantity: Scalars['Int']['output'];
};

/**
 * An auto-generated type for paginating through multiple FulfillmentLineItems.
 *
 */
export type ShopifyGenFulfillmentLineItemConnection = {
  __typename?: 'FulfillmentLineItemConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenFulfillmentLineItemEdge>;
  /** A list of the nodes contained in FulfillmentLineItemEdge. */
  nodes: Array<ShopifyGenFulfillmentLineItem>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one FulfillmentLineItem and a cursor during pagination.
 *
 */
export type ShopifyGenFulfillmentLineItemEdge = {
  __typename?: 'FulfillmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentLineItemEdge. */
  node: ShopifyGenFulfillmentLineItem;
};

/** Tracking information associated with the fulfillment. */
export type ShopifyGenFulfillmentTrackingInfo = {
  __typename?: 'FulfillmentTrackingInfo';
  /** The tracking number of the fulfillment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The URL to track the fulfillment. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The generic file resource lets you manage files in a merchant’s store. Generic files include any file that doesn’t fit into a designated type such as image or video. Example: PDF, JSON. */
export type ShopifyGenGenericFile = ShopifyGenNode & {
  __typename?: 'GenericFile';
  /** A word or phrase to indicate the contents of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The MIME type of the file. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The size of the original file in bytes. */
  originalFileSize?: Maybe<Scalars['Int']['output']>;
  /** The preview image for the file. */
  previewImage?: Maybe<ShopifyGenImage>;
  /** The URL of the file. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The input fields used to specify a geographical location. */
export type ShopifyGenGeoCoordinateInput = {
  /** The coordinate's latitude value. */
  latitude: Scalars['Float']['input'];
  /** The coordinate's longitude value. */
  longitude: Scalars['Float']['input'];
};

/** Represents information about the metafields associated to the specified resource. */
export type ShopifyGenHasMetafields = {
  /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
  metafield?: Maybe<ShopifyGenMetafield>;
  /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
  metafields: Array<Maybe<ShopifyGenMetafield>>;
};

/** Represents information about the metafields associated to the specified resource. */
export type ShopifyGenHasMetafieldsMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Represents information about the metafields associated to the specified resource. */
export type ShopifyGenHasMetafieldsMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** The input fields to identify a metafield on an owner resource by namespace and key. */
export type ShopifyGenHasMetafieldsIdentifier = {
  /** The identifier for the metafield. */
  key: Scalars['String']['input'];
  /** The container the metafield belongs to. If omitted, the app-reserved namespace will be used. */
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an image resource. */
export type ShopifyGenImage = {
  __typename?: 'Image';
  /** A word or phrase to share the nature or contents of an image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The original height of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  height?: Maybe<Scalars['Int']['output']>;
  /** A unique ID for the image. */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * The location of the original image as a URL.
   *
   * If there are any existing transformations in the original source URL, they will remain and not be stripped.
   *
   * @deprecated Use `url` instead.
   */
  originalSrc: Scalars['URL']['output'];
  /**
   * The location of the image as a URL.
   * @deprecated Use `url` instead.
   */
  src: Scalars['URL']['output'];
  /**
   * The location of the transformed image as a URL.
   *
   * All transformation arguments are considered "best-effort". If they can be applied to an image, they will be.
   * Otherwise any transformations which an image type doesn't support will be ignored.
   *
   * @deprecated Use `url(transform:)` instead
   */
  transformedSrc: Scalars['URL']['output'];
  /**
   * The location of the image as a URL.
   *
   * If no transform options are specified, then the original image will be preserved including any pre-applied transforms.
   *
   * All transformation options are considered "best-effort". Any transformation that the original image type doesn't support will be ignored.
   *
   * If you need multiple variations of the same image, then you can use [GraphQL aliases](https://graphql.org/learn/queries/#aliases).
   *
   */
  url: Scalars['URL']['output'];
  /** The original width of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Represents an image resource. */
export type ShopifyGenImageTransformedSrcArgs = {
  crop?: InputMaybe<ShopifyGenCropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  preferredContentType?: InputMaybe<ShopifyGenImageContentType>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an image resource. */
export type ShopifyGenImageUrlArgs = {
  transform?: InputMaybe<ShopifyGenImageTransformInput>;
};

/**
 * An auto-generated type for paginating through multiple Images.
 *
 */
export type ShopifyGenImageConnection = {
  __typename?: 'ImageConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenImageEdge>;
  /** A list of the nodes contained in ImageEdge. */
  nodes: Array<ShopifyGenImage>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/** List of supported image content types. */
export enum ShopifyGenImageContentType {
  /** A JPG image. */
  Jpg = 'JPG',
  /** A PNG image. */
  Png = 'PNG',
  /** A WEBP image. */
  Webp = 'WEBP',
}

/**
 * An auto-generated type which holds one Image and a cursor during pagination.
 *
 */
export type ShopifyGenImageEdge = {
  __typename?: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ImageEdge. */
  node: ShopifyGenImage;
};

/**
 * The available options for transforming an image.
 *
 * All transformation options are considered best effort. Any transformation that
 * the original image type doesn't support will be ignored.
 *
 */
export type ShopifyGenImageTransformInput = {
  /**
   * The region of the image to remain after cropping.
   * Must be used in conjunction with the `maxWidth` and/or `maxHeight` fields,
   * where the `maxWidth` and `maxHeight` aren't equal.
   * The `crop` argument should coincide with the smaller value. A smaller `maxWidth` indicates a `LEFT` or `RIGHT` crop, while
   * a smaller `maxHeight` indicates a `TOP` or `BOTTOM` crop. For example, `{
   * maxWidth: 5, maxHeight: 10, crop: LEFT }` will result
   * in an image with a width of 5 and height of 10, where the right side of the image is removed.
   *
   */
  crop?: InputMaybe<ShopifyGenCropRegion>;
  /**
   * Image height in pixels between 1 and 5760.
   *
   */
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Image width in pixels between 1 and 5760.
   *
   */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Convert the source image into the preferred content type.
   * Supported conversions: `.svg` to `.png`, any file type to `.jpg`, and any file type to `.webp`.
   *
   */
  preferredContentType?: InputMaybe<ShopifyGenImageContentType>;
  /**
   * Image size multiplier for high-resolution retina displays. Must be within 1..3.
   *
   */
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/** Provide details about the contexts influenced by the @inContext directive on a field. */
export type ShopifyGenInContextAnnotation = {
  __typename?: 'InContextAnnotation';
  description: Scalars['String']['output'];
  type: ShopifyGenInContextAnnotationType;
};

/** This gives information about the type of context that impacts a field. For example, for a query with @inContext(language: "EN"), the type would point to the name: LanguageCode and kind: ENUM. */
export type ShopifyGenInContextAnnotationType = {
  __typename?: 'InContextAnnotationType';
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A language. */
export type ShopifyGenLanguage = {
  __typename?: 'Language';
  /** The name of the language in the language itself. If the language uses capitalization, it is capitalized for a mid-sentence position. */
  endonymName: Scalars['String']['output'];
  /** The ISO code. */
  isoCode: ShopifyGenLanguageCode;
  /** The name of the language in the current language. */
  name: Scalars['String']['output'];
};

/** Language codes supported by Shopify. */
export enum ShopifyGenLanguageCode {
  /** Afrikaans. */
  Af = 'AF',
  /** Akan. */
  Ak = 'AK',
  /** Amharic. */
  Am = 'AM',
  /** Arabic. */
  Ar = 'AR',
  /** Assamese. */
  As = 'AS',
  /** Azerbaijani. */
  Az = 'AZ',
  /** Belarusian. */
  Be = 'BE',
  /** Bulgarian. */
  Bg = 'BG',
  /** Bambara. */
  Bm = 'BM',
  /** Bangla. */
  Bn = 'BN',
  /** Tibetan. */
  Bo = 'BO',
  /** Breton. */
  Br = 'BR',
  /** Bosnian. */
  Bs = 'BS',
  /** Catalan. */
  Ca = 'CA',
  /** Chechen. */
  Ce = 'CE',
  /** Central Kurdish. */
  Ckb = 'CKB',
  /** Czech. */
  Cs = 'CS',
  /** Church Slavic. */
  Cu = 'CU',
  /** Welsh. */
  Cy = 'CY',
  /** Danish. */
  Da = 'DA',
  /** German. */
  De = 'DE',
  /** Dzongkha. */
  Dz = 'DZ',
  /** Ewe. */
  Ee = 'EE',
  /** Greek. */
  El = 'EL',
  /** English. */
  En = 'EN',
  /** Esperanto. */
  Eo = 'EO',
  /** Spanish. */
  Es = 'ES',
  /** Estonian. */
  Et = 'ET',
  /** Basque. */
  Eu = 'EU',
  /** Persian. */
  Fa = 'FA',
  /** Fulah. */
  Ff = 'FF',
  /** Finnish. */
  Fi = 'FI',
  /** Filipino. */
  Fil = 'FIL',
  /** Faroese. */
  Fo = 'FO',
  /** French. */
  Fr = 'FR',
  /** Western Frisian. */
  Fy = 'FY',
  /** Irish. */
  Ga = 'GA',
  /** Scottish Gaelic. */
  Gd = 'GD',
  /** Galician. */
  Gl = 'GL',
  /** Gujarati. */
  Gu = 'GU',
  /** Manx. */
  Gv = 'GV',
  /** Hausa. */
  Ha = 'HA',
  /** Hebrew. */
  He = 'HE',
  /** Hindi. */
  Hi = 'HI',
  /** Croatian. */
  Hr = 'HR',
  /** Hungarian. */
  Hu = 'HU',
  /** Armenian. */
  Hy = 'HY',
  /** Interlingua. */
  Ia = 'IA',
  /** Indonesian. */
  Id = 'ID',
  /** Igbo. */
  Ig = 'IG',
  /** Sichuan Yi. */
  Ii = 'II',
  /** Icelandic. */
  Is = 'IS',
  /** Italian. */
  It = 'IT',
  /** Japanese. */
  Ja = 'JA',
  /** Javanese. */
  Jv = 'JV',
  /** Georgian. */
  Ka = 'KA',
  /** Kikuyu. */
  Ki = 'KI',
  /** Kazakh. */
  Kk = 'KK',
  /** Kalaallisut. */
  Kl = 'KL',
  /** Khmer. */
  Km = 'KM',
  /** Kannada. */
  Kn = 'KN',
  /** Korean. */
  Ko = 'KO',
  /** Kashmiri. */
  Ks = 'KS',
  /** Kurdish. */
  Ku = 'KU',
  /** Cornish. */
  Kw = 'KW',
  /** Kyrgyz. */
  Ky = 'KY',
  /** Latin. */
  La = 'LA',
  /** Luxembourgish. */
  Lb = 'LB',
  /** Ganda. */
  Lg = 'LG',
  /** Lingala. */
  Ln = 'LN',
  /** Lao. */
  Lo = 'LO',
  /** Lithuanian. */
  Lt = 'LT',
  /** Luba-Katanga. */
  Lu = 'LU',
  /** Latvian. */
  Lv = 'LV',
  /** Malagasy. */
  Mg = 'MG',
  /** Māori. */
  Mi = 'MI',
  /** Macedonian. */
  Mk = 'MK',
  /** Malayalam. */
  Ml = 'ML',
  /** Mongolian. */
  Mn = 'MN',
  /** Moldavian. */
  Mo = 'MO',
  /** Marathi. */
  Mr = 'MR',
  /** Malay. */
  Ms = 'MS',
  /** Maltese. */
  Mt = 'MT',
  /** Burmese. */
  My = 'MY',
  /** Norwegian (Bokmål). */
  Nb = 'NB',
  /** North Ndebele. */
  Nd = 'ND',
  /** Nepali. */
  Ne = 'NE',
  /** Dutch. */
  Nl = 'NL',
  /** Norwegian Nynorsk. */
  Nn = 'NN',
  /** Norwegian. */
  No = 'NO',
  /** Oromo. */
  Om = 'OM',
  /** Odia. */
  Or = 'OR',
  /** Ossetic. */
  Os = 'OS',
  /** Punjabi. */
  Pa = 'PA',
  /** Polish. */
  Pl = 'PL',
  /** Pashto. */
  Ps = 'PS',
  /** Portuguese. */
  Pt = 'PT',
  /** Portuguese (Brazil). */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal). */
  PtPt = 'PT_PT',
  /** Quechua. */
  Qu = 'QU',
  /** Romansh. */
  Rm = 'RM',
  /** Rundi. */
  Rn = 'RN',
  /** Romanian. */
  Ro = 'RO',
  /** Russian. */
  Ru = 'RU',
  /** Kinyarwanda. */
  Rw = 'RW',
  /** Sanskrit. */
  Sa = 'SA',
  /** Sardinian. */
  Sc = 'SC',
  /** Sindhi. */
  Sd = 'SD',
  /** Northern Sami. */
  Se = 'SE',
  /** Sango. */
  Sg = 'SG',
  /** Serbo-Croatian. */
  Sh = 'SH',
  /** Sinhala. */
  Si = 'SI',
  /** Slovak. */
  Sk = 'SK',
  /** Slovenian. */
  Sl = 'SL',
  /** Shona. */
  Sn = 'SN',
  /** Somali. */
  So = 'SO',
  /** Albanian. */
  Sq = 'SQ',
  /** Serbian. */
  Sr = 'SR',
  /** Sundanese. */
  Su = 'SU',
  /** Swedish. */
  Sv = 'SV',
  /** Swahili. */
  Sw = 'SW',
  /** Tamil. */
  Ta = 'TA',
  /** Telugu. */
  Te = 'TE',
  /** Tajik. */
  Tg = 'TG',
  /** Thai. */
  Th = 'TH',
  /** Tigrinya. */
  Ti = 'TI',
  /** Turkmen. */
  Tk = 'TK',
  /** Tongan. */
  To = 'TO',
  /** Turkish. */
  Tr = 'TR',
  /** Tatar. */
  Tt = 'TT',
  /** Uyghur. */
  Ug = 'UG',
  /** Ukrainian. */
  Uk = 'UK',
  /** Urdu. */
  Ur = 'UR',
  /** Uzbek. */
  Uz = 'UZ',
  /** Vietnamese. */
  Vi = 'VI',
  /** Volapük. */
  Vo = 'VO',
  /** Wolof. */
  Wo = 'WO',
  /** Xhosa. */
  Xh = 'XH',
  /** Yiddish. */
  Yi = 'YI',
  /** Yoruba. */
  Yo = 'YO',
  /** Chinese. */
  Zh = 'ZH',
  /** Chinese (Simplified). */
  ZhCn = 'ZH_CN',
  /** Chinese (Traditional). */
  ZhTw = 'ZH_TW',
  /** Zulu. */
  Zu = 'ZU',
}

/** Information about the localized experiences configured for the shop. */
export type ShopifyGenLocalization = {
  __typename?: 'Localization';
  /** The list of countries with enabled localized experiences. */
  availableCountries: Array<ShopifyGenCountry>;
  /** The list of languages available for the active country. */
  availableLanguages: Array<ShopifyGenLanguage>;
  /** The country of the active localized experience. Use the `@inContext` directive to change this value. */
  country: ShopifyGenCountry;
  /** The language of the active localized experience. Use the `@inContext` directive to change this value. */
  language: ShopifyGenLanguage;
  /** The market including the country of the active localized experience. Use the `@inContext` directive to change this value. */
  market: ShopifyGenMarket;
};

/** Represents a location where product inventory is held. */
export type ShopifyGenLocation = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Location';
    /** The address of the location. */
    address: ShopifyGenLocationAddress;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The name of the location. */
    name: Scalars['String']['output'];
  };

/** Represents a location where product inventory is held. */
export type ShopifyGenLocationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a location where product inventory is held. */
export type ShopifyGenLocationMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * Represents the address of a location.
 *
 */
export type ShopifyGenLocationAddress = {
  __typename?: 'LocationAddress';
  /** The first line of the address for the location. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address for the location. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the location. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the location. */
  country?: Maybe<Scalars['String']['output']>;
  /** The country code of the location. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address for the location. */
  formatted: Array<Scalars['String']['output']>;
  /** The latitude coordinates of the location. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinates of the location. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The phone number of the location. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The province of the location. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The code for the province, state, or district of the address of the location.
   *
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the location. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * An auto-generated type for paginating through multiple Locations.
 *
 */
export type ShopifyGenLocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenLocationEdge>;
  /** A list of the nodes contained in LocationEdge. */
  nodes: Array<ShopifyGenLocation>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Location and a cursor during pagination.
 *
 */
export type ShopifyGenLocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of LocationEdge. */
  node: ShopifyGenLocation;
};

/** The set of valid sort keys for the Location query. */
export enum ShopifyGenLocationSortKeys {
  /** Sort by the `city` value. */
  City = 'CITY',
  /** Sort by the `distance` value. */
  Distance = 'DISTANCE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME',
}

/** Represents a mailing address for customers and shipping. */
export type ShopifyGenMailingAddress = ShopifyGenNode & {
  __typename?: 'MailingAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: Maybe<Scalars['String']['output']>;
  /** The name of the city, district, village, or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The name of the customer's company or organization. */
  company?: Maybe<Scalars['String']['output']>;
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   *
   * @deprecated Use `countryCodeV2` instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   *
   */
  countryCodeV2?: Maybe<ShopifyGenCountryCode>;
  /** The first name of the customer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address, customized by the provided arguments. */
  formatted: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the customer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the customer address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the customer address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The full name of the customer, based on firstName and lastName. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   *
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Represents a mailing address for customers and shipping. */
export type ShopifyGenMailingAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']['input']>;
  withName?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple MailingAddresses.
 *
 */
export type ShopifyGenMailingAddressConnection = {
  __typename?: 'MailingAddressConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenMailingAddressEdge>;
  /** A list of the nodes contained in MailingAddressEdge. */
  nodes: Array<ShopifyGenMailingAddress>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one MailingAddress and a cursor during pagination.
 *
 */
export type ShopifyGenMailingAddressEdge = {
  __typename?: 'MailingAddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MailingAddressEdge. */
  node: ShopifyGenMailingAddress;
};

/** The input fields to create or update a mailing address. */
export type ShopifyGenMailingAddressInput = {
  /**
   * The first line of the address. Typically the street address or PO Box number.
   *
   */
  address1?: InputMaybe<Scalars['String']['input']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the city, district, village, or town.
   *
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the customer's company or organization.
   *
   */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The name of the country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The region of the address, such as the province, state, or district. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Manual discount applications capture the intentions of a discount that was manually created.
 *
 */
export type ShopifyGenManualDiscountApplication =
  ShopifyGenDiscountApplication & {
    __typename?: 'ManualDiscountApplication';
    /** The method by which the discount's value is allocated to its entitled items. */
    allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
    /** The description of the application. */
    description?: Maybe<Scalars['String']['output']>;
    /** Which lines of targetType that the discount is allocated over. */
    targetSelection: ShopifyGenDiscountApplicationTargetSelection;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The title of the application. */
    title: Scalars['String']['output'];
    /** The value of the discount application. */
    value: ShopifyGenPricingValue;
  };

/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type ShopifyGenMarket = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Market';
    /**
     * A human-readable unique string for the market automatically generated from its title.
     *
     */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
  };

/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type ShopifyGenMarketMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type ShopifyGenMarketMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** Represents a media interface. */
export type ShopifyGenMedia = {
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: ShopifyGenMediaContentType;
  /** The presentation for a media. */
  presentation?: Maybe<ShopifyGenMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<ShopifyGenImage>;
};

/**
 * An auto-generated type for paginating through multiple Media.
 *
 */
export type ShopifyGenMediaConnection = {
  __typename?: 'MediaConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenMediaEdge>;
  /** A list of the nodes contained in MediaEdge. */
  nodes: Array<ShopifyGenMedia>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/** The possible content types for a media object. */
export enum ShopifyGenMediaContentType {
  /** An externally hosted video. */
  ExternalVideo = 'EXTERNAL_VIDEO',
  /** A Shopify hosted image. */
  Image = 'IMAGE',
  /** A 3d model. */
  Model_3D = 'MODEL_3D',
  /** A Shopify hosted video. */
  Video = 'VIDEO',
}

/**
 * An auto-generated type which holds one Media and a cursor during pagination.
 *
 */
export type ShopifyGenMediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MediaEdge. */
  node: ShopifyGenMedia;
};

/** Host for a Media Resource. */
export enum ShopifyGenMediaHost {
  /** Host for Vimeo embedded videos. */
  Vimeo = 'VIMEO',
  /** Host for YouTube embedded videos. */
  Youtube = 'YOUTUBE',
}

/** Represents a Shopify hosted image. */
export type ShopifyGenMediaImage = ShopifyGenMedia &
  ShopifyGenNode & {
    __typename?: 'MediaImage';
    /** A word or phrase to share the nature or contents of a media. */
    alt?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The image for the media. */
    image?: Maybe<ShopifyGenImage>;
    /** The media content type. */
    mediaContentType: ShopifyGenMediaContentType;
    /** The presentation for a media. */
    presentation?: Maybe<ShopifyGenMediaPresentation>;
    /** The preview image for the media. */
    previewImage?: Maybe<ShopifyGenImage>;
  };

/** A media presentation. */
export type ShopifyGenMediaPresentation = ShopifyGenNode & {
  __typename?: 'MediaPresentation';
  /** A JSON object representing a presentation view. */
  asJson?: Maybe<Scalars['JSON']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** A media presentation. */
export type ShopifyGenMediaPresentationAsJsonArgs = {
  format: ShopifyGenMediaPresentationFormat;
};

/** The possible formats for a media presentation. */
export enum ShopifyGenMediaPresentationFormat {
  /** A media image presentation. */
  Image = 'IMAGE',
  /** A model viewer presentation. */
  ModelViewer = 'MODEL_VIEWER',
}

/**
 * A [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) representing a hierarchy
 * of hyperlinks (items).
 *
 */
export type ShopifyGenMenu = ShopifyGenNode & {
  __typename?: 'Menu';
  /** The menu's handle. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The menu's child items. */
  items: Array<ShopifyGenMenuItem>;
  /** The count of items on the menu. */
  itemsCount: Scalars['Int']['output'];
  /** The menu's title. */
  title: Scalars['String']['output'];
};

/** A menu item within a parent menu. */
export type ShopifyGenMenuItem = ShopifyGenNode & {
  __typename?: 'MenuItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The menu item's child items. */
  items: Array<ShopifyGenMenuItem>;
  /** The linked resource. */
  resource?: Maybe<ShopifyGenMenuItemResource>;
  /** The ID of the linked resource. */
  resourceId?: Maybe<Scalars['ID']['output']>;
  /** The menu item's tags to filter a collection. */
  tags: Array<Scalars['String']['output']>;
  /** The menu item's title. */
  title: Scalars['String']['output'];
  /** The menu item's type. */
  type: ShopifyGenMenuItemType;
  /** The menu item's URL. */
  url?: Maybe<Scalars['URL']['output']>;
};

/**
 * The list of possible resources a `MenuItem` can reference.
 *
 */
export type ShopifyGenMenuItemResource =
  | ShopifyGenArticle
  | ShopifyGenBlog
  | ShopifyGenCollection
  | ShopifyGenMetaobject
  | ShopifyGenPage
  | ShopifyGenProduct
  | ShopifyGenShopPolicy;

/** A menu item type. */
export enum ShopifyGenMenuItemType {
  /** An article link. */
  Article = 'ARTICLE',
  /** A blog link. */
  Blog = 'BLOG',
  /** A catalog link. */
  Catalog = 'CATALOG',
  /** A collection link. */
  Collection = 'COLLECTION',
  /** A collection link. */
  Collections = 'COLLECTIONS',
  /** A customer account page link. */
  CustomerAccountPage = 'CUSTOMER_ACCOUNT_PAGE',
  /** A frontpage link. */
  Frontpage = 'FRONTPAGE',
  /** An http link. */
  Http = 'HTTP',
  /** A metaobject page link. */
  Metaobject = 'METAOBJECT',
  /** A page link. */
  Page = 'PAGE',
  /** A product link. */
  Product = 'PRODUCT',
  /** A search link. */
  Search = 'SEARCH',
  /** A shop policy link. */
  ShopPolicy = 'SHOP_POLICY',
}

/** The merchandise to be purchased at checkout. */
export type ShopifyGenMerchandise = ShopifyGenProductVariant;

/**
 * Metafields represent custom metadata attached to a resource. Metafields can be sorted into namespaces and are
 * comprised of keys, values, and value types.
 *
 */
export type ShopifyGenMetafield = ShopifyGenNode & {
  __typename?: 'Metafield';
  /** The date and time when the storefront metafield was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of a metafield. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield within its namespace. */
  key: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield is associated with. */
  namespace: Scalars['String']['output'];
  /** The type of resource that the metafield is attached to. */
  parentResource: ShopifyGenMetafieldParentResource;
  /** Returns a reference object if the metafield's type is a resource reference. */
  reference?: Maybe<ShopifyGenMetafieldReference>;
  /** A list of reference objects if the metafield's type is a resource reference list. */
  references?: Maybe<ShopifyGenMetafieldReferenceConnection>;
  /**
   * The type name of the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).
   *
   */
  type: Scalars['String']['output'];
  /** The date and time when the metafield was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  value: Scalars['String']['output'];
};

/**
 * Metafields represent custom metadata attached to a resource. Metafields can be sorted into namespaces and are
 * comprised of keys, values, and value types.
 *
 */
export type ShopifyGenMetafieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible error codes that can be returned by `MetafieldDeleteUserError`. */
export enum ShopifyGenMetafieldDeleteErrorCode {
  /** The owner ID is invalid. */
  InvalidOwner = 'INVALID_OWNER',
  /** Metafield not found. */
  MetafieldDoesNotExist = 'METAFIELD_DOES_NOT_EXIST',
}

/** An error that occurs during the execution of cart metafield deletion. */
export type ShopifyGenMetafieldDeleteUserError = ShopifyGenDisplayableError & {
  __typename?: 'MetafieldDeleteUserError';
  /** The error code. */
  code?: Maybe<ShopifyGenMetafieldDeleteErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * A filter used to view a subset of products in a collection matching a specific metafield value.
 *
 * Only the following metafield types are currently supported:
 * - `number_integer`
 * - `number_decimal`
 * - `single_line_text_field`
 * - `boolean` as of 2022-04.
 *
 */
export type ShopifyGenMetafieldFilter = {
  /** The key of the metafield to filter on. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield to filter on. */
  namespace: Scalars['String']['input'];
  /** The value of the metafield. */
  value: Scalars['String']['input'];
};

/** A resource that the metafield belongs to. */
export type ShopifyGenMetafieldParentResource =
  | ShopifyGenArticle
  | ShopifyGenBlog
  | ShopifyGenCart
  | ShopifyGenCollection
  | ShopifyGenCompany
  | ShopifyGenCompanyLocation
  | ShopifyGenCustomer
  | ShopifyGenLocation
  | ShopifyGenMarket
  | ShopifyGenOrder
  | ShopifyGenPage
  | ShopifyGenProduct
  | ShopifyGenProductVariant
  | ShopifyGenSellingPlan
  | ShopifyGenShop;

/**
 * Returns the resource which is being referred to by a metafield.
 *
 */
export type ShopifyGenMetafieldReference =
  | ShopifyGenCollection
  | ShopifyGenGenericFile
  | ShopifyGenMediaImage
  | ShopifyGenMetaobject
  | ShopifyGenModel3d
  | ShopifyGenPage
  | ShopifyGenProduct
  | ShopifyGenProductVariant
  | ShopifyGenVideo;

/**
 * An auto-generated type for paginating through multiple MetafieldReferences.
 *
 */
export type ShopifyGenMetafieldReferenceConnection = {
  __typename?: 'MetafieldReferenceConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenMetafieldReferenceEdge>;
  /** A list of the nodes contained in MetafieldReferenceEdge. */
  nodes: Array<ShopifyGenMetafieldReference>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one MetafieldReference and a cursor during pagination.
 *
 */
export type ShopifyGenMetafieldReferenceEdge = {
  __typename?: 'MetafieldReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldReferenceEdge. */
  node: ShopifyGenMetafieldReference;
};

/** An error that occurs during the execution of `MetafieldsSet`. */
export type ShopifyGenMetafieldsSetUserError = ShopifyGenDisplayableError & {
  __typename?: 'MetafieldsSetUserError';
  /** The error code. */
  code?: Maybe<ShopifyGenMetafieldsSetUserErrorCode>;
  /** The index of the array element that's causing the error. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldsSetUserError`. */
export enum ShopifyGenMetafieldsSetUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The owner ID is invalid. */
  InvalidOwner = 'INVALID_OWNER',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for metafield type or for definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
}

/** An instance of a user-defined model based on a MetaobjectDefinition. */
export type ShopifyGenMetaobject = ShopifyGenNode &
  ShopifyGenOnlineStorePublishable & {
    __typename?: 'Metaobject';
    /** Accesses a field of the object by key. */
    field?: Maybe<ShopifyGenMetaobjectField>;
    /**
     * All object fields with defined values.
     * Omitted object keys can be assumed null, and no guarantees are made about field order.
     *
     */
    fields: Array<ShopifyGenMetaobjectField>;
    /** The unique handle of the metaobject. Useful as a custom ID. */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The URL used for viewing the metaobject on the shop's Online Store. Returns `null` if the metaobject definition doesn't have the `online_store` capability. */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /**
     * The metaobject's SEO information. Returns `null` if the metaobject definition
     * doesn't have the `renderable` capability.
     *
     */
    seo?: Maybe<ShopifyGenMetaobjectSeo>;
    /** The type of the metaobject. Defines the namespace of its associated metafields. */
    type: Scalars['String']['output'];
    /** The date and time when the metaobject was last updated. */
    updatedAt: Scalars['DateTime']['output'];
  };

/** An instance of a user-defined model based on a MetaobjectDefinition. */
export type ShopifyGenMetaobjectFieldArgs = {
  key: Scalars['String']['input'];
};

/**
 * An auto-generated type for paginating through multiple Metaobjects.
 *
 */
export type ShopifyGenMetaobjectConnection = {
  __typename?: 'MetaobjectConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenMetaobjectEdge>;
  /** A list of the nodes contained in MetaobjectEdge. */
  nodes: Array<ShopifyGenMetaobject>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Metaobject and a cursor during pagination.
 *
 */
export type ShopifyGenMetaobjectEdge = {
  __typename?: 'MetaobjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetaobjectEdge. */
  node: ShopifyGenMetaobject;
};

/** Provides the value of a Metaobject field. */
export type ShopifyGenMetaobjectField = {
  __typename?: 'MetaobjectField';
  /** The field key. */
  key: Scalars['String']['output'];
  /** A referenced object if the field type is a resource reference. */
  reference?: Maybe<ShopifyGenMetafieldReference>;
  /** A list of referenced objects if the field type is a resource reference list. */
  references?: Maybe<ShopifyGenMetafieldReferenceConnection>;
  /**
   * The type name of the field.
   * See the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).
   *
   */
  type: Scalars['String']['output'];
  /** The field value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Provides the value of a Metaobject field. */
export type ShopifyGenMetaobjectFieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields used to retrieve a metaobject by handle. */
export type ShopifyGenMetaobjectHandleInput = {
  /** The handle of the metaobject. */
  handle: Scalars['String']['input'];
  /** The type of the metaobject. */
  type: Scalars['String']['input'];
};

/** SEO information for a metaobject. */
export type ShopifyGenMetaobjectSeo = {
  __typename?: 'MetaobjectSEO';
  /** The meta description. */
  description?: Maybe<ShopifyGenMetaobjectField>;
  /** The SEO title. */
  title?: Maybe<ShopifyGenMetaobjectField>;
};

/** Represents a Shopify hosted 3D model. */
export type ShopifyGenModel3d = ShopifyGenMedia &
  ShopifyGenNode & {
    __typename?: 'Model3d';
    /** A word or phrase to share the nature or contents of a media. */
    alt?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The media content type. */
    mediaContentType: ShopifyGenMediaContentType;
    /** The presentation for a media. */
    presentation?: Maybe<ShopifyGenMediaPresentation>;
    /** The preview image for the media. */
    previewImage?: Maybe<ShopifyGenImage>;
    /** The sources for a 3d model. */
    sources: Array<ShopifyGenModel3dSource>;
  };

/** Represents a source for a Shopify hosted 3d model. */
export type ShopifyGenModel3dSource = {
  __typename?: 'Model3dSource';
  /** The filesize of the 3d model. */
  filesize: Scalars['Int']['output'];
  /** The format of the 3d model. */
  format: Scalars['String']['output'];
  /** The MIME type of the 3d model. */
  mimeType: Scalars['String']['output'];
  /** The URL of the 3d model. */
  url: Scalars['String']['output'];
};

/** The input fields for a monetary value with currency. */
export type ShopifyGenMoneyInput = {
  /** Decimal money amount. */
  amount: Scalars['Decimal']['input'];
  /** Currency of the money. */
  currencyCode: ShopifyGenCurrencyCode;
};

/**
 * A monetary value with currency.
 *
 */
export type ShopifyGenMoneyV2 = {
  __typename?: 'MoneyV2';
  /** Decimal money amount. */
  amount: Scalars['Decimal']['output'];
  /** Currency of the money. */
  currencyCode: ShopifyGenCurrencyCode;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutation = {
  __typename?: 'Mutation';
  /** Updates the attributes on a cart. */
  cartAttributesUpdate?: Maybe<ShopifyGenCartAttributesUpdatePayload>;
  /** Updates the billing address on the cart. */
  cartBillingAddressUpdate?: Maybe<ShopifyGenCartBillingAddressUpdatePayload>;
  /**
   * Updates customer information associated with a cart.
   * Buyer identity is used to determine
   * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
   * and should match the customer's shipping address.
   *
   */
  cartBuyerIdentityUpdate?: Maybe<ShopifyGenCartBuyerIdentityUpdatePayload>;
  /** Creates a new cart. */
  cartCreate?: Maybe<ShopifyGenCartCreatePayload>;
  /** Adds delivery addresses to the cart. */
  cartDeliveryAddressesAdd?: Maybe<ShopifyGenCartDeliveryAddressesAddPayload>;
  /** Removes delivery addresses from the cart. */
  cartDeliveryAddressesRemove?: Maybe<ShopifyGenCartDeliveryAddressesRemovePayload>;
  /** Updates one or more delivery addresses on a cart. */
  cartDeliveryAddressesUpdate?: Maybe<ShopifyGenCartDeliveryAddressesUpdatePayload>;
  /** Updates the discount codes applied to the cart. */
  cartDiscountCodesUpdate?: Maybe<ShopifyGenCartDiscountCodesUpdatePayload>;
  /** Removes the gift card codes applied to the cart. */
  cartGiftCardCodesRemove?: Maybe<ShopifyGenCartGiftCardCodesRemovePayload>;
  /** Updates the gift card codes applied to the cart. */
  cartGiftCardCodesUpdate?: Maybe<ShopifyGenCartGiftCardCodesUpdatePayload>;
  /** Adds a merchandise line to the cart. */
  cartLinesAdd?: Maybe<ShopifyGenCartLinesAddPayload>;
  /** Removes one or more merchandise lines from the cart. */
  cartLinesRemove?: Maybe<ShopifyGenCartLinesRemovePayload>;
  /** Updates one or more merchandise lines on a cart. */
  cartLinesUpdate?: Maybe<ShopifyGenCartLinesUpdatePayload>;
  /** Deletes a cart metafield. */
  cartMetafieldDelete?: Maybe<ShopifyGenCartMetafieldDeletePayload>;
  /**
   * Sets cart metafield values. Cart metafield values will be set regardless if they were previously created or not.
   *
   * Allows a maximum of 25 cart metafields to be set at a time.
   *
   */
  cartMetafieldsSet?: Maybe<ShopifyGenCartMetafieldsSetPayload>;
  /** Updates the note on the cart. */
  cartNoteUpdate?: Maybe<ShopifyGenCartNoteUpdatePayload>;
  /** Update the customer's payment method that will be used to checkout. */
  cartPaymentUpdate?: Maybe<ShopifyGenCartPaymentUpdatePayload>;
  /** Prepare the cart for cart checkout completion. */
  cartPrepareForCompletion?: Maybe<ShopifyGenCartPrepareForCompletionPayload>;
  /** Update the selected delivery options for a delivery group. */
  cartSelectedDeliveryOptionsUpdate?: Maybe<ShopifyGenCartSelectedDeliveryOptionsUpdatePayload>;
  /** Submit the cart for checkout completion. */
  cartSubmitForCompletion?: Maybe<ShopifyGenCartSubmitForCompletionPayload>;
  /**
   * Creates a customer access token.
   * The customer access token is required to modify the customer object in any way.
   *
   */
  customerAccessTokenCreate?: Maybe<ShopifyGenCustomerAccessTokenCreatePayload>;
  /**
   * Creates a customer access token using a
   * [multipass token](https://shopify.dev/api/multipass) instead of email and
   * password. A customer record is created if the customer doesn't exist. If a customer
   * record already exists but the record is disabled, then the customer record is enabled.
   *
   */
  customerAccessTokenCreateWithMultipass?: Maybe<ShopifyGenCustomerAccessTokenCreateWithMultipassPayload>;
  /** Permanently destroys a customer access token. */
  customerAccessTokenDelete?: Maybe<ShopifyGenCustomerAccessTokenDeletePayload>;
  /**
   * Renews a customer access token.
   *
   * Access token renewal must happen *before* a token expires.
   * If a token has already expired, a new one should be created instead via `customerAccessTokenCreate`.
   *
   */
  customerAccessTokenRenew?: Maybe<ShopifyGenCustomerAccessTokenRenewPayload>;
  /** Activates a customer. */
  customerActivate?: Maybe<ShopifyGenCustomerActivatePayload>;
  /** Activates a customer with the activation url received from `customerCreate`. */
  customerActivateByUrl?: Maybe<ShopifyGenCustomerActivateByUrlPayload>;
  /** Creates a new address for a customer. */
  customerAddressCreate?: Maybe<ShopifyGenCustomerAddressCreatePayload>;
  /** Permanently deletes the address of an existing customer. */
  customerAddressDelete?: Maybe<ShopifyGenCustomerAddressDeletePayload>;
  /** Updates the address of an existing customer. */
  customerAddressUpdate?: Maybe<ShopifyGenCustomerAddressUpdatePayload>;
  /** Creates a new customer. */
  customerCreate?: Maybe<ShopifyGenCustomerCreatePayload>;
  /** Updates the default address of an existing customer. */
  customerDefaultAddressUpdate?: Maybe<ShopifyGenCustomerDefaultAddressUpdatePayload>;
  /**
   * Sends a reset password email to the customer. The reset password
   * email contains a reset password URL and token that you can pass to
   * the [`customerResetByUrl`](https://shopify.dev/api/storefront/latest/mutations/customerResetByUrl) or
   * [`customerReset`](https://shopify.dev/api/storefront/latest/mutations/customerReset) mutation to reset the
   * customer password.
   *
   * This mutation is throttled by IP. With private access,
   * you can provide a [`Shopify-Storefront-Buyer-IP`](https://shopify.dev/api/usage/authentication#optional-ip-header) instead of the request IP.
   * The header is case-sensitive and must be sent as `Shopify-Storefront-Buyer-IP`.
   *
   * Make sure that the value provided to `Shopify-Storefront-Buyer-IP` is trusted. Unthrottled access to this
   * mutation presents a security risk.
   *
   */
  customerRecover?: Maybe<ShopifyGenCustomerRecoverPayload>;
  /**
   * "Resets a customer’s password with the token received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."
   *
   */
  customerReset?: Maybe<ShopifyGenCustomerResetPayload>;
  /**
   * "Resets a customer’s password with the reset password URL received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."
   *
   */
  customerResetByUrl?: Maybe<ShopifyGenCustomerResetByUrlPayload>;
  /** Updates an existing customer. */
  customerUpdate?: Maybe<ShopifyGenCustomerUpdatePayload>;
  /** Create a new Shop Pay payment request session. */
  shopPayPaymentRequestSessionCreate?: Maybe<ShopifyGenShopPayPaymentRequestSessionCreatePayload>;
  /** Submits a Shop Pay payment request session. */
  shopPayPaymentRequestSessionSubmit?: Maybe<ShopifyGenShopPayPaymentRequestSessionSubmitPayload>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartAttributesUpdateArgs = {
  attributes: Array<ShopifyGenAttributeInput>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartBillingAddressUpdateArgs = {
  billingAddress?: InputMaybe<ShopifyGenMailingAddressInput>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartBuyerIdentityUpdateArgs = {
  buyerIdentity: ShopifyGenCartBuyerIdentityInput;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartCreateArgs = {
  input?: InputMaybe<ShopifyGenCartInput>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartDeliveryAddressesAddArgs = {
  addresses: Array<ShopifyGenCartSelectableAddressInput>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartDeliveryAddressesRemoveArgs = {
  addressIds: Array<Scalars['ID']['input']>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartDeliveryAddressesUpdateArgs = {
  addresses: Array<ShopifyGenCartSelectableAddressUpdateInput>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartDiscountCodesUpdateArgs = {
  cartId: Scalars['ID']['input'];
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartGiftCardCodesRemoveArgs = {
  appliedGiftCardIds: Array<Scalars['ID']['input']>;
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartGiftCardCodesUpdateArgs = {
  cartId: Scalars['ID']['input'];
  giftCardCodes: Array<Scalars['String']['input']>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartLinesAddArgs = {
  cartId: Scalars['ID']['input'];
  lines: Array<ShopifyGenCartLineInput>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartLinesRemoveArgs = {
  cartId: Scalars['ID']['input'];
  lineIds: Array<Scalars['ID']['input']>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartLinesUpdateArgs = {
  cartId: Scalars['ID']['input'];
  lines: Array<ShopifyGenCartLineUpdateInput>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartMetafieldDeleteArgs = {
  input: ShopifyGenCartMetafieldDeleteInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartMetafieldsSetArgs = {
  metafields: Array<ShopifyGenCartMetafieldsSetInput>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartNoteUpdateArgs = {
  cartId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartPaymentUpdateArgs = {
  cartId: Scalars['ID']['input'];
  payment: ShopifyGenCartPaymentInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartPrepareForCompletionArgs = {
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartSelectedDeliveryOptionsUpdateArgs = {
  cartId: Scalars['ID']['input'];
  selectedDeliveryOptions: Array<ShopifyGenCartSelectedDeliveryOptionInput>;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCartSubmitForCompletionArgs = {
  attemptToken: Scalars['String']['input'];
  cartId: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAccessTokenCreateArgs = {
  input: ShopifyGenCustomerAccessTokenCreateInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAccessTokenCreateWithMultipassArgs = {
  multipassToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAccessTokenDeleteArgs = {
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAccessTokenRenewArgs = {
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerActivateArgs = {
  id: Scalars['ID']['input'];
  input: ShopifyGenCustomerActivateInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerActivateByUrlArgs = {
  activationUrl: Scalars['URL']['input'];
  password: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAddressCreateArgs = {
  address: ShopifyGenMailingAddressInput;
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAddressDeleteArgs = {
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerAddressUpdateArgs = {
  address: ShopifyGenMailingAddressInput;
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerCreateArgs = {
  input: ShopifyGenCustomerCreateInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerDefaultAddressUpdateArgs = {
  addressId: Scalars['ID']['input'];
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerRecoverArgs = {
  email: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerResetArgs = {
  id: Scalars['ID']['input'];
  input: ShopifyGenCustomerResetInput;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerResetByUrlArgs = {
  password: Scalars['String']['input'];
  resetUrl: Scalars['URL']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationCustomerUpdateArgs = {
  customer: ShopifyGenCustomerUpdateInput;
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationShopPayPaymentRequestSessionCreateArgs = {
  paymentRequest: ShopifyGenShopPayPaymentRequestInput;
  sourceIdentifier: Scalars['String']['input'];
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type ShopifyGenMutationShopPayPaymentRequestSessionSubmitArgs = {
  idempotencyKey: Scalars['String']['input'];
  orderName?: InputMaybe<Scalars['String']['input']>;
  paymentRequest: ShopifyGenShopPayPaymentRequestInput;
  token: Scalars['String']['input'];
};

/**
 * An object with an ID field to support global identification, in accordance with the
 * [Relay specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface).
 * This interface is used by the [node](/docs/api/storefront/latest/queries/node)
 * and [nodes](/docs/api/storefront/latest/queries/nodes) queries.
 *
 */
export type ShopifyGenNode = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Represents a resource that can be published to the Online Store sales channel. */
export type ShopifyGenOnlineStorePublishable = {
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrder = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Order';
    /** The address associated with the payment method. */
    billingAddress?: Maybe<ShopifyGenMailingAddress>;
    /** The reason for the order's cancellation. Returns `null` if the order wasn't canceled. */
    cancelReason?: Maybe<ShopifyGenOrderCancelReason>;
    /** The date and time when the order was canceled. Returns null if the order wasn't canceled. */
    canceledAt?: Maybe<Scalars['DateTime']['output']>;
    /** The code of the currency used for the payment. */
    currencyCode: ShopifyGenCurrencyCode;
    /** The subtotal of line items and their discounts, excluding line items that have been removed. Does not contain order-level discounts, duties, shipping costs, or shipping discounts. Taxes aren't included unless the order is a taxes-included order. */
    currentSubtotalPrice: ShopifyGenMoneyV2;
    /** The total cost of duties for the order, including refunds. */
    currentTotalDuties?: Maybe<ShopifyGenMoneyV2>;
    /** The total amount of the order, including duties, taxes and discounts, minus amounts for line items that have been removed. */
    currentTotalPrice: ShopifyGenMoneyV2;
    /** The total cost of shipping, excluding shipping lines that have been refunded or removed. Taxes aren't included unless the order is a taxes-included order. */
    currentTotalShippingPrice: ShopifyGenMoneyV2;
    /** The total of all taxes applied to the order, excluding taxes for returned line items. */
    currentTotalTax: ShopifyGenMoneyV2;
    /** A list of the custom attributes added to the order. For example, whether an order is a customer's first. */
    customAttributes: Array<ShopifyGenAttribute>;
    /** The locale code in which this specific order happened. */
    customerLocale?: Maybe<Scalars['String']['output']>;
    /** The unique URL that the customer can use to access the order. */
    customerUrl?: Maybe<Scalars['URL']['output']>;
    /** Discounts that have been applied on the order. */
    discountApplications: ShopifyGenDiscountApplicationConnection;
    /** Whether the order has had any edits applied or not. */
    edited: Scalars['Boolean']['output'];
    /** The customer's email address. */
    email?: Maybe<Scalars['String']['output']>;
    /** The financial status of the order. */
    financialStatus?: Maybe<ShopifyGenOrderFinancialStatus>;
    /** The fulfillment status for the order. */
    fulfillmentStatus: ShopifyGenOrderFulfillmentStatus;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** List of the order’s line items. */
    lineItems: ShopifyGenOrderLineItemConnection;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /**
     * Unique identifier for the order that appears on the order.
     * For example, _#1000_ or _Store1001.
     *
     */
    name: Scalars['String']['output'];
    /** A unique numeric identifier for the order for use by shop owner and customer. */
    orderNumber: Scalars['Int']['output'];
    /** The total cost of duties charged at checkout. */
    originalTotalDuties?: Maybe<ShopifyGenMoneyV2>;
    /** The total price of the order before any applied edits. */
    originalTotalPrice: ShopifyGenMoneyV2;
    /** The customer's phone number for receiving SMS notifications. */
    phone?: Maybe<Scalars['String']['output']>;
    /**
     * The date and time when the order was imported.
     * This value can be set to dates in the past when importing from other systems.
     * If no value is provided, it will be auto-generated based on current date and time.
     *
     */
    processedAt: Scalars['DateTime']['output'];
    /** The address to where the order will be shipped. */
    shippingAddress?: Maybe<ShopifyGenMailingAddress>;
    /**
     * The discounts that have been allocated onto the shipping line by discount applications.
     *
     */
    shippingDiscountAllocations: Array<ShopifyGenDiscountAllocation>;
    /** The unique URL for the order's status page. */
    statusUrl: Scalars['URL']['output'];
    /** Price of the order before shipping and taxes. */
    subtotalPrice?: Maybe<ShopifyGenMoneyV2>;
    /**
     * Price of the order before duties, shipping and taxes.
     * @deprecated Use `subtotalPrice` instead.
     */
    subtotalPriceV2?: Maybe<ShopifyGenMoneyV2>;
    /** List of the order’s successful fulfillments. */
    successfulFulfillments?: Maybe<Array<ShopifyGenFulfillment>>;
    /** The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive). */
    totalPrice: ShopifyGenMoneyV2;
    /**
     * The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive).
     * @deprecated Use `totalPrice` instead.
     */
    totalPriceV2: ShopifyGenMoneyV2;
    /** The total amount that has been refunded. */
    totalRefunded: ShopifyGenMoneyV2;
    /**
     * The total amount that has been refunded.
     * @deprecated Use `totalRefunded` instead.
     */
    totalRefundedV2: ShopifyGenMoneyV2;
    /** The total cost of shipping. */
    totalShippingPrice: ShopifyGenMoneyV2;
    /**
     * The total cost of shipping.
     * @deprecated Use `totalShippingPrice` instead.
     */
    totalShippingPriceV2: ShopifyGenMoneyV2;
    /** The total cost of taxes. */
    totalTax?: Maybe<ShopifyGenMoneyV2>;
    /**
     * The total cost of taxes.
     * @deprecated Use `totalTax` instead.
     */
    totalTaxV2?: Maybe<ShopifyGenMoneyV2>;
  };

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrderDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrderMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrderMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type ShopifyGenOrderSuccessfulFulfillmentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the reason for the order's cancellation. */
export enum ShopifyGenOrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = 'CUSTOMER',
  /** Payment was declined. */
  Declined = 'DECLINED',
  /** The order was fraudulent. */
  Fraud = 'FRAUD',
  /** There was insufficient inventory. */
  Inventory = 'INVENTORY',
  /** The order was canceled for an unlisted reason. */
  Other = 'OTHER',
  /** Staff made an error. */
  Staff = 'STAFF',
}

/**
 * An auto-generated type for paginating through multiple Orders.
 *
 */
export type ShopifyGenOrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenOrderEdge>;
  /** A list of the nodes contained in OrderEdge. */
  nodes: Array<ShopifyGenOrder>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
  /** The total count of Orders. */
  totalCount: Scalars['UnsignedInt64']['output'];
};

/**
 * An auto-generated type which holds one Order and a cursor during pagination.
 *
 */
export type ShopifyGenOrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderEdge. */
  node: ShopifyGenOrder;
};

/** Represents the order's current financial status. */
export enum ShopifyGenOrderFinancialStatus {
  /** Displayed as **Authorized**. */
  Authorized = 'AUTHORIZED',
  /** Displayed as **Paid**. */
  Paid = 'PAID',
  /** Displayed as **Partially paid**. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Displayed as **Partially refunded**. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** Displayed as **Pending**. */
  Pending = 'PENDING',
  /** Displayed as **Refunded**. */
  Refunded = 'REFUNDED',
  /** Displayed as **Voided**. */
  Voided = 'VOIDED',
}

/** Represents the order's aggregated fulfillment status for display purposes. */
export enum ShopifyGenOrderFulfillmentStatus {
  /** Displayed as **Fulfilled**. All of the items in the order have been fulfilled. */
  Fulfilled = 'FULFILLED',
  /** Displayed as **In progress**. Some of the items in the order have been fulfilled, or a request for fulfillment has been sent to the fulfillment service. */
  InProgress = 'IN_PROGRESS',
  /** Displayed as **On hold**. All of the unfulfilled items in this order are on hold. */
  OnHold = 'ON_HOLD',
  /** Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status. */
  Open = 'OPEN',
  /** Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled. */
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  /** Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by "IN_PROGRESS" status. */
  PendingFulfillment = 'PENDING_FULFILLMENT',
  /** Displayed as **Restocked**. All of the items in the order have been restocked. Replaced by "UNFULFILLED" status. */
  Restocked = 'RESTOCKED',
  /** Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time. */
  Scheduled = 'SCHEDULED',
  /** Displayed as **Unfulfilled**. None of the items in the order have been fulfilled. */
  Unfulfilled = 'UNFULFILLED',
}

/** Represents a single line in an order. There is one line item for each distinct product variant. */
export type ShopifyGenOrderLineItem = {
  __typename?: 'OrderLineItem';
  /** The number of entries associated to the line item minus the items that have been removed. */
  currentQuantity: Scalars['Int']['output'];
  /** List of custom attributes associated to the line item. */
  customAttributes: Array<ShopifyGenAttribute>;
  /** The discounts that have been allocated onto the order line item by discount applications. */
  discountAllocations: Array<ShopifyGenDiscountAllocation>;
  /** The total price of the line item, including discounts, and displayed in the presentment currency. */
  discountedTotalPrice: ShopifyGenMoneyV2;
  /** The total price of the line item, not including any discounts. The total price is calculated using the original unit price multiplied by the quantity, and it's displayed in the presentment currency. */
  originalTotalPrice: ShopifyGenMoneyV2;
  /** The number of products variants associated to the line item. */
  quantity: Scalars['Int']['output'];
  /** The title of the product combined with title of the variant. */
  title: Scalars['String']['output'];
  /** The product variant object associated to the line item. */
  variant?: Maybe<ShopifyGenProductVariant>;
};

/**
 * An auto-generated type for paginating through multiple OrderLineItems.
 *
 */
export type ShopifyGenOrderLineItemConnection = {
  __typename?: 'OrderLineItemConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenOrderLineItemEdge>;
  /** A list of the nodes contained in OrderLineItemEdge. */
  nodes: Array<ShopifyGenOrderLineItem>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one OrderLineItem and a cursor during pagination.
 *
 */
export type ShopifyGenOrderLineItemEdge = {
  __typename?: 'OrderLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderLineItemEdge. */
  node: ShopifyGenOrderLineItem;
};

/** The set of valid sort keys for the Order query. */
export enum ShopifyGenOrderSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `processed_at` value. */
  ProcessedAt = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `total_price` value. */
  TotalPrice = 'TOTAL_PRICE',
}

/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type ShopifyGenPage = ShopifyGenHasMetafields &
  ShopifyGenNode &
  ShopifyGenOnlineStorePublishable &
  ShopifyGenTrackable & {
    __typename?: 'Page';
    /** The description of the page, complete with HTML formatting. */
    body: Scalars['HTML']['output'];
    /** Summary of the page body. */
    bodySummary: Scalars['String']['output'];
    /** The timestamp of the page creation. */
    createdAt: Scalars['DateTime']['output'];
    /** A human-friendly unique string for the page automatically generated from its title. */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /** The page's SEO information. */
    seo?: Maybe<ShopifyGenSeo>;
    /** The title of the page. */
    title: Scalars['String']['output'];
    /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
    trackingParameters?: Maybe<Scalars['String']['output']>;
    /** The timestamp of the latest page update. */
    updatedAt: Scalars['DateTime']['output'];
  };

/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type ShopifyGenPageMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type ShopifyGenPageMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * An auto-generated type for paginating through multiple Pages.
 *
 */
export type ShopifyGenPageConnection = {
  __typename?: 'PageConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenPageEdge>;
  /** A list of the nodes contained in PageEdge. */
  nodes: Array<ShopifyGenPage>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Page and a cursor during pagination.
 *
 */
export type ShopifyGenPageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of PageEdge. */
  node: ShopifyGenPage;
};

/**
 * Returns information about pagination in a connection, in accordance with the
 * [Relay specification](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo).
 * For more information, please read our [GraphQL Pagination Usage Guide](https://shopify.dev/api/usage/pagination-graphql).
 *
 */
export type ShopifyGenPageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last node in edges. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more pages to fetch following the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are any pages prior to the current page. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first node in edges. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The set of valid sort keys for the Page query. */
export enum ShopifyGenPageSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
}

/** Type for paginating through multiple sitemap's resources. */
export type ShopifyGenPaginatedSitemapResources = {
  __typename?: 'PaginatedSitemapResources';
  /** Whether there are more pages to fetch following the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  /**
   * List of sitemap resources for the current page.
   * Note: The number of items varies between 0 and 250 per page.
   *
   */
  items: Array<ShopifyGenSitemapResourceInterface>;
};

/** Settings related to payments. */
export type ShopifyGenPaymentSettings = {
  __typename?: 'PaymentSettings';
  /** List of the card brands which the business entity accepts. */
  acceptedCardBrands: Array<ShopifyGenCardBrand>;
  /** The url pointing to the endpoint to vault credit cards. */
  cardVaultUrl: Scalars['URL']['output'];
  /** The country where the shop is located. When multiple business entities operate within the shop, then this will represent the country of the business entity that's serving the specified buyer context. */
  countryCode: ShopifyGenCountryCode;
  /** The three-letter code for the shop's primary currency. */
  currencyCode: ShopifyGenCurrencyCode;
  /**
   * A list of enabled currencies (ISO 4217 format) that the shop accepts.
   * Merchants can enable currencies from their Shopify Payments settings in the Shopify admin.
   *
   */
  enabledPresentmentCurrencies: Array<ShopifyGenCurrencyCode>;
  /** The shop’s Shopify Payments account ID. */
  shopifyPaymentsAccountId?: Maybe<Scalars['String']['output']>;
  /** List of the digital wallets which the business entity supports. */
  supportedDigitalWallets: Array<ShopifyGenDigitalWallet>;
};

/** Decides the distribution of results. */
export enum ShopifyGenPredictiveSearchLimitScope {
  /** Return results up to limit across all types. */
  All = 'ALL',
  /** Return results up to limit per type. */
  Each = 'EACH',
}

/**
 * A predictive search result represents a list of products, collections, pages, articles, and query suggestions
 * that matches the predictive search query.
 *
 */
export type ShopifyGenPredictiveSearchResult = {
  __typename?: 'PredictiveSearchResult';
  /** The articles that match the search query. */
  articles: Array<ShopifyGenArticle>;
  /** The articles that match the search query. */
  collections: Array<ShopifyGenCollection>;
  /** The pages that match the search query. */
  pages: Array<ShopifyGenPage>;
  /** The products that match the search query. */
  products: Array<ShopifyGenProduct>;
  /** The query suggestions that are relevant to the search query. */
  queries: Array<ShopifyGenSearchQuerySuggestion>;
};

/** The types of search items to perform predictive search on. */
export enum ShopifyGenPredictiveSearchType {
  /** Returns matching articles. */
  Article = 'ARTICLE',
  /** Returns matching collections. */
  Collection = 'COLLECTION',
  /** Returns matching pages. */
  Page = 'PAGE',
  /** Returns matching products. */
  Product = 'PRODUCT',
  /** Returns matching query strings. */
  Query = 'QUERY',
}

/** The preferred delivery methods such as shipping, local pickup or through pickup points. */
export enum ShopifyGenPreferenceDeliveryMethodType {
  /** A delivery method used to let buyers collect purchases at designated locations like parcel lockers. */
  PickupPoint = 'PICKUP_POINT',
  /** A delivery method used to let buyers receive items directly from a specific location within an area. */
  PickUp = 'PICK_UP',
  /** A delivery method used to send items directly to a buyer’s specified address. */
  Shipping = 'SHIPPING',
}

/**
 * The input fields for a filter used to view a subset of products in a collection matching a specific price range.
 *
 */
export type ShopifyGenPriceRangeFilter = {
  /** The maximum price in the range. Empty indicates no max price. */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum price in the range. Defaults to zero. */
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** The value of the percentage pricing object. */
export type ShopifyGenPricingPercentageValue = {
  __typename?: 'PricingPercentageValue';
  /** The percentage value of the object. */
  percentage: Scalars['Float']['output'];
};

/** The price value (fixed or percentage) for a discount application. */
export type ShopifyGenPricingValue =
  | ShopifyGenMoneyV2
  | ShopifyGenPricingPercentageValue;

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProduct = ShopifyGenHasMetafields &
  ShopifyGenNode &
  ShopifyGenOnlineStorePublishable &
  ShopifyGenTrackable & {
    __typename?: 'Product';
    /**
     * A list of variants whose selected options differ with the provided selected options by one, ordered by variant id.
     * If selected options are not provided, adjacent variants to the first available variant is returned.
     *
     * Note that this field returns an array of variants. In most cases, the number of variants in this array will be low.
     * However, with a low number of options and a high number of values per option, the number of variants returned
     * here can be high. In such cases, it recommended to avoid using this field.
     *
     * This list of variants can be used in combination with the `options` field to build a rich variant picker that
     * includes variant availability or other variant information.
     *
     */
    adjacentVariants: Array<ShopifyGenProductVariant>;
    /** Indicates if at least one product variant is available for sale. */
    availableForSale: Scalars['Boolean']['output'];
    /** The category of a product from [Shopify's Standard Product Taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
    category?: Maybe<ShopifyGenTaxonomyCategory>;
    /** A list of [collections](/docs/api/storefront/latest/objects/Collection) that include the product. */
    collections: ShopifyGenCollectionConnection;
    /** The [compare-at price range](https://help.shopify.com/manual/products/details/product-pricing/sale-pricing) of the product in the shop's default currency. */
    compareAtPriceRange: ShopifyGenProductPriceRange;
    /** The date and time when the product was created. */
    createdAt: Scalars['DateTime']['output'];
    /** A single-line description of the product, with [HTML tags](https://developer.mozilla.org/en-US/docs/Web/HTML) removed. */
    description: Scalars['String']['output'];
    /**
     * The description of the product, with
     * HTML tags. For example, the description might include
     * bold `<strong></strong>` and italic `<i></i>` text.
     *
     */
    descriptionHtml: Scalars['HTML']['output'];
    /**
     * An encoded string containing all option value combinations
     * with a corresponding variant that is currently available for sale.
     *
     * Integers represent option and values:
     * [0,1] represents option_value at array index 0 for the option at array index 0
     *
     * `:`, `,`, ` ` and `-` are control characters.
     * `:` indicates a new option. ex: 0:1 indicates value 0 for the option in position 1, value 1 for the option in position 2.
     * `,` indicates the end of a repeated prefix, mulitple consecutive commas indicate the end of multiple repeated prefixes.
     * ` ` indicates a gap in the sequence of option values. ex: 0 4 indicates option values in position 0 and 4 are present.
     * `-` indicates a continuous range of option values. ex: 0 1-3 4
     *
     * Decoding process:
     *
     * Example options: [Size, Color, Material]
     * Example values: [[Small, Medium, Large], [Red, Blue], [Cotton, Wool]]
     * Example encoded string: "0:0:0,1:0-1,,1:0:0-1,1:1,,2:0:1,1:0,,"
     *
     * Step 1: Expand ranges into the numbers they represent: "0:0:0,1:0 1,,1:0:0 1,1:1,,2:0:1,1:0,,"
     * Step 2: Expand repeated prefixes: "0:0:0,0:1:0 1,1:0:0 1,1:1:1,2:0:1,2:1:0,"
     * Step 3: Expand shared prefixes so data is encoded as a string: "0:0:0,0:1:0,0:1:1,1:0:0,1:0:1,1:1:1,2:0:1,2:1:0,"
     * Step 4: Map to options + option values to determine existing variants:
     *
     * [Small, Red, Cotton] (0:0:0), [Small, Blue, Cotton] (0:1:0), [Small, Blue, Wool] (0:1:1),
     * [Medium, Red, Cotton] (1:0:0), [Medium, Red, Wool] (1:0:1), [Medium, Blue, Wool] (1:1:1),
     * [Large, Red, Wool] (2:0:1), [Large, Blue, Cotton] (2:1:0).
     *
     *
     */
    encodedVariantAvailability?: Maybe<Scalars['String']['output']>;
    /**
     * An encoded string containing all option value combinations with a corresponding variant.
     *
     * Integers represent option and values:
     * [0,1] represents option_value at array index 0 for the option at array index 0
     *
     * `:`, `,`, ` ` and `-` are control characters.
     * `:` indicates a new option. ex: 0:1 indicates value 0 for the option in position 1, value 1 for the option in position 2.
     * `,` indicates the end of a repeated prefix, mulitple consecutive commas indicate the end of multiple repeated prefixes.
     * ` ` indicates a gap in the sequence of option values. ex: 0 4 indicates option values in position 0 and 4 are present.
     * `-` indicates a continuous range of option values. ex: 0 1-3 4
     *
     * Decoding process:
     *
     * Example options: [Size, Color, Material]
     * Example values: [[Small, Medium, Large], [Red, Blue], [Cotton, Wool]]
     * Example encoded string: "0:0:0,1:0-1,,1:0:0-1,1:1,,2:0:1,1:0,,"
     *
     * Step 1: Expand ranges into the numbers they represent: "0:0:0,1:0 1,,1:0:0 1,1:1,,2:0:1,1:0,,"
     * Step 2: Expand repeated prefixes: "0:0:0,0:1:0 1,1:0:0 1,1:1:1,2:0:1,2:1:0,"
     * Step 3: Expand shared prefixes so data is encoded as a string: "0:0:0,0:1:0,0:1:1,1:0:0,1:0:1,1:1:1,2:0:1,2:1:0,"
     * Step 4: Map to options + option values to determine existing variants:
     *
     * [Small, Red, Cotton] (0:0:0), [Small, Blue, Cotton] (0:1:0), [Small, Blue, Wool] (0:1:1),
     * [Medium, Red, Cotton] (1:0:0), [Medium, Red, Wool] (1:0:1), [Medium, Blue, Wool] (1:1:1),
     * [Large, Red, Wool] (2:0:1), [Large, Blue, Cotton] (2:1:0).
     *
     *
     */
    encodedVariantExistence?: Maybe<Scalars['String']['output']>;
    /**
     * The featured image for the product.
     *
     * This field is functionally equivalent to `images(first: 1)`.
     *
     */
    featuredImage?: Maybe<ShopifyGenImage>;
    /**
     * A unique, human-readable string of the product's title.
     * A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
     * The handle is used in the online store URL for the product.
     *
     */
    handle: Scalars['String']['output'];
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** List of images associated with the product. */
    images: ShopifyGenImageConnection;
    /** Whether the product is a gift card. */
    isGiftCard: Scalars['Boolean']['output'];
    /** The [media](/docs/apps/build/online-store/product-media) that are associated with the product. Valid media are images, 3D models, videos. */
    media: ShopifyGenMediaConnection;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /**
     * The product's URL on the online store.
     * If `null`, then the product isn't published to the online store sales channel.
     *
     */
    onlineStoreUrl?: Maybe<Scalars['URL']['output']>;
    /** A list of product options. The limit is defined by the [shop's resource limits for product options](/docs/api/admin-graphql/latest/objects/Shop#field-resourcelimits) (`Shop.resourceLimits.maxProductOptions`). */
    options: Array<ShopifyGenProductOption>;
    /**
     * The minimum and maximum prices of a product, expressed in decimal numbers.
     * For example, if the product is priced between $10.00 and $50.00,
     * then the price range is $10.00 - $50.00.
     *
     */
    priceRange: ShopifyGenProductPriceRange;
    /**
     * The [product type](https://help.shopify.com/manual/products/details/product-type)
     * that merchants define.
     *
     */
    productType: Scalars['String']['output'];
    /** The date and time when the product was published to the channel. */
    publishedAt: Scalars['DateTime']['output'];
    /** Whether the product can only be purchased with a [selling plan](/docs/apps/build/purchase-options/subscriptions/selling-plans). Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores. If you update a product to be subscription-only (`requiresSellingPlan:false`), then the product is unpublished from all channels, except the online store. */
    requiresSellingPlan: Scalars['Boolean']['output'];
    /**
     * Find an active product variant based on selected options, availability or the first variant.
     *
     * All arguments are optional. If no selected options are provided, the first available variant is returned.
     * If no variants are available, the first variant is returned.
     *
     */
    selectedOrFirstAvailableVariant?: Maybe<ShopifyGenProductVariant>;
    /** A list of all [selling plan groups](/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan) that are associated with the product either directly, or through the product's variants. */
    sellingPlanGroups: ShopifyGenSellingPlanGroupConnection;
    /**
     * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
     * that are associated with a product.
     *
     */
    seo: ShopifyGenSeo;
    /**
     * A comma-separated list of searchable keywords that are
     * associated with the product. For example, a merchant might apply the `sports`
     * and `summer` tags to products that are associated with sportwear for summer.
     * Updating `tags` overwrites any existing tags that were previously added to the product.
     * To add new tags without overwriting existing tags,
     * use the GraphQL Admin API's [`tagsAdd`](/docs/api/admin-graphql/latest/mutations/tagsadd)
     * mutation.
     *
     */
    tags: Array<Scalars['String']['output']>;
    /**
     * The name for the product that displays to customers. The title is used to construct the product's handle.
     * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
     *
     */
    title: Scalars['String']['output'];
    /** The quantity of inventory that's in stock. */
    totalInventory?: Maybe<Scalars['Int']['output']>;
    /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
    trackingParameters?: Maybe<Scalars['String']['output']>;
    /**
     * The date and time when the product was last modified.
     * A product's `updatedAt` value can change for different reasons. For example, if an order
     * is placed for a product that has inventory tracking set up, then the inventory adjustment
     * is counted as an update.
     *
     */
    updatedAt: Scalars['DateTime']['output'];
    /**
     * Find a product’s variant based on its selected options.
     * This is useful for converting a user’s selection of product options into a single matching variant.
     * If there is not a variant for the selected options, `null` will be returned.
     *
     */
    variantBySelectedOptions?: Maybe<ShopifyGenProductVariant>;
    /** A list of [variants](/docs/api/storefront/latest/objects/ProductVariant) that are associated with the product. */
    variants: ShopifyGenProductVariantConnection;
    /** The number of [variants](/docs/api/storefront/latest/objects/ProductVariant) that are associated with the product. */
    variantsCount?: Maybe<ShopifyGenCount>;
    /** The name of the product's vendor. */
    vendor: Scalars['String']['output'];
  };

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductAdjacentVariantsArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']['input']>;
  selectedOptions?: InputMaybe<Array<ShopifyGenSelectedOptionInput>>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenProductImageSortKeys>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenProductMediaSortKeys>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductSelectedOrFirstAvailableVariantArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']['input']>;
  selectedOptions?: InputMaybe<Array<ShopifyGenSelectedOptionInput>>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductVariantBySelectedOptionsArgs = {
  caseInsensitiveMatch?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreUnknownOptions?: InputMaybe<Scalars['Boolean']['input']>;
  selectedOptions: Array<ShopifyGenSelectedOptionInput>;
};

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers.
 * They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](/docs/api/storefront/latest/objects/ProductVariant)
 * to create or update different versions of the same product.
 * You can also add or update product [media](/docs/api/storefront/latest/interfaces/Media).
 * Products can be organized by grouping them into a [collection](/docs/api/storefront/latest/objects/Collection).
 *
 * Learn more about working with [products and collections](/docs/storefronts/headless/building-with-the-storefront-api/products-collections).
 *
 */
export type ShopifyGenProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenProductVariantSortKeys>;
};

/** The set of valid sort keys for the ProductCollection query. */
export enum ShopifyGenProductCollectionSortKeys {
  /** Sort by the `best-selling` value. */
  BestSelling = 'BEST_SELLING',
  /** Sort by the `collection-default` value. */
  CollectionDefault = 'COLLECTION_DEFAULT',
  /** Sort by the `created` value. */
  Created = 'CREATED',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `manual` value. */
  Manual = 'MANUAL',
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
}

/**
 * An auto-generated type for paginating through multiple Products.
 *
 */
export type ShopifyGenProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenProductEdge>;
  /** A list of available filters. */
  filters: Array<ShopifyGenFilter>;
  /** A list of the nodes contained in ProductEdge. */
  nodes: Array<ShopifyGenProduct>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one Product and a cursor during pagination.
 *
 */
export type ShopifyGenProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductEdge. */
  node: ShopifyGenProduct;
};

/**
 * The input fields for a filter used to view a subset of products in a collection.
 * By default, the `available` and `price` filters are enabled. Filters are customized with the Shopify Search & Discovery app.
 * Learn more about [customizing storefront filtering](https://help.shopify.com/manual/online-store/themes/customizing-themes/storefront-filters).
 *
 */
export type ShopifyGenProductFilter = {
  /** Filter on if the product is available for sale. */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** A product category to filter on. */
  category?: InputMaybe<ShopifyGenCategoryFilter>;
  /** A range of prices to filter with-in. */
  price?: InputMaybe<ShopifyGenPriceRangeFilter>;
  /** A product metafield to filter on. */
  productMetafield?: InputMaybe<ShopifyGenMetafieldFilter>;
  /** The product type to filter on. */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** The product vendor to filter on. */
  productVendor?: InputMaybe<Scalars['String']['input']>;
  /** A product tag to filter on. */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** A standard product attribute metafield to filter on. */
  taxonomyMetafield?: InputMaybe<ShopifyGenTaxonomyMetafieldFilter>;
  /** A variant metafield to filter on. */
  variantMetafield?: InputMaybe<ShopifyGenMetafieldFilter>;
  /** A variant option to filter on. */
  variantOption?: InputMaybe<ShopifyGenVariantOptionFilter>;
};

/** The set of valid sort keys for the ProductImage query. */
export enum ShopifyGenProductImageSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
}

/** The set of valid sort keys for the ProductMedia query. */
export enum ShopifyGenProductMediaSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
}

/**
 * Product property names like "Size", "Color", and "Material" that the customers can select.
 * Variants are selected based on permutations of these options.
 * 255 characters limit each.
 *
 */
export type ShopifyGenProductOption = ShopifyGenNode & {
  __typename?: 'ProductOption';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** The corresponding option value to the product option. */
  optionValues: Array<ShopifyGenProductOptionValue>;
  /**
   * The corresponding value to the product option name.
   * @deprecated Use `optionValues` instead.
   */
  values: Array<Scalars['String']['output']>;
};

/**
 * The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option.
 *
 */
export type ShopifyGenProductOptionValue = ShopifyGenNode & {
  __typename?: 'ProductOptionValue';
  /**
   * The product variant that combines this option value with the
   * lowest-position option values for all other options.
   *
   * This field will always return a variant, provided a variant including this option value exists.
   *
   */
  firstSelectableVariant?: Maybe<ShopifyGenProductVariant>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the product option value. */
  name: Scalars['String']['output'];
  /** The swatch of the product option value. */
  swatch?: Maybe<ShopifyGenProductOptionValueSwatch>;
};

/**
 * The product option value swatch.
 *
 */
export type ShopifyGenProductOptionValueSwatch = {
  __typename?: 'ProductOptionValueSwatch';
  /** The swatch color. */
  color?: Maybe<Scalars['Color']['output']>;
  /** The swatch image. */
  image?: Maybe<ShopifyGenMedia>;
};

/** The price range of the product. */
export type ShopifyGenProductPriceRange = {
  __typename?: 'ProductPriceRange';
  /** The highest variant's price. */
  maxVariantPrice: ShopifyGenMoneyV2;
  /** The lowest variant's price. */
  minVariantPrice: ShopifyGenMoneyV2;
};

/**
 * The recommendation intent that is used to generate product recommendations.
 * You can use intent to generate product recommendations according to different strategies.
 *
 */
export enum ShopifyGenProductRecommendationIntent {
  /** Offer customers products that are complementary to a product for which recommendations are to be fetched. An example is add-on products that display in a Pair it with section. */
  Complementary = 'COMPLEMENTARY',
  /** Offer customers a mix of products that are similar or complementary to a product for which recommendations are to be fetched. An example is substitutable products that display in a You may also like section. */
  Related = 'RELATED',
}

/** The set of valid sort keys for the Product query. */
export enum ShopifyGenProductSortKeys {
  /** Sort by the `best_selling` value. */
  BestSelling = 'BEST_SELLING',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /** Sort by the `product_type` value. */
  ProductType = 'PRODUCT_TYPE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  Vendor = 'VENDOR',
}

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariant = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'ProductVariant';
    /** Indicates if the product variant is available for sale. */
    availableForSale: Scalars['Boolean']['output'];
    /** The barcode (for example, ISBN, UPC, or GTIN) associated with the variant. */
    barcode?: Maybe<Scalars['String']['output']>;
    /** The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPrice` is higher than `price`. */
    compareAtPrice?: Maybe<ShopifyGenMoneyV2>;
    /**
     * The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPriceV2` is higher than `priceV2`.
     * @deprecated Use `compareAtPrice` instead.
     */
    compareAtPriceV2?: Maybe<ShopifyGenMoneyV2>;
    /**
     * List of bundles components included in the variant considering only fixed bundles.
     *
     */
    components: ShopifyGenProductVariantComponentConnection;
    /** Whether a product is out of stock but still available for purchase (used for backorders). */
    currentlyNotInStock: Scalars['Boolean']['output'];
    /**
     * List of bundles that include this variant considering only fixed bundles.
     *
     */
    groupedBy: ShopifyGenProductVariantConnection;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** Image associated with the product variant. This field falls back to the product image if no image is available. */
    image?: Maybe<ShopifyGenImage>;
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** The product variant’s price. */
    price: ShopifyGenMoneyV2;
    /**
     * The product variant’s price.
     * @deprecated Use `price` instead.
     */
    priceV2: ShopifyGenMoneyV2;
    /** The product object that the product variant belongs to. */
    product: ShopifyGenProduct;
    /** The total sellable quantity of the variant for online sales channels. */
    quantityAvailable?: Maybe<Scalars['Int']['output']>;
    /** A list of quantity breaks for the product variant. */
    quantityPriceBreaks: ShopifyGenQuantityPriceBreakConnection;
    /** The quantity rule for the product variant in a given context. */
    quantityRule: ShopifyGenQuantityRule;
    /**
     * Whether a product variant requires components. The default value is `false`.
     * If `true`, then the product variant can only be purchased as a parent bundle with components.
     *
     */
    requiresComponents: Scalars['Boolean']['output'];
    /** Whether a customer needs to provide a shipping address when placing an order for the product variant. */
    requiresShipping: Scalars['Boolean']['output'];
    /** List of product options applied to the variant. */
    selectedOptions: Array<ShopifyGenSelectedOption>;
    /** Represents an association between a variant and a selling plan. Selling plan allocations describe which selling plans are available for each variant, and what their impact is on pricing. */
    sellingPlanAllocations: ShopifyGenSellingPlanAllocationConnection;
    /** The Shop Pay Installments pricing information for the product variant. */
    shopPayInstallmentsPricing?: Maybe<ShopifyGenShopPayInstallmentsProductVariantPricing>;
    /** The SKU (stock keeping unit) associated with the variant. */
    sku?: Maybe<Scalars['String']['output']>;
    /** The in-store pickup availability of this variant by location. */
    storeAvailability: ShopifyGenStoreAvailabilityConnection;
    /** Whether tax is charged when the product variant is sold. */
    taxable: Scalars['Boolean']['output'];
    /** The product variant’s title. */
    title: Scalars['String']['output'];
    /** The unit price value for the variant based on the variant's measurement. */
    unitPrice?: Maybe<ShopifyGenMoneyV2>;
    /** The unit price measurement for the variant. */
    unitPriceMeasurement?: Maybe<ShopifyGenUnitPriceMeasurement>;
    /** The weight of the product variant in the unit system specified with `weight_unit`. */
    weight?: Maybe<Scalars['Float']['output']>;
    /** Unit of measurement for weight. */
    weightUnit: ShopifyGenWeightUnit;
  };

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantGroupedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantSellingPlanAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.
 *
 */
export type ShopifyGenProductVariantStoreAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  near?: InputMaybe<ShopifyGenGeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a component of a bundle variant.
 *
 */
export type ShopifyGenProductVariantComponent = {
  __typename?: 'ProductVariantComponent';
  /** The product variant object that the component belongs to. */
  productVariant: ShopifyGenProductVariant;
  /** The quantity of component present in the bundle. */
  quantity: Scalars['Int']['output'];
};

/**
 * An auto-generated type for paginating through multiple ProductVariantComponents.
 *
 */
export type ShopifyGenProductVariantComponentConnection = {
  __typename?: 'ProductVariantComponentConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenProductVariantComponentEdge>;
  /** A list of the nodes contained in ProductVariantComponentEdge. */
  nodes: Array<ShopifyGenProductVariantComponent>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one ProductVariantComponent and a cursor during pagination.
 *
 */
export type ShopifyGenProductVariantComponentEdge = {
  __typename?: 'ProductVariantComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantComponentEdge. */
  node: ShopifyGenProductVariantComponent;
};

/**
 * An auto-generated type for paginating through multiple ProductVariants.
 *
 */
export type ShopifyGenProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenProductVariantEdge>;
  /** A list of the nodes contained in ProductVariantEdge. */
  nodes: Array<ShopifyGenProductVariant>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one ProductVariant and a cursor during pagination.
 *
 */
export type ShopifyGenProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantEdge. */
  node: ShopifyGenProductVariant;
};

/** The set of valid sort keys for the ProductVariant query. */
export enum ShopifyGenProductVariantSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `sku` value. */
  Sku = 'SKU',
  /** Sort by the `title` value. */
  Title = 'TITLE',
}

/** Represents information about the buyer that is interacting with the cart. */
export type ShopifyGenPurchasingCompany = {
  __typename?: 'PurchasingCompany';
  /** The company associated to the order or draft order. */
  company: ShopifyGenCompany;
  /** The company contact associated to the order or draft order. */
  contact?: Maybe<ShopifyGenCompanyContact>;
  /** The company location associated to the order or draft order. */
  location: ShopifyGenCompanyLocation;
};

/**
 * Quantity price breaks lets you offer different rates that are based on the
 * amount of a specific variant being ordered.
 *
 */
export type ShopifyGenQuantityPriceBreak = {
  __typename?: 'QuantityPriceBreak';
  /**
   * Minimum quantity required to reach new quantity break price.
   *
   */
  minimumQuantity: Scalars['Int']['output'];
  /**
   * The price of variant after reaching the minimum quanity.
   *
   */
  price: ShopifyGenMoneyV2;
};

/**
 * An auto-generated type for paginating through multiple QuantityPriceBreaks.
 *
 */
export type ShopifyGenQuantityPriceBreakConnection = {
  __typename?: 'QuantityPriceBreakConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenQuantityPriceBreakEdge>;
  /** A list of the nodes contained in QuantityPriceBreakEdge. */
  nodes: Array<ShopifyGenQuantityPriceBreak>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one QuantityPriceBreak and a cursor during pagination.
 *
 */
export type ShopifyGenQuantityPriceBreakEdge = {
  __typename?: 'QuantityPriceBreakEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of QuantityPriceBreakEdge. */
  node: ShopifyGenQuantityPriceBreak;
};

/**
 * The quantity rule for the product variant in a given context.
 *
 */
export type ShopifyGenQuantityRule = {
  __typename?: 'QuantityRule';
  /**
   * The value that specifies the quantity increment between minimum and maximum of the rule.
   * Only quantities divisible by this value will be considered valid.
   *
   * The increment must be lower than or equal to the minimum and the maximum, and both minimum and maximum
   * must be divisible by this value.
   *
   */
  increment: Scalars['Int']['output'];
  /**
   * An optional value that defines the highest allowed quantity purchased by the customer.
   * If defined, maximum must be lower than or equal to the minimum and must be a multiple of the increment.
   *
   */
  maximum?: Maybe<Scalars['Int']['output']>;
  /**
   * The value that defines the lowest allowed quantity purchased by the customer.
   * The minimum must be a multiple of the quantity rule's increment.
   *
   */
  minimum: Scalars['Int']['output'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRoot = {
  __typename?: 'QueryRoot';
  /** Fetch a specific Article by its ID. */
  article?: Maybe<ShopifyGenArticle>;
  /** List of the shop's articles. */
  articles: ShopifyGenArticleConnection;
  /** Fetch a specific `Blog` by one of its unique attributes. */
  blog?: Maybe<ShopifyGenBlog>;
  /**
   * Find a blog by its handle.
   * @deprecated Use `blog` instead.
   */
  blogByHandle?: Maybe<ShopifyGenBlog>;
  /** List of the shop's blogs. */
  blogs: ShopifyGenBlogConnection;
  /**
   * Retrieve a cart by its ID. For more information, refer to
   * [Manage a cart with the Storefront API](https://shopify.dev/custom-storefronts/cart/manage).
   *
   */
  cart?: Maybe<ShopifyGenCart>;
  /**
   * A poll for the status of the cart checkout completion and order creation.
   *
   */
  cartCompletionAttempt?: Maybe<ShopifyGenCartCompletionAttemptResult>;
  /** Fetch a specific `Collection` by one of its unique attributes. */
  collection?: Maybe<ShopifyGenCollection>;
  /**
   * Find a collection by its handle.
   * @deprecated Use `collection` instead.
   */
  collectionByHandle?: Maybe<ShopifyGenCollection>;
  /** List of the shop’s collections. */
  collections: ShopifyGenCollectionConnection;
  /**
   * The customer associated with the given access token. Tokens are obtained by using the
   * [`customerAccessTokenCreate` mutation](https://shopify.dev/docs/api/storefront/latest/mutations/customerAccessTokenCreate).
   *
   */
  customer?: Maybe<ShopifyGenCustomer>;
  /** Returns the localized experiences configured for the shop. */
  localization: ShopifyGenLocalization;
  /**
   * List of the shop's locations that support in-store pickup.
   *
   * When sorting by distance, you must specify a location via the `near` argument.
   *
   *
   */
  locations: ShopifyGenLocationConnection;
  /** Retrieve a [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) by its handle. */
  menu?: Maybe<ShopifyGenMenu>;
  /** Fetch a specific Metaobject by one of its unique identifiers. */
  metaobject?: Maybe<ShopifyGenMetaobject>;
  /** All active metaobjects for the shop. */
  metaobjects: ShopifyGenMetaobjectConnection;
  /** Returns a specific node by ID. */
  node?: Maybe<ShopifyGenNode>;
  /** Returns the list of nodes with the given IDs. */
  nodes: Array<Maybe<ShopifyGenNode>>;
  /** Fetch a specific `Page` by one of its unique attributes. */
  page?: Maybe<ShopifyGenPage>;
  /**
   * Find a page by its handle.
   * @deprecated Use `page` instead.
   */
  pageByHandle?: Maybe<ShopifyGenPage>;
  /** List of the shop's pages. */
  pages: ShopifyGenPageConnection;
  /** Settings related to payments. */
  paymentSettings: ShopifyGenPaymentSettings;
  /** List of the predictive search results. */
  predictiveSearch?: Maybe<ShopifyGenPredictiveSearchResult>;
  /** Fetch a specific `Product` by one of its unique attributes. */
  product?: Maybe<ShopifyGenProduct>;
  /**
   * Find a product by its handle.
   * @deprecated Use `product` instead.
   */
  productByHandle?: Maybe<ShopifyGenProduct>;
  /**
   * Find recommended products related to a given `product_id`.
   * To learn more about how recommendations are generated, see
   * [*Showing product recommendations on product pages*](https://help.shopify.com/themes/development/recommended-products).
   *
   */
  productRecommendations?: Maybe<Array<ShopifyGenProduct>>;
  /**
   * Tags added to products.
   * Additional access scope required: unauthenticated_read_product_tags.
   *
   */
  productTags: ShopifyGenStringConnection;
  /** List of product types for the shop's products that are published to your app. */
  productTypes: ShopifyGenStringConnection;
  /** Returns a list of the shop's products. For storefront search, use the [`search`](https://shopify.dev/docs/api/storefront/latest/queries/search) query. */
  products: ShopifyGenProductConnection;
  /** The list of public Storefront API versions, including supported, release candidate and unstable versions. */
  publicApiVersions: Array<ShopifyGenApiVersion>;
  /** List of the search results. */
  search: ShopifyGenSearchResultItemConnection;
  /** The shop associated with the storefront access token. */
  shop: ShopifyGenShop;
  /** Contains all fields required to generate sitemaps. */
  sitemap: ShopifyGenSitemap;
  /** A list of redirects for a shop. */
  urlRedirects: ShopifyGenUrlRedirectConnection;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootArticleArgs = {
  id: Scalars['ID']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenArticleSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootBlogArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootBlogByHandleArgs = {
  handle: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootBlogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenBlogSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCartArgs = {
  id: Scalars['ID']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCartCompletionAttemptArgs = {
  attemptId: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCollectionArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCollectionByHandleArgs = {
  handle: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenCollectionSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootCustomerArgs = {
  customerAccessToken: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  near?: InputMaybe<ShopifyGenGeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenLocationSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootMenuArgs = {
  handle: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootMetaobjectArgs = {
  handle?: InputMaybe<ShopifyGenMetaobjectHandleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootNodeArgs = {
  id: Scalars['ID']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootPageArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootPageByHandleArgs = {
  handle: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenPageSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootPredictiveSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitScope?: InputMaybe<ShopifyGenPredictiveSearchLimitScope>;
  query: Scalars['String']['input'];
  searchableFields?: InputMaybe<Array<ShopifyGenSearchableField>>;
  types?: InputMaybe<Array<ShopifyGenPredictiveSearchType>>;
  unavailableProducts?: InputMaybe<ShopifyGenSearchUnavailableProductsType>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductByHandleArgs = {
  handle: Scalars['String']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductRecommendationsArgs = {
  intent?: InputMaybe<ShopifyGenProductRecommendationIntent>;
  productHandle?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductTagsArgs = {
  first: Scalars['Int']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductTypesArgs = {
  first: Scalars['Int']['input'];
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenProductSortKeys>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<ShopifyGenSearchPrefixQueryType>;
  productFilters?: InputMaybe<Array<ShopifyGenProductFilter>>;
  query: Scalars['String']['input'];
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ShopifyGenSearchSortKeys>;
  types?: InputMaybe<Array<ShopifyGenSearchType>>;
  unavailableProducts?: InputMaybe<ShopifyGenSearchUnavailableProductsType>;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootSitemapArgs = {
  type: ShopifyGenSitemapType;
};

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type ShopifyGenQueryRootUrlRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SEO information. */
export type ShopifyGenSeo = {
  __typename?: 'SEO';
  /** The meta description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The SEO title. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Script discount applications capture the intentions of a discount that
 * was created by a Shopify Script.
 *
 */
export type ShopifyGenScriptDiscountApplication =
  ShopifyGenDiscountApplication & {
    __typename?: 'ScriptDiscountApplication';
    /** The method by which the discount's value is allocated to its entitled items. */
    allocationMethod: ShopifyGenDiscountApplicationAllocationMethod;
    /** Which lines of targetType that the discount is allocated over. */
    targetSelection: ShopifyGenDiscountApplicationTargetSelection;
    /** The type of line that the discount is applicable towards. */
    targetType: ShopifyGenDiscountApplicationTargetType;
    /** The title of the application as defined by the Script. */
    title: Scalars['String']['output'];
    /** The value of the discount application. */
    value: ShopifyGenPricingValue;
  };

/** Specifies whether to perform a partial word match on the last search term. */
export enum ShopifyGenSearchPrefixQueryType {
  /** Perform a partial word match on the last search term. */
  Last = 'LAST',
  /** Don't perform a partial word match on the last search term. */
  None = 'NONE',
}

/** A search query suggestion. */
export type ShopifyGenSearchQuerySuggestion = ShopifyGenTrackable & {
  __typename?: 'SearchQuerySuggestion';
  /** The text of the search query suggestion with highlighted HTML tags. */
  styledText: Scalars['String']['output'];
  /** The text of the search query suggestion. */
  text: Scalars['String']['output'];
  /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
};

/**
 * A search result that matches the search query.
 *
 */
export type ShopifyGenSearchResultItem =
  | ShopifyGenArticle
  | ShopifyGenPage
  | ShopifyGenProduct;

/**
 * An auto-generated type for paginating through multiple SearchResultItems.
 *
 */
export type ShopifyGenSearchResultItemConnection = {
  __typename?: 'SearchResultItemConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenSearchResultItemEdge>;
  /** A list of the nodes contained in SearchResultItemEdge. */
  nodes: Array<ShopifyGenSearchResultItem>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
  /** A list of available filters. */
  productFilters: Array<ShopifyGenFilter>;
  /** The total number of results. */
  totalCount: Scalars['Int']['output'];
};

/**
 * An auto-generated type which holds one SearchResultItem and a cursor during pagination.
 *
 */
export type ShopifyGenSearchResultItemEdge = {
  __typename?: 'SearchResultItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SearchResultItemEdge. */
  node: ShopifyGenSearchResultItem;
};

/** The set of valid sort keys for the search query. */
export enum ShopifyGenSearchSortKeys {
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /** Sort by relevance to the search terms. */
  Relevance = 'RELEVANCE',
}

/** The types of search items to perform search within. */
export enum ShopifyGenSearchType {
  /** Returns matching articles. */
  Article = 'ARTICLE',
  /** Returns matching pages. */
  Page = 'PAGE',
  /** Returns matching products. */
  Product = 'PRODUCT',
}

/** Specifies whether to display results for unavailable products. */
export enum ShopifyGenSearchUnavailableProductsType {
  /** Exclude unavailable products. */
  Hide = 'HIDE',
  /** Show unavailable products after all other matching results. This is the default. */
  Last = 'LAST',
  /** Show unavailable products in the order that they're found. */
  Show = 'SHOW',
}

/** Specifies the list of resource fields to search. */
export enum ShopifyGenSearchableField {
  /** Author of the page or article. */
  Author = 'AUTHOR',
  /** Body of the page or article or product description or collection description. */
  Body = 'BODY',
  /** Product type. */
  ProductType = 'PRODUCT_TYPE',
  /** Tag associated with the product or article. */
  Tag = 'TAG',
  /** Title of the page or article or product title or collection title. */
  Title = 'TITLE',
  /** Variant barcode. */
  VariantsBarcode = 'VARIANTS_BARCODE',
  /** Variant SKU. */
  VariantsSku = 'VARIANTS_SKU',
  /** Variant title. */
  VariantsTitle = 'VARIANTS_TITLE',
  /** Product vendor. */
  Vendor = 'VENDOR',
}

/**
 * Properties used by customers to select a product variant.
 * Products can have multiple options, like different sizes or colors.
 *
 */
export type ShopifyGenSelectedOption = {
  __typename?: 'SelectedOption';
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** The product option’s value. */
  value: Scalars['String']['output'];
};

/** The input fields required for a selected option. */
export type ShopifyGenSelectedOptionInput = {
  /** The product option’s name. */
  name: Scalars['String']['input'];
  /** The product option’s value. */
  value: Scalars['String']['input'];
};

/** Represents how products and variants can be sold and purchased. */
export type ShopifyGenSellingPlan = ShopifyGenHasMetafields & {
  __typename?: 'SellingPlan';
  /** The billing policy for the selling plan. */
  billingPolicy?: Maybe<ShopifyGenSellingPlanBillingPolicy>;
  /** The initial payment due for the purchase. */
  checkoutCharge: ShopifyGenSellingPlanCheckoutCharge;
  /** The delivery policy for the selling plan. */
  deliveryPolicy?: Maybe<ShopifyGenSellingPlanDeliveryPolicy>;
  /** The description of the selling plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
  metafield?: Maybe<ShopifyGenMetafield>;
  /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
  metafields: Array<Maybe<ShopifyGenMetafield>>;
  /** The name of the selling plan. For example, '6 weeks of prepaid granola, delivered weekly'. */
  name: Scalars['String']['output'];
  /** The selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product. Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing. */
  options: Array<ShopifyGenSellingPlanOption>;
  /** The price adjustments that a selling plan makes when a variant is purchased with a selling plan. */
  priceAdjustments: Array<ShopifyGenSellingPlanPriceAdjustment>;
  /** Whether purchasing the selling plan will result in multiple deliveries. */
  recurringDeliveries: Scalars['Boolean']['output'];
};

/** Represents how products and variants can be sold and purchased. */
export type ShopifyGenSellingPlanMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Represents how products and variants can be sold and purchased. */
export type ShopifyGenSellingPlanMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** Represents an association between a variant and a selling plan. Selling plan allocations describe the options offered for each variant, and the price of the variant when purchased with a selling plan. */
export type ShopifyGenSellingPlanAllocation = {
  __typename?: 'SellingPlanAllocation';
  /** The checkout charge amount due for the purchase. */
  checkoutChargeAmount: ShopifyGenMoneyV2;
  /** A list of price adjustments, with a maximum of two. When there are two, the first price adjustment goes into effect at the time of purchase, while the second one starts after a certain number of orders. A price adjustment represents how a selling plan affects pricing when a variant is purchased with a selling plan. Prices display in the customer's currency if the shop is configured for it. */
  priceAdjustments: Array<ShopifyGenSellingPlanAllocationPriceAdjustment>;
  /** The remaining balance charge amount due for the purchase. */
  remainingBalanceChargeAmount: ShopifyGenMoneyV2;
  /** A representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'. */
  sellingPlan: ShopifyGenSellingPlan;
};

/**
 * An auto-generated type for paginating through multiple SellingPlanAllocations.
 *
 */
export type ShopifyGenSellingPlanAllocationConnection = {
  __typename?: 'SellingPlanAllocationConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenSellingPlanAllocationEdge>;
  /** A list of the nodes contained in SellingPlanAllocationEdge. */
  nodes: Array<ShopifyGenSellingPlanAllocation>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one SellingPlanAllocation and a cursor during pagination.
 *
 */
export type ShopifyGenSellingPlanAllocationEdge = {
  __typename?: 'SellingPlanAllocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanAllocationEdge. */
  node: ShopifyGenSellingPlanAllocation;
};

/** The resulting prices for variants when they're purchased with a specific selling plan. */
export type ShopifyGenSellingPlanAllocationPriceAdjustment = {
  __typename?: 'SellingPlanAllocationPriceAdjustment';
  /** The price of the variant when it's purchased without a selling plan for the same number of deliveries. For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00. */
  compareAtPrice: ShopifyGenMoneyV2;
  /** The effective price for a single delivery. For example, for a prepaid subscription plan that includes 6 deliveries at the price of $48.00, the per delivery price is $8.00. */
  perDeliveryPrice: ShopifyGenMoneyV2;
  /** The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00. */
  price: ShopifyGenMoneyV2;
  /** The resulting price per unit for the variant associated with the selling plan. If the variant isn't sold by quantity or measurement, then this field returns `null`. */
  unitPrice?: Maybe<ShopifyGenMoneyV2>;
};

/** The selling plan billing policy. */
export type ShopifyGenSellingPlanBillingPolicy =
  ShopifyGenSellingPlanRecurringBillingPolicy;

/** The initial payment due for the purchase. */
export type ShopifyGenSellingPlanCheckoutCharge = {
  __typename?: 'SellingPlanCheckoutCharge';
  /** The charge type for the checkout charge. */
  type: ShopifyGenSellingPlanCheckoutChargeType;
  /** The charge value for the checkout charge. */
  value: ShopifyGenSellingPlanCheckoutChargeValue;
};

/** The percentage value of the price used for checkout charge. */
export type ShopifyGenSellingPlanCheckoutChargePercentageValue = {
  __typename?: 'SellingPlanCheckoutChargePercentageValue';
  /** The percentage value of the price used for checkout charge. */
  percentage: Scalars['Float']['output'];
};

/** The checkout charge when the full amount isn't charged at checkout. */
export enum ShopifyGenSellingPlanCheckoutChargeType {
  /** The checkout charge is a percentage of the product or variant price. */
  Percentage = 'PERCENTAGE',
  /** The checkout charge is a fixed price amount. */
  Price = 'PRICE',
}

/** The portion of the price to be charged at checkout. */
export type ShopifyGenSellingPlanCheckoutChargeValue =
  | ShopifyGenMoneyV2
  | ShopifyGenSellingPlanCheckoutChargePercentageValue;

/**
 * An auto-generated type for paginating through multiple SellingPlans.
 *
 */
export type ShopifyGenSellingPlanConnection = {
  __typename?: 'SellingPlanConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenSellingPlanEdge>;
  /** A list of the nodes contained in SellingPlanEdge. */
  nodes: Array<ShopifyGenSellingPlan>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/** The selling plan delivery policy. */
export type ShopifyGenSellingPlanDeliveryPolicy =
  ShopifyGenSellingPlanRecurringDeliveryPolicy;

/**
 * An auto-generated type which holds one SellingPlan and a cursor during pagination.
 *
 */
export type ShopifyGenSellingPlanEdge = {
  __typename?: 'SellingPlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanEdge. */
  node: ShopifyGenSellingPlan;
};

/** A fixed amount that's deducted from the original variant price. For example, $10.00 off. */
export type ShopifyGenSellingPlanFixedAmountPriceAdjustment = {
  __typename?: 'SellingPlanFixedAmountPriceAdjustment';
  /** The money value of the price adjustment. */
  adjustmentAmount: ShopifyGenMoneyV2;
};

/** A fixed price adjustment for a variant that's purchased with a selling plan. */
export type ShopifyGenSellingPlanFixedPriceAdjustment = {
  __typename?: 'SellingPlanFixedPriceAdjustment';
  /** A new price of the variant when it's purchased with the selling plan. */
  price: ShopifyGenMoneyV2;
};

/** Represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans. */
export type ShopifyGenSellingPlanGroup = {
  __typename?: 'SellingPlanGroup';
  /** A display friendly name for the app that created the selling plan group. */
  appName?: Maybe<Scalars['String']['output']>;
  /** The name of the selling plan group. */
  name: Scalars['String']['output'];
  /** Represents the selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product. */
  options: Array<ShopifyGenSellingPlanGroupOption>;
  /** A list of selling plans in a selling plan group. A selling plan is a representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'. */
  sellingPlans: ShopifyGenSellingPlanConnection;
};

/** Represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans. */
export type ShopifyGenSellingPlanGroupSellingPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple SellingPlanGroups.
 *
 */
export type ShopifyGenSellingPlanGroupConnection = {
  __typename?: 'SellingPlanGroupConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenSellingPlanGroupEdge>;
  /** A list of the nodes contained in SellingPlanGroupEdge. */
  nodes: Array<ShopifyGenSellingPlanGroup>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one SellingPlanGroup and a cursor during pagination.
 *
 */
export type ShopifyGenSellingPlanGroupEdge = {
  __typename?: 'SellingPlanGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanGroupEdge. */
  node: ShopifyGenSellingPlanGroup;
};

/**
 * Represents an option on a selling plan group that's available in the drop-down list in the storefront.
 *
 * Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing.
 */
export type ShopifyGenSellingPlanGroupOption = {
  __typename?: 'SellingPlanGroupOption';
  /** The name of the option. For example, 'Delivery every'. */
  name: Scalars['String']['output'];
  /** The values for the options specified by the selling plans in the selling plan group. For example, '1 week', '2 weeks', '3 weeks'. */
  values: Array<Scalars['String']['output']>;
};

/** Represents a valid selling plan interval. */
export enum ShopifyGenSellingPlanInterval {
  /** Day interval. */
  Day = 'DAY',
  /** Month interval. */
  Month = 'MONTH',
  /** Week interval. */
  Week = 'WEEK',
  /** Year interval. */
  Year = 'YEAR',
}

/** An option provided by a Selling Plan. */
export type ShopifyGenSellingPlanOption = {
  __typename?: 'SellingPlanOption';
  /** The name of the option (ie "Delivery every"). */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the option (ie "Month"). */
  value?: Maybe<Scalars['String']['output']>;
};

/** A percentage amount that's deducted from the original variant price. For example, 10% off. */
export type ShopifyGenSellingPlanPercentagePriceAdjustment = {
  __typename?: 'SellingPlanPercentagePriceAdjustment';
  /** The percentage value of the price adjustment. */
  adjustmentPercentage: Scalars['Float']['output'];
};

/** Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments. If a variant has multiple price adjustments, then the first price adjustment applies when the variant is initially purchased. The second price adjustment applies after a certain number of orders (specified by the `orderCount` field) are made. If a selling plan doesn't have any price adjustments, then the unadjusted price of the variant is the effective price. */
export type ShopifyGenSellingPlanPriceAdjustment = {
  __typename?: 'SellingPlanPriceAdjustment';
  /** The type of price adjustment. An adjustment value can have one of three types: percentage, amount off, or a new price. */
  adjustmentValue: ShopifyGenSellingPlanPriceAdjustmentValue;
  /** The number of orders that the price adjustment applies to. If the price adjustment always applies, then this field is `null`. */
  orderCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments. */
export type ShopifyGenSellingPlanPriceAdjustmentValue =
  | ShopifyGenSellingPlanFixedAmountPriceAdjustment
  | ShopifyGenSellingPlanFixedPriceAdjustment
  | ShopifyGenSellingPlanPercentagePriceAdjustment;

/** The recurring billing policy for the selling plan. */
export type ShopifyGenSellingPlanRecurringBillingPolicy = {
  __typename?: 'SellingPlanRecurringBillingPolicy';
  /** The billing frequency, it can be either: day, week, month or year. */
  interval: ShopifyGenSellingPlanInterval;
  /** The number of intervals between billings. */
  intervalCount: Scalars['Int']['output'];
};

/** The recurring delivery policy for the selling plan. */
export type ShopifyGenSellingPlanRecurringDeliveryPolicy = {
  __typename?: 'SellingPlanRecurringDeliveryPolicy';
  /** The delivery frequency, it can be either: day, week, month or year. */
  interval: ShopifyGenSellingPlanInterval;
  /** The number of intervals between deliveries. */
  intervalCount: Scalars['Int']['output'];
};

/** Shop represents a collection of the general settings and information about the shop. */
export type ShopifyGenShop = ShopifyGenHasMetafields &
  ShopifyGenNode & {
    __typename?: 'Shop';
    /** The shop's branding configuration. */
    brand?: Maybe<ShopifyGenBrand>;
    /** A description of the shop. */
    description?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** A [custom field](https://shopify.dev/docs/apps/build/custom-data), including its `namespace` and `key`, that's associated with a Shopify resource for the purposes of adding and storing additional information. */
    metafield?: Maybe<ShopifyGenMetafield>;
    /** A list of [custom fields](/docs/apps/build/custom-data) that a merchant associates with a Shopify resource. */
    metafields: Array<Maybe<ShopifyGenMetafield>>;
    /** A string representing the way currency is formatted when the currency isn’t specified. */
    moneyFormat: Scalars['String']['output'];
    /** The shop’s name. */
    name: Scalars['String']['output'];
    /** Settings related to payments. */
    paymentSettings: ShopifyGenPaymentSettings;
    /** The primary domain of the shop’s Online Store. */
    primaryDomain: ShopifyGenDomain;
    /** The shop’s privacy policy. */
    privacyPolicy?: Maybe<ShopifyGenShopPolicy>;
    /** The shop’s refund policy. */
    refundPolicy?: Maybe<ShopifyGenShopPolicy>;
    /** The shop’s shipping policy. */
    shippingPolicy?: Maybe<ShopifyGenShopPolicy>;
    /** Countries that the shop ships to. */
    shipsToCountries: Array<ShopifyGenCountryCode>;
    /** The Shop Pay Installments pricing information for the shop. */
    shopPayInstallmentsPricing?: Maybe<ShopifyGenShopPayInstallmentsPricing>;
    /** The shop’s subscription policy. */
    subscriptionPolicy?: Maybe<ShopifyGenShopPolicyWithDefault>;
    /** The shop’s terms of service. */
    termsOfService?: Maybe<ShopifyGenShopPolicy>;
  };

/** Shop represents a collection of the general settings and information about the shop. */
export type ShopifyGenShopMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
};

/** Shop represents a collection of the general settings and information about the shop. */
export type ShopifyGenShopMetafieldsArgs = {
  identifiers: Array<ShopifyGenHasMetafieldsIdentifier>;
};

/** The financing plan in Shop Pay Installments. */
export type ShopifyGenShopPayInstallmentsFinancingPlan = ShopifyGenNode & {
  __typename?: 'ShopPayInstallmentsFinancingPlan';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The maximum price to qualify for the financing plan. */
  maxPrice: ShopifyGenMoneyV2;
  /** The minimum price to qualify for the financing plan. */
  minPrice: ShopifyGenMoneyV2;
  /** The terms of the financing plan. */
  terms: Array<ShopifyGenShopPayInstallmentsFinancingPlanTerm>;
};

/** The payment frequency for a Shop Pay Installments Financing Plan. */
export enum ShopifyGenShopPayInstallmentsFinancingPlanFrequency {
  /** Monthly payment frequency. */
  Monthly = 'MONTHLY',
  /** Weekly payment frequency. */
  Weekly = 'WEEKLY',
}

/** The terms of the financing plan in Shop Pay Installments. */
export type ShopifyGenShopPayInstallmentsFinancingPlanTerm = ShopifyGenNode & {
  __typename?: 'ShopPayInstallmentsFinancingPlanTerm';
  /** The annual percentage rate (APR) of the financing plan. */
  apr: Scalars['Int']['output'];
  /** The payment frequency for the financing plan. */
  frequency: ShopifyGenShopPayInstallmentsFinancingPlanFrequency;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The number of installments for the financing plan. */
  installmentsCount?: Maybe<ShopifyGenCount>;
  /** The type of loan for the financing plan. */
  loanType: ShopifyGenShopPayInstallmentsLoan;
};

/** The loan type for a Shop Pay Installments Financing Plan Term. */
export enum ShopifyGenShopPayInstallmentsLoan {
  /** An interest-bearing loan type. */
  Interest = 'INTEREST',
  /** A split-pay loan type. */
  SplitPay = 'SPLIT_PAY',
  /** A zero-percent loan type. */
  ZeroPercent = 'ZERO_PERCENT',
}

/** The result for a Shop Pay Installments pricing request. */
export type ShopifyGenShopPayInstallmentsPricing = {
  __typename?: 'ShopPayInstallmentsPricing';
  /** The financing plans available for the given price range. */
  financingPlans: Array<ShopifyGenShopPayInstallmentsFinancingPlan>;
  /** The maximum price to qualify for financing. */
  maxPrice: ShopifyGenMoneyV2;
  /** The minimum price to qualify for financing. */
  minPrice: ShopifyGenMoneyV2;
};

/** The shop pay installments pricing information for a product variant. */
export type ShopifyGenShopPayInstallmentsProductVariantPricing =
  ShopifyGenNode & {
    __typename?: 'ShopPayInstallmentsProductVariantPricing';
    /** Whether the product variant is available. */
    available: Scalars['Boolean']['output'];
    /** Whether the product variant is eligible for Shop Pay Installments. */
    eligible: Scalars['Boolean']['output'];
    /** The full price of the product variant. */
    fullPrice: ShopifyGenMoneyV2;
    /** The ID of the product variant. */
    id: Scalars['ID']['output'];
    /** The number of payment terms available for the product variant. */
    installmentsCount?: Maybe<ShopifyGenCount>;
    /** The price per term for the product variant. */
    pricePerTerm: ShopifyGenMoneyV2;
  };

/** Represents a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequest = {
  __typename?: 'ShopPayPaymentRequest';
  /** The delivery methods for the payment request. */
  deliveryMethods: Array<ShopifyGenShopPayPaymentRequestDeliveryMethod>;
  /** The discount codes for the payment request. */
  discountCodes: Array<Scalars['String']['output']>;
  /** The discounts for the payment request order. */
  discounts?: Maybe<Array<ShopifyGenShopPayPaymentRequestDiscount>>;
  /** The line items for the payment request. */
  lineItems: Array<ShopifyGenShopPayPaymentRequestLineItem>;
  /** The locale for the payment request. */
  locale: Scalars['String']['output'];
  /** The presentment currency for the payment request. */
  presentmentCurrency: ShopifyGenCurrencyCode;
  /** The delivery method type for the payment request. */
  selectedDeliveryMethodType: ShopifyGenShopPayPaymentRequestDeliveryMethodType;
  /** The shipping address for the payment request. */
  shippingAddress?: Maybe<ShopifyGenShopPayPaymentRequestContactField>;
  /** The shipping lines for the payment request. */
  shippingLines: Array<ShopifyGenShopPayPaymentRequestShippingLine>;
  /** The subtotal amount for the payment request. */
  subtotal: ShopifyGenMoneyV2;
  /** The total amount for the payment request. */
  total: ShopifyGenMoneyV2;
  /** The total shipping price for the payment request. */
  totalShippingPrice?: Maybe<ShopifyGenShopPayPaymentRequestTotalShippingPrice>;
  /** The total tax for the payment request. */
  totalTax?: Maybe<ShopifyGenMoneyV2>;
};

/** Represents a contact field for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestContactField = {
  __typename?: 'ShopPayPaymentRequestContactField';
  /** The first address line of the contact field. */
  address1: Scalars['String']['output'];
  /** The second address line of the contact field. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the contact field. */
  city: Scalars['String']['output'];
  /** The company name of the contact field. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country of the contact field. */
  countryCode: Scalars['String']['output'];
  /** The email of the contact field. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the contact field. */
  firstName: Scalars['String']['output'];
  /** The first name of the contact field. */
  lastName: Scalars['String']['output'];
  /** The phone number of the contact field. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The postal code of the contact field. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The province of the contact field. */
  provinceCode?: Maybe<Scalars['String']['output']>;
};

/** Represents a delivery method for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestDeliveryMethod = {
  __typename?: 'ShopPayPaymentRequestDeliveryMethod';
  /** The amount for the delivery method. */
  amount: ShopifyGenMoneyV2;
  /** The code of the delivery method. */
  code: Scalars['String']['output'];
  /** The detail about when the delivery may be expected. */
  deliveryExpectationLabel?: Maybe<Scalars['String']['output']>;
  /** The detail of the delivery method. */
  detail?: Maybe<Scalars['String']['output']>;
  /** The label of the delivery method. */
  label: Scalars['String']['output'];
  /** The maximum delivery date for the delivery method. */
  maxDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The minimum delivery date for the delivery method. */
  minDeliveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The input fields to create a delivery method for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestDeliveryMethodInput = {
  /** The amount for the delivery method. */
  amount?: InputMaybe<ShopifyGenMoneyInput>;
  /** The code of the delivery method. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The detail about when the delivery may be expected. */
  deliveryExpectationLabel?: InputMaybe<Scalars['String']['input']>;
  /** The detail of the delivery method. */
  detail?: InputMaybe<Scalars['String']['input']>;
  /** The label of the delivery method. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The maximum delivery date for the delivery method. */
  maxDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The minimum delivery date for the delivery method. */
  minDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Represents the delivery method type for a Shop Pay payment request. */
export enum ShopifyGenShopPayPaymentRequestDeliveryMethodType {
  /** The delivery method type is pickup. */
  Pickup = 'PICKUP',
  /** The delivery method type is shipping. */
  Shipping = 'SHIPPING',
}

/** Represents a discount for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestDiscount = {
  __typename?: 'ShopPayPaymentRequestDiscount';
  /** The amount of the discount. */
  amount: ShopifyGenMoneyV2;
  /** The label of the discount. */
  label: Scalars['String']['output'];
};

/** The input fields to create a discount for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestDiscountInput = {
  /** The amount of the discount. */
  amount?: InputMaybe<ShopifyGenMoneyInput>;
  /** The label of the discount. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an image for a Shop Pay payment request line item. */
export type ShopifyGenShopPayPaymentRequestImage = {
  __typename?: 'ShopPayPaymentRequestImage';
  /** The alt text of the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The source URL of the image. */
  url: Scalars['String']['output'];
};

/** The input fields to create an image for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestImageInput = {
  /** The alt text of the image. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** The source URL of the image. */
  url: Scalars['String']['input'];
};

/** The input fields represent a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestInput = {
  /**
   * The delivery methods for the payment request.
   *
   * The input must not contain more than `250` values.
   */
  deliveryMethods?: InputMaybe<
    Array<ShopifyGenShopPayPaymentRequestDeliveryMethodInput>
  >;
  /**
   * The discount codes for the payment request.
   *
   * The input must not contain more than `250` values.
   */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The discounts for the payment request order.
   *
   * The input must not contain more than `250` values.
   */
  discounts?: InputMaybe<Array<ShopifyGenShopPayPaymentRequestDiscountInput>>;
  /**
   * The line items for the payment request.
   *
   * The input must not contain more than `250` values.
   */
  lineItems?: InputMaybe<Array<ShopifyGenShopPayPaymentRequestLineItemInput>>;
  /** The locale for the payment request. */
  locale: Scalars['String']['input'];
  /** The encrypted payment method for the payment request. */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** The presentment currency for the payment request. */
  presentmentCurrency: ShopifyGenCurrencyCode;
  /** The delivery method type for the payment request. */
  selectedDeliveryMethodType?: InputMaybe<ShopifyGenShopPayPaymentRequestDeliveryMethodType>;
  /**
   * The shipping lines for the payment request.
   *
   * The input must not contain more than `250` values.
   */
  shippingLines?: InputMaybe<
    Array<ShopifyGenShopPayPaymentRequestShippingLineInput>
  >;
  /** The subtotal amount for the payment request. */
  subtotal: ShopifyGenMoneyInput;
  /** The total amount for the payment request. */
  total: ShopifyGenMoneyInput;
  /** The total shipping price for the payment request. */
  totalShippingPrice?: InputMaybe<ShopifyGenShopPayPaymentRequestTotalShippingPriceInput>;
  /** The total tax for the payment request. */
  totalTax?: InputMaybe<ShopifyGenMoneyInput>;
};

/** Represents a line item for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestLineItem = {
  __typename?: 'ShopPayPaymentRequestLineItem';
  /** The final item price for the line item. */
  finalItemPrice: ShopifyGenMoneyV2;
  /** The final line price for the line item. */
  finalLinePrice: ShopifyGenMoneyV2;
  /** The image of the line item. */
  image?: Maybe<ShopifyGenShopPayPaymentRequestImage>;
  /** The item discounts for the line item. */
  itemDiscounts?: Maybe<Array<ShopifyGenShopPayPaymentRequestDiscount>>;
  /** The label of the line item. */
  label: Scalars['String']['output'];
  /** The line discounts for the line item. */
  lineDiscounts?: Maybe<Array<ShopifyGenShopPayPaymentRequestDiscount>>;
  /** The original item price for the line item. */
  originalItemPrice?: Maybe<ShopifyGenMoneyV2>;
  /** The original line price for the line item. */
  originalLinePrice?: Maybe<ShopifyGenMoneyV2>;
  /** The quantity of the line item. */
  quantity: Scalars['Int']['output'];
  /** Whether the line item requires shipping. */
  requiresShipping?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the line item. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** The input fields to create a line item for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestLineItemInput = {
  /** The final item price for the line item. */
  finalItemPrice?: InputMaybe<ShopifyGenMoneyInput>;
  /** The final line price for the line item. */
  finalLinePrice?: InputMaybe<ShopifyGenMoneyInput>;
  /** The image of the line item. */
  image?: InputMaybe<ShopifyGenShopPayPaymentRequestImageInput>;
  /**
   * The item discounts for the line item.
   *
   * The input must not contain more than `250` values.
   */
  itemDiscounts?: InputMaybe<
    Array<ShopifyGenShopPayPaymentRequestDiscountInput>
  >;
  /** The label of the line item. */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * The line discounts for the line item.
   *
   * The input must not contain more than `250` values.
   */
  lineDiscounts?: InputMaybe<
    Array<ShopifyGenShopPayPaymentRequestDiscountInput>
  >;
  /** The original item price for the line item. */
  originalItemPrice?: InputMaybe<ShopifyGenMoneyInput>;
  /** The original line price for the line item. */
  originalLinePrice?: InputMaybe<ShopifyGenMoneyInput>;
  /** The quantity of the line item. */
  quantity: Scalars['Int']['input'];
  /** Whether the line item requires shipping. */
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU of the line item. */
  sku?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a receipt for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestReceipt = {
  __typename?: 'ShopPayPaymentRequestReceipt';
  /** The payment request object. */
  paymentRequest: ShopifyGenShopPayPaymentRequest;
  /** The processing status. */
  processingStatusType: Scalars['String']['output'];
  /** The token of the receipt. */
  token: Scalars['String']['output'];
};

/** Represents a Shop Pay payment request session. */
export type ShopifyGenShopPayPaymentRequestSession = {
  __typename?: 'ShopPayPaymentRequestSession';
  /** The checkout URL of the Shop Pay payment request session. */
  checkoutUrl: Scalars['URL']['output'];
  /** The payment request associated with the Shop Pay payment request session. */
  paymentRequest: ShopifyGenShopPayPaymentRequest;
  /** The source identifier of the Shop Pay payment request session. */
  sourceIdentifier: Scalars['String']['output'];
  /** The token of the Shop Pay payment request session. */
  token: Scalars['String']['output'];
};

/** Return type for `shopPayPaymentRequestSessionCreate` mutation. */
export type ShopifyGenShopPayPaymentRequestSessionCreatePayload = {
  __typename?: 'ShopPayPaymentRequestSessionCreatePayload';
  /** The new Shop Pay payment request session object. */
  shopPayPaymentRequestSession?: Maybe<ShopifyGenShopPayPaymentRequestSession>;
  /** Error codes for failed Shop Pay payment request session mutations. */
  userErrors: Array<ShopifyGenUserErrorsShopPayPaymentRequestSessionUserErrors>;
};

/** Return type for `shopPayPaymentRequestSessionSubmit` mutation. */
export type ShopifyGenShopPayPaymentRequestSessionSubmitPayload = {
  __typename?: 'ShopPayPaymentRequestSessionSubmitPayload';
  /** The checkout on which the payment was applied. */
  paymentRequestReceipt?: Maybe<ShopifyGenShopPayPaymentRequestReceipt>;
  /** Error codes for failed Shop Pay payment request session mutations. */
  userErrors: Array<ShopifyGenUserErrorsShopPayPaymentRequestSessionUserErrors>;
};

/** Represents a shipping line for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestShippingLine = {
  __typename?: 'ShopPayPaymentRequestShippingLine';
  /** The amount for the shipping line. */
  amount: ShopifyGenMoneyV2;
  /** The code of the shipping line. */
  code: Scalars['String']['output'];
  /** The label of the shipping line. */
  label: Scalars['String']['output'];
};

/** The input fields to create a shipping line for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestShippingLineInput = {
  /** The amount for the shipping line. */
  amount?: InputMaybe<ShopifyGenMoneyInput>;
  /** The code of the shipping line. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The label of the shipping line. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shipping total for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestTotalShippingPrice = {
  __typename?: 'ShopPayPaymentRequestTotalShippingPrice';
  /** The discounts for the shipping total. */
  discounts: Array<ShopifyGenShopPayPaymentRequestDiscount>;
  /** The final total for the shipping total. */
  finalTotal: ShopifyGenMoneyV2;
  /** The original total for the shipping total. */
  originalTotal?: Maybe<ShopifyGenMoneyV2>;
};

/** The input fields to create a shipping total for a Shop Pay payment request. */
export type ShopifyGenShopPayPaymentRequestTotalShippingPriceInput = {
  /**
   * The discounts for the shipping total.
   *
   * The input must not contain more than `250` values.
   */
  discounts?: InputMaybe<Array<ShopifyGenShopPayPaymentRequestDiscountInput>>;
  /** The final total for the shipping total. */
  finalTotal?: InputMaybe<ShopifyGenMoneyInput>;
  /** The original total for the shipping total. */
  originalTotal?: InputMaybe<ShopifyGenMoneyInput>;
};

/**
 * The input fields for submitting Shop Pay payment method information for checkout.
 *
 */
export type ShopifyGenShopPayWalletContentInput = {
  /** The customer's billing address. */
  billingAddress: ShopifyGenMailingAddressInput;
  /** Session token for transaction. */
  sessionToken: Scalars['String']['input'];
};

/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type ShopifyGenShopPolicy = ShopifyGenNode & {
  __typename?: 'ShopPolicy';
  /** Policy text, maximum size of 64kb. */
  body: Scalars['String']['output'];
  /** Policy’s handle. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Policy’s title. */
  title: Scalars['String']['output'];
  /** Public URL to the policy. */
  url: Scalars['URL']['output'];
};

/**
 * A policy for the store that comes with a default value, such as a subscription policy.
 * If the merchant hasn't configured a policy for their store, then the policy will return the default value.
 * Otherwise, the policy will return the merchant-configured value.
 *
 */
export type ShopifyGenShopPolicyWithDefault = {
  __typename?: 'ShopPolicyWithDefault';
  /** The text of the policy. Maximum size: 64KB. */
  body: Scalars['String']['output'];
  /** The handle of the policy. */
  handle: Scalars['String']['output'];
  /** The unique ID of the policy. A default policy doesn't have an ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The title of the policy. */
  title: Scalars['String']['output'];
  /** Public URL to the policy. */
  url: Scalars['URL']['output'];
};

/** Contains all fields required to generate sitemaps. */
export type ShopifyGenSitemap = {
  __typename?: 'Sitemap';
  /** The number of sitemap's pages for a given type. */
  pagesCount?: Maybe<ShopifyGenCount>;
  /**
   * A list of sitemap's resources for a given type.
   *
   * Important Notes:
   *   - The number of items per page varies from 0 to 250.
   *   - Empty pages (0 items) may occur and do not necessarily indicate the end of results.
   *   - Always check `hasNextPage` to determine if more pages are available.
   *
   */
  resources?: Maybe<ShopifyGenPaginatedSitemapResources>;
};

/** Contains all fields required to generate sitemaps. */
export type ShopifyGenSitemapResourcesArgs = {
  page: Scalars['Int']['input'];
};

/** Represents a sitemap's image. */
export type ShopifyGenSitemapImage = {
  __typename?: 'SitemapImage';
  /** Image's alt text. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Path to the image. */
  filepath?: Maybe<Scalars['String']['output']>;
  /** The date and time when the image was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a sitemap resource that is not a metaobject. */
export type ShopifyGenSitemapResource = ShopifyGenSitemapResourceInterface & {
  __typename?: 'SitemapResource';
  /** Resource's handle. */
  handle: Scalars['String']['output'];
  /** Resource's image. */
  image?: Maybe<ShopifyGenSitemapImage>;
  /** Resource's title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time when the resource was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the common fields for all sitemap resource types. */
export type ShopifyGenSitemapResourceInterface = {
  /** Resource's handle. */
  handle: Scalars['String']['output'];
  /** The date and time when the resource was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * A SitemapResourceMetaobject represents a metaobject with
 * [the `renderable` capability](https://shopify.dev/docs/apps/build/custom-data/metaobjects/use-metaobject-capabilities#render-metaobjects-as-web-pages).
 *
 */
export type ShopifyGenSitemapResourceMetaobject =
  ShopifyGenSitemapResourceInterface & {
    __typename?: 'SitemapResourceMetaobject';
    /** Resource's handle. */
    handle: Scalars['String']['output'];
    /** The URL handle for accessing pages of this metaobject type in the Online Store. */
    onlineStoreUrlHandle?: Maybe<Scalars['String']['output']>;
    /** The type of the metaobject. Defines the namespace of its associated metafields. */
    type: Scalars['String']['output'];
    /** The date and time when the resource was updated. */
    updatedAt: Scalars['DateTime']['output'];
  };

/** The types of resources potentially present in a sitemap. */
export enum ShopifyGenSitemapType {
  /** Articles present in the sitemap. */
  Article = 'ARTICLE',
  /** Blogs present in the sitemap. */
  Blog = 'BLOG',
  /** Collections present in the sitemap. */
  Collection = 'COLLECTION',
  /**
   * Metaobjects present in the sitemap. Only metaobject types with the
   * [`renderable` capability](https://shopify.dev/docs/apps/build/custom-data/metaobjects/use-metaobject-capabilities#render-metaobjects-as-web-pages)
   * are included in sitemap.
   *
   */
  Metaobject = 'METAOBJECT',
  /** Pages present in the sitemap. */
  Page = 'PAGE',
  /** Products present in the sitemap. */
  Product = 'PRODUCT',
}

/**
 * The availability of a product variant at a particular location.
 * Local pick-up must be enabled in the  store's shipping settings, otherwise this will return an empty result.
 *
 */
export type ShopifyGenStoreAvailability = {
  __typename?: 'StoreAvailability';
  /** Whether the product variant is in-stock at this location. */
  available: Scalars['Boolean']['output'];
  /** The location where this product variant is stocked at. */
  location: ShopifyGenLocation;
  /** Returns the estimated amount of time it takes for pickup to be ready (Example: Usually ready in 24 hours). */
  pickUpTime: Scalars['String']['output'];
  /** The quantity of the product variant in-stock at this location. */
  quantityAvailable: Scalars['Int']['output'];
};

/**
 * An auto-generated type for paginating through multiple StoreAvailabilities.
 *
 */
export type ShopifyGenStoreAvailabilityConnection = {
  __typename?: 'StoreAvailabilityConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenStoreAvailabilityEdge>;
  /** A list of the nodes contained in StoreAvailabilityEdge. */
  nodes: Array<ShopifyGenStoreAvailability>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one StoreAvailability and a cursor during pagination.
 *
 */
export type ShopifyGenStoreAvailabilityEdge = {
  __typename?: 'StoreAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of StoreAvailabilityEdge. */
  node: ShopifyGenStoreAvailability;
};

/**
 * An auto-generated type for paginating through multiple Strings.
 *
 */
export type ShopifyGenStringConnection = {
  __typename?: 'StringConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenStringEdge>;
  /** A list of the nodes contained in StringEdge. */
  nodes: Array<Scalars['String']['output']>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one String and a cursor during pagination.
 *
 */
export type ShopifyGenStringEdge = {
  __typename?: 'StringEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of StringEdge. */
  node: Scalars['String']['output'];
};

/** An error that occurred during cart submit for completion. */
export type ShopifyGenSubmissionError = {
  __typename?: 'SubmissionError';
  /** The error code. */
  code: ShopifyGenSubmissionErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** The code of the error that occurred during cart submit for completion. */
export enum ShopifyGenSubmissionErrorCode {
  BuyerIdentityEmailIsInvalid = 'BUYER_IDENTITY_EMAIL_IS_INVALID',
  BuyerIdentityEmailRequired = 'BUYER_IDENTITY_EMAIL_REQUIRED',
  BuyerIdentityPhoneIsInvalid = 'BUYER_IDENTITY_PHONE_IS_INVALID',
  DeliveryAddress1Invalid = 'DELIVERY_ADDRESS1_INVALID',
  DeliveryAddress1Required = 'DELIVERY_ADDRESS1_REQUIRED',
  DeliveryAddress1TooLong = 'DELIVERY_ADDRESS1_TOO_LONG',
  DeliveryAddress2Invalid = 'DELIVERY_ADDRESS2_INVALID',
  DeliveryAddress2Required = 'DELIVERY_ADDRESS2_REQUIRED',
  DeliveryAddress2TooLong = 'DELIVERY_ADDRESS2_TOO_LONG',
  DeliveryAddressRequired = 'DELIVERY_ADDRESS_REQUIRED',
  DeliveryCityInvalid = 'DELIVERY_CITY_INVALID',
  DeliveryCityRequired = 'DELIVERY_CITY_REQUIRED',
  DeliveryCityTooLong = 'DELIVERY_CITY_TOO_LONG',
  DeliveryCompanyInvalid = 'DELIVERY_COMPANY_INVALID',
  DeliveryCompanyRequired = 'DELIVERY_COMPANY_REQUIRED',
  DeliveryCompanyTooLong = 'DELIVERY_COMPANY_TOO_LONG',
  DeliveryCountryRequired = 'DELIVERY_COUNTRY_REQUIRED',
  DeliveryFirstNameInvalid = 'DELIVERY_FIRST_NAME_INVALID',
  DeliveryFirstNameRequired = 'DELIVERY_FIRST_NAME_REQUIRED',
  DeliveryFirstNameTooLong = 'DELIVERY_FIRST_NAME_TOO_LONG',
  DeliveryInvalidPostalCodeForCountry = 'DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY',
  DeliveryInvalidPostalCodeForZone = 'DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE',
  DeliveryLastNameInvalid = 'DELIVERY_LAST_NAME_INVALID',
  DeliveryLastNameRequired = 'DELIVERY_LAST_NAME_REQUIRED',
  DeliveryLastNameTooLong = 'DELIVERY_LAST_NAME_TOO_LONG',
  DeliveryNoDeliveryAvailable = 'DELIVERY_NO_DELIVERY_AVAILABLE',
  DeliveryNoDeliveryAvailableForMerchandiseLine = 'DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE',
  DeliveryOptionsPhoneNumberInvalid = 'DELIVERY_OPTIONS_PHONE_NUMBER_INVALID',
  DeliveryOptionsPhoneNumberRequired = 'DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED',
  DeliveryPhoneNumberInvalid = 'DELIVERY_PHONE_NUMBER_INVALID',
  DeliveryPhoneNumberRequired = 'DELIVERY_PHONE_NUMBER_REQUIRED',
  DeliveryPostalCodeInvalid = 'DELIVERY_POSTAL_CODE_INVALID',
  DeliveryPostalCodeRequired = 'DELIVERY_POSTAL_CODE_REQUIRED',
  DeliveryZoneNotFound = 'DELIVERY_ZONE_NOT_FOUND',
  DeliveryZoneRequiredForCountry = 'DELIVERY_ZONE_REQUIRED_FOR_COUNTRY',
  Error = 'ERROR',
  MerchandiseLineLimitReached = 'MERCHANDISE_LINE_LIMIT_REACHED',
  MerchandiseNotApplicable = 'MERCHANDISE_NOT_APPLICABLE',
  MerchandiseNotEnoughStockAvailable = 'MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE',
  MerchandiseOutOfStock = 'MERCHANDISE_OUT_OF_STOCK',
  MerchandiseProductNotPublished = 'MERCHANDISE_PRODUCT_NOT_PUBLISHED',
  NoDeliveryGroupSelected = 'NO_DELIVERY_GROUP_SELECTED',
  PaymentsAddress1Invalid = 'PAYMENTS_ADDRESS1_INVALID',
  PaymentsAddress1Required = 'PAYMENTS_ADDRESS1_REQUIRED',
  PaymentsAddress1TooLong = 'PAYMENTS_ADDRESS1_TOO_LONG',
  PaymentsAddress2Invalid = 'PAYMENTS_ADDRESS2_INVALID',
  PaymentsAddress2Required = 'PAYMENTS_ADDRESS2_REQUIRED',
  PaymentsAddress2TooLong = 'PAYMENTS_ADDRESS2_TOO_LONG',
  PaymentsBillingAddressZoneNotFound = 'PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND',
  PaymentsBillingAddressZoneRequiredForCountry = 'PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY',
  PaymentsCityInvalid = 'PAYMENTS_CITY_INVALID',
  PaymentsCityRequired = 'PAYMENTS_CITY_REQUIRED',
  PaymentsCityTooLong = 'PAYMENTS_CITY_TOO_LONG',
  PaymentsCompanyInvalid = 'PAYMENTS_COMPANY_INVALID',
  PaymentsCompanyRequired = 'PAYMENTS_COMPANY_REQUIRED',
  PaymentsCompanyTooLong = 'PAYMENTS_COMPANY_TOO_LONG',
  PaymentsCountryRequired = 'PAYMENTS_COUNTRY_REQUIRED',
  PaymentsCreditCardBaseExpired = 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED',
  PaymentsCreditCardBaseGatewayNotSupported = 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED',
  PaymentsCreditCardBaseInvalidStartDateOrIssueNumberForDebit = 'PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT',
  PaymentsCreditCardBrandNotSupported = 'PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED',
  PaymentsCreditCardFirstNameBlank = 'PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK',
  PaymentsCreditCardGeneric = 'PAYMENTS_CREDIT_CARD_GENERIC',
  PaymentsCreditCardLastNameBlank = 'PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK',
  PaymentsCreditCardMonthInclusion = 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION',
  PaymentsCreditCardNameInvalid = 'PAYMENTS_CREDIT_CARD_NAME_INVALID',
  PaymentsCreditCardNumberInvalid = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID',
  PaymentsCreditCardNumberInvalidFormat = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT',
  PaymentsCreditCardSessionId = 'PAYMENTS_CREDIT_CARD_SESSION_ID',
  PaymentsCreditCardVerificationValueBlank = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK',
  PaymentsCreditCardVerificationValueInvalidForCardType = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE',
  PaymentsCreditCardYearExpired = 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED',
  PaymentsCreditCardYearInvalidExpiryYear = 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR',
  PaymentsFirstNameInvalid = 'PAYMENTS_FIRST_NAME_INVALID',
  PaymentsFirstNameRequired = 'PAYMENTS_FIRST_NAME_REQUIRED',
  PaymentsFirstNameTooLong = 'PAYMENTS_FIRST_NAME_TOO_LONG',
  PaymentsInvalidPostalCodeForCountry = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY',
  PaymentsInvalidPostalCodeForZone = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE',
  PaymentsLastNameInvalid = 'PAYMENTS_LAST_NAME_INVALID',
  PaymentsLastNameRequired = 'PAYMENTS_LAST_NAME_REQUIRED',
  PaymentsLastNameTooLong = 'PAYMENTS_LAST_NAME_TOO_LONG',
  PaymentsMethodRequired = 'PAYMENTS_METHOD_REQUIRED',
  PaymentsMethodUnavailable = 'PAYMENTS_METHOD_UNAVAILABLE',
  PaymentsPhoneNumberInvalid = 'PAYMENTS_PHONE_NUMBER_INVALID',
  PaymentsPhoneNumberRequired = 'PAYMENTS_PHONE_NUMBER_REQUIRED',
  PaymentsPostalCodeInvalid = 'PAYMENTS_POSTAL_CODE_INVALID',
  PaymentsPostalCodeRequired = 'PAYMENTS_POSTAL_CODE_REQUIRED',
  PaymentsShopifyPaymentsRequired = 'PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED',
  PaymentsUnacceptablePaymentAmount = 'PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT',
  PaymentsWalletContentMissing = 'PAYMENTS_WALLET_CONTENT_MISSING',
  TaxesDeliveryGroupIdNotFound = 'TAXES_DELIVERY_GROUP_ID_NOT_FOUND',
  TaxesLineIdNotFound = 'TAXES_LINE_ID_NOT_FOUND',
  TaxesMustBeDefined = 'TAXES_MUST_BE_DEFINED',
}

/** Cart submit for checkout completion is successful. */
export type ShopifyGenSubmitAlreadyAccepted = {
  __typename?: 'SubmitAlreadyAccepted';
  /** The ID of the cart completion attempt that will be used for polling for the result. */
  attemptId: Scalars['String']['output'];
};

/** Cart submit for checkout completion failed. */
export type ShopifyGenSubmitFailed = {
  __typename?: 'SubmitFailed';
  /** The URL of the checkout for the cart. */
  checkoutUrl?: Maybe<Scalars['URL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  errors: Array<ShopifyGenSubmissionError>;
};

/** Cart submit for checkout completion is already accepted. */
export type ShopifyGenSubmitSuccess = {
  __typename?: 'SubmitSuccess';
  /** The ID of the cart completion attempt that will be used for polling for the result. */
  attemptId: Scalars['String']['output'];
  /** The url to which the buyer should be redirected after the cart is successfully submitted. */
  redirectUrl: Scalars['URL']['output'];
};

/** Cart submit for checkout completion is throttled. */
export type ShopifyGenSubmitThrottled = {
  __typename?: 'SubmitThrottled';
  /**
   * UTC date time string that indicates the time after which clients should make their next
   * poll request. Any poll requests sent before this time will be ignored. Use this value to schedule the
   * next poll request.
   *
   */
  pollAfter: Scalars['DateTime']['output'];
};

/** Color and image for visual representation. */
export type ShopifyGenSwatch = {
  __typename?: 'Swatch';
  /** The swatch color. */
  color?: Maybe<Scalars['Color']['output']>;
  /** The swatch image. */
  image?: Maybe<ShopifyGenMediaImage>;
};

/**
 * The taxonomy category for the product.
 *
 */
export type ShopifyGenTaxonomyCategory = ShopifyGenNode & {
  __typename?: 'TaxonomyCategory';
  /** All parent nodes of the current taxonomy category. */
  ancestors: Array<ShopifyGenTaxonomyCategory>;
  /** A static identifier for the taxonomy category. */
  id: Scalars['ID']['output'];
  /** The localized name of the taxonomy category. */
  name: Scalars['String']['output'];
};

/**
 * A filter used to view a subset of products in a collection matching a specific taxonomy metafield value.
 *
 */
export type ShopifyGenTaxonomyMetafieldFilter = {
  /** The key of the metafield to filter on. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield to filter on. */
  namespace: Scalars['String']['input'];
  /** The value of the metafield. */
  value: Scalars['String']['input'];
};

/** Represents a resource that you can track the origin of the search traffic. */
export type ShopifyGenTrackable = {
  /** URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
};

/**
 * The measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml).
 *
 */
export type ShopifyGenUnitPriceMeasurement = {
  __typename?: 'UnitPriceMeasurement';
  /** The type of unit of measurement for the unit price measurement. */
  measuredType?: Maybe<ShopifyGenUnitPriceMeasurementMeasuredType>;
  /** The quantity unit for the unit price measurement. */
  quantityUnit?: Maybe<ShopifyGenUnitPriceMeasurementMeasuredUnit>;
  /** The quantity value for the unit price measurement. */
  quantityValue: Scalars['Float']['output'];
  /** The reference unit for the unit price measurement. */
  referenceUnit?: Maybe<ShopifyGenUnitPriceMeasurementMeasuredUnit>;
  /** The reference value for the unit price measurement. */
  referenceValue: Scalars['Int']['output'];
};

/** The accepted types of unit of measurement. */
export enum ShopifyGenUnitPriceMeasurementMeasuredType {
  /** Unit of measurements representing areas. */
  Area = 'AREA',
  /** Unit of measurements representing lengths. */
  Length = 'LENGTH',
  /** Unit of measurements representing volumes. */
  Volume = 'VOLUME',
  /** Unit of measurements representing weights. */
  Weight = 'WEIGHT',
}

/** The valid units of measurement for a unit price measurement. */
export enum ShopifyGenUnitPriceMeasurementMeasuredUnit {
  /** 100 centiliters equals 1 liter. */
  Cl = 'CL',
  /** 100 centimeters equals 1 meter. */
  Cm = 'CM',
  /** Metric system unit of weight. */
  G = 'G',
  /** 1 kilogram equals 1000 grams. */
  Kg = 'KG',
  /** Metric system unit of volume. */
  L = 'L',
  /** Metric system unit of length. */
  M = 'M',
  /** Metric system unit of area. */
  M2 = 'M2',
  /** 1 cubic meter equals 1000 liters. */
  M3 = 'M3',
  /** 1000 milligrams equals 1 gram. */
  Mg = 'MG',
  /** 1000 milliliters equals 1 liter. */
  Ml = 'ML',
  /** 1000 millimeters equals 1 meter. */
  Mm = 'MM',
}

/** Systems of weights and measures. */
export enum ShopifyGenUnitSystem {
  /** Imperial system of weights and measures. */
  ImperialSystem = 'IMPERIAL_SYSTEM',
  /** Metric system of weights and measures. */
  MetricSystem = 'METRIC_SYSTEM',
}

/** A redirect on the online store. */
export type ShopifyGenUrlRedirect = ShopifyGenNode & {
  __typename?: 'UrlRedirect';
  /** The ID of the URL redirect. */
  id: Scalars['ID']['output'];
  /** The old path to be redirected from. When the user visits this path, they'll be redirected to the target location. */
  path: Scalars['String']['output'];
  /** The target location where the user will be redirected to. */
  target: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple UrlRedirects.
 *
 */
export type ShopifyGenUrlRedirectConnection = {
  __typename?: 'UrlRedirectConnection';
  /** A list of edges. */
  edges: Array<ShopifyGenUrlRedirectEdge>;
  /** A list of the nodes contained in UrlRedirectEdge. */
  nodes: Array<ShopifyGenUrlRedirect>;
  /** Information to aid in pagination. */
  pageInfo: ShopifyGenPageInfo;
};

/**
 * An auto-generated type which holds one UrlRedirect and a cursor during pagination.
 *
 */
export type ShopifyGenUrlRedirectEdge = {
  __typename?: 'UrlRedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of UrlRedirectEdge. */
  node: ShopifyGenUrlRedirect;
};

/** Represents an error in the input of a mutation. */
export type ShopifyGenUserError = ShopifyGenDisplayableError & {
  __typename?: 'UserError';
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Error codes for failed Shop Pay payment request session mutations. */
export type ShopifyGenUserErrorsShopPayPaymentRequestSessionUserErrors =
  ShopifyGenDisplayableError & {
    __typename?: 'UserErrorsShopPayPaymentRequestSessionUserErrors';
    /** The error code. */
    code?: Maybe<ShopifyGenUserErrorsShopPayPaymentRequestSessionUserErrorsCode>;
    /** The path to the input field that caused the error. */
    field?: Maybe<Array<Scalars['String']['output']>>;
    /** The error message. */
    message: Scalars['String']['output'];
  };

/** Possible error codes that can be returned by `ShopPayPaymentRequestSessionUserErrors`. */
export enum ShopifyGenUserErrorsShopPayPaymentRequestSessionUserErrorsCode {
  /** Idempotency key has already been used. */
  IdempotencyKeyAlreadyUsed = 'IDEMPOTENCY_KEY_ALREADY_USED',
  /** Payment request input is invalid. */
  PaymentRequestInvalidInput = 'PAYMENT_REQUEST_INVALID_INPUT',
  /** Payment request not found. */
  PaymentRequestNotFound = 'PAYMENT_REQUEST_NOT_FOUND',
}

/** The input fields for a filter used to view a subset of products in a collection matching a specific variant option. */
export type ShopifyGenVariantOptionFilter = {
  /** The name of the variant option to filter on. */
  name: Scalars['String']['input'];
  /** The value of the variant option to filter on. */
  value: Scalars['String']['input'];
};

/** Represents a Shopify hosted video. */
export type ShopifyGenVideo = ShopifyGenMedia &
  ShopifyGenNode & {
    __typename?: 'Video';
    /** A word or phrase to share the nature or contents of a media. */
    alt?: Maybe<Scalars['String']['output']>;
    /** A globally-unique ID. */
    id: Scalars['ID']['output'];
    /** The media content type. */
    mediaContentType: ShopifyGenMediaContentType;
    /** The presentation for a media. */
    presentation?: Maybe<ShopifyGenMediaPresentation>;
    /** The preview image for the media. */
    previewImage?: Maybe<ShopifyGenImage>;
    /** The sources for a video. */
    sources: Array<ShopifyGenVideoSource>;
  };

/** Represents a source for a Shopify hosted video. */
export type ShopifyGenVideoSource = {
  __typename?: 'VideoSource';
  /** The format of the video source. */
  format: Scalars['String']['output'];
  /** The height of the video. */
  height: Scalars['Int']['output'];
  /** The video MIME type. */
  mimeType: Scalars['String']['output'];
  /** The URL of the video. */
  url: Scalars['String']['output'];
  /** The width of the video. */
  width: Scalars['Int']['output'];
};

/** Units of measurement for weight. */
export enum ShopifyGenWeightUnit {
  /** Metric system unit of mass. */
  Grams = 'GRAMS',
  /** 1 kilogram equals 1000 grams. */
  Kilograms = 'KILOGRAMS',
  /** Imperial system unit of mass. */
  Ounces = 'OUNCES',
  /** 1 pound equals 16 ounces. */
  Pounds = 'POUNDS',
}

export type ShopifyGenCreateCartWithProductsMutationVariables = Exact<{
  country: ShopifyGenCountryCode;
  lineItems: Array<ShopifyGenCartLineInput> | ShopifyGenCartLineInput;
  customAttributes?: InputMaybe<
    Array<ShopifyGenAttributeInput> | ShopifyGenAttributeInput
  >;
}>;

export type ShopifyGenCreateCartWithProductsMutation = {
  __typename?: 'Mutation';
  cartCreate?: {
    __typename?: 'CartCreatePayload';
    cart?: {
      __typename?: 'Cart';
      id: string;
      checkoutUrl: string;
      lines: {
        __typename?: 'BaseCartLineConnection';
        nodes: Array<
          | {
              __typename?: 'CartLine';
              id: string;
              attributes: Array<{
                __typename?: 'Attribute';
                key: string;
                value?: string | null;
              }>;
              cost: {
                __typename?: 'CartLineCost';
                totalAmount: { __typename?: 'MoneyV2'; amount: any };
              };
              discountAllocations: Array<
                | {
                    __typename?: 'CartAutomaticDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
                | {
                    __typename?: 'CartCodeDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
                | {
                    __typename?: 'CartCustomDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
              >;
            }
          | {
              __typename?: 'ComponentizableCartLine';
              id: string;
              attributes: Array<{
                __typename?: 'Attribute';
                key: string;
                value?: string | null;
              }>;
              cost: {
                __typename?: 'CartLineCost';
                totalAmount: { __typename?: 'MoneyV2'; amount: any };
              };
              discountAllocations: Array<
                | {
                    __typename?: 'CartAutomaticDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
                | {
                    __typename?: 'CartCodeDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
                | {
                    __typename?: 'CartCustomDiscountAllocation';
                    discountedAmount: { __typename?: 'MoneyV2'; amount: any };
                  }
              >;
            }
        >;
      };
    } | null;
  } | null;
};

export type ShopifyGenGetCollectionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ShopifyGenGetCollectionByIdQuery = {
  __typename?: 'QueryRoot';
  collection?: {
    __typename?: 'Collection';
    image?: { __typename?: 'Image'; url: string } | null;
    products: {
      __typename?: 'ProductConnection';
      nodes: Array<{
        __typename?: 'Product';
        id: string;
        title: string;
        handle: string;
        tags: Array<string>;
        featuredImage?: { __typename?: 'Image'; url: string } | null;
        artistName?: { __typename?: 'Metafield'; value: string } | null;
        maximumSalesCapacity?: {
          __typename?: 'Metafield';
          value: string;
        } | null;
        variants: {
          __typename?: 'ProductVariantConnection';
          edges: Array<{
            __typename?: 'ProductVariantEdge';
            node: {
              __typename?: 'ProductVariant';
              id: string;
              title: string;
              availableForSale: boolean;
              price: { __typename?: 'MoneyV2'; amount: any };
            };
          }>;
        };
      }>;
    };
    worksSelectorDescription?: {
      __typename?: 'Metafield';
      value: string;
    } | null;
  } | null;
};

export type ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ShopifyGenGetFrameVariantsByFrameProdutIdsQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | {
        __typename?: 'Product';
        id: string;
        title: string;
        variants: {
          __typename?: 'ProductVariantConnection';
          edges: Array<{
            __typename?: 'ProductVariantEdge';
            node: {
              __typename?: 'ProductVariant';
              id: string;
              title: string;
              price: { __typename?: 'MoneyV2'; amount: any };
            };
          }>;
        };
      }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant' }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenGetOrderProductsForFrameUpsellQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ShopifyGenGetOrderProductsForFrameUpsellQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | {
        __typename?: 'Product';
        id: string;
        framingUpsellEndTime?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        frames?: {
          __typename?: 'Metafield';
          references?: {
            __typename?: 'MetafieldReferenceConnection';
            nodes: Array<
              | { __typename?: 'Collection' }
              | { __typename?: 'GenericFile' }
              | { __typename?: 'MediaImage' }
              | { __typename?: 'Metaobject' }
              | { __typename?: 'Model3d' }
              | { __typename?: 'Page' }
              | {
                  __typename?: 'Product';
                  id: string;
                  frameName?: {
                    __typename?: 'Metafield';
                    value: string;
                  } | null;
                  frameFinish?: {
                    __typename?: 'Metafield';
                    value: string;
                  } | null;
                  images: {
                    __typename?: 'ImageConnection';
                    nodes: Array<{ __typename?: 'Image'; url: string }>;
                  };
                  variants: {
                    __typename?: 'ProductVariantConnection';
                    edges: Array<{
                      __typename?: 'ProductVariantEdge';
                      node: {
                        __typename?: 'ProductVariant';
                        id: string;
                        title: string;
                        price: { __typename?: 'MoneyV2'; amount: any };
                      };
                    }>;
                  };
                }
              | { __typename?: 'ProductVariant' }
              | { __typename?: 'Video' }
            >;
          } | null;
        } | null;
      }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant' }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenGetProductPurchaseDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  country?: InputMaybe<ShopifyGenCountryCode>;
}>;

export type ShopifyGenGetProductPurchaseDetailsQuery = {
  __typename?: 'QueryRoot';
  product?: {
    __typename?: 'Product';
    id: string;
    title: string;
    handle: string;
    tags: Array<string>;
    variants: {
      __typename?: 'ProductVariantConnection';
      edges: Array<{
        __typename?: 'ProductVariantEdge';
        node: {
          __typename?: 'ProductVariant';
          id: string;
          sku?: string | null;
          title: string;
          availableForSale: boolean;
          requiresShipping: boolean;
          price: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
      }>;
    };
    priceRange: {
      __typename?: 'ProductPriceRange';
      maxVariantPrice: {
        __typename?: 'MoneyV2';
        amount: any;
        currencyCode: ShopifyGenCurrencyCode;
      };
    };
    manifoldListingId?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    auctionFloorPrice?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    editionSize?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    artistName?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    launchDate?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    framingOffered?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    unframedDispatchDate?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    framedDispatchDate?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    closingDate?: {
      __typename?: 'Metafield';
      value: string;
      type: string;
    } | null;
    collectionSet?: {
      __typename?: 'Metafield';
      reference?:
        | {
            __typename?: 'Collection';
            image?: { __typename?: 'Image'; url: string } | null;
            products: {
              __typename?: 'ProductConnection';
              nodes: Array<{
                __typename?: 'Product';
                id: string;
                title: string;
                handle: string;
                tags: Array<string>;
                featuredImage?: { __typename?: 'Image'; url: string } | null;
                artistName?: { __typename?: 'Metafield'; value: string } | null;
                maximumSalesCapacity?: {
                  __typename?: 'Metafield';
                  value: string;
                } | null;
                variants: {
                  __typename?: 'ProductVariantConnection';
                  edges: Array<{
                    __typename?: 'ProductVariantEdge';
                    node: {
                      __typename?: 'ProductVariant';
                      id: string;
                      title: string;
                      availableForSale: boolean;
                      price: { __typename?: 'MoneyV2'; amount: any };
                    };
                  }>;
                };
                frames?: {
                  __typename?: 'Metafield';
                  references?: {
                    __typename?: 'MetafieldReferenceConnection';
                    nodes: Array<
                      | { __typename?: 'Collection' }
                      | { __typename?: 'GenericFile' }
                      | { __typename?: 'MediaImage' }
                      | { __typename?: 'Metaobject' }
                      | { __typename?: 'Model3d' }
                      | { __typename?: 'Page' }
                      | {
                          __typename?: 'Product';
                          id: string;
                          frameName?: {
                            __typename?: 'Metafield';
                            value: string;
                          } | null;
                          frameFinish?: {
                            __typename?: 'Metafield';
                            value: string;
                          } | null;
                          images: {
                            __typename?: 'ImageConnection';
                            nodes: Array<{ __typename?: 'Image'; url: string }>;
                          };
                          variants: {
                            __typename?: 'ProductVariantConnection';
                            edges: Array<{
                              __typename?: 'ProductVariantEdge';
                              node: {
                                __typename?: 'ProductVariant';
                                id: string;
                                title: string;
                                price: { __typename?: 'MoneyV2'; amount: any };
                              };
                            }>;
                          };
                        }
                      | { __typename?: 'ProductVariant' }
                      | { __typename?: 'Video' }
                    >;
                  } | null;
                } | null;
              }>;
            };
            worksSelectorDescription?: {
              __typename?: 'Metafield';
              value: string;
            } | null;
          }
        | { __typename?: 'GenericFile' }
        | { __typename?: 'MediaImage' }
        | { __typename?: 'Metaobject' }
        | { __typename?: 'Model3d' }
        | { __typename?: 'Page' }
        | { __typename?: 'Product' }
        | { __typename?: 'ProductVariant' }
        | { __typename?: 'Video' }
        | null;
    } | null;
    maximumSalesCapacity?: { __typename?: 'Metafield'; value: string } | null;
    frames?: {
      __typename?: 'Metafield';
      references?: {
        __typename?: 'MetafieldReferenceConnection';
        nodes: Array<
          | { __typename?: 'Collection' }
          | { __typename?: 'GenericFile' }
          | { __typename?: 'MediaImage' }
          | { __typename?: 'Metaobject' }
          | { __typename?: 'Model3d' }
          | { __typename?: 'Page' }
          | {
              __typename?: 'Product';
              id: string;
              frameName?: { __typename?: 'Metafield'; value: string } | null;
              frameFinish?: { __typename?: 'Metafield'; value: string } | null;
              images: {
                __typename?: 'ImageConnection';
                nodes: Array<{ __typename?: 'Image'; url: string }>;
              };
              variants: {
                __typename?: 'ProductVariantConnection';
                edges: Array<{
                  __typename?: 'ProductVariantEdge';
                  node: {
                    __typename?: 'ProductVariant';
                    id: string;
                    title: string;
                    price: { __typename?: 'MoneyV2'; amount: any };
                  };
                }>;
              };
            }
          | { __typename?: 'ProductVariant' }
          | { __typename?: 'Video' }
        >;
      } | null;
    } | null;
  } | null;
};

export type ShopifyGenGetProductsCollectionsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ShopifyGenGetProductsCollectionsQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | {
        __typename?: 'Product';
        id: string;
        collections: {
          __typename?: 'CollectionConnection';
          nodes: Array<{
            __typename?: 'Collection';
            title: string;
            id: string;
          }>;
        };
      }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant' }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenSelectedProductsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  country?: InputMaybe<ShopifyGenCountryCode>;
}>;

export type ShopifyGenSelectedProductsQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | {
        __typename?: 'Product';
        id: string;
        title: string;
        productType: string;
        tags: Array<string>;
        handle: string;
        onlineStoreUrl?: string | null;
        artistName?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        launchDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        framingOffered?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        unframedDispatchDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        framedDispatchDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        closingDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        editionSize?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        releaseType?: { __typename?: 'Metafield'; value: string } | null;
        cryptoPrice?: { __typename?: 'Metafield'; value: string } | null;
        priceRange: {
          __typename?: 'ProductPriceRange';
          maxVariantPrice: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
        featuredImage?: {
          __typename?: 'Image';
          altText?: string | null;
          url: string;
        } | null;
        variants: {
          __typename?: 'ProductVariantConnection';
          edges: Array<{
            __typename?: 'ProductVariantEdge';
            node: {
              __typename?: 'ProductVariant';
              id: string;
              title: string;
              price: { __typename?: 'MoneyV2'; amount: any };
            };
          }>;
        };
        collectionSet?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
      }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant' }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenAllProductsIDsQueryVariables = Exact<{
  filters: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShopifyGenAllProductsIDsQuery = {
  __typename?: 'QueryRoot';
  products: {
    __typename?: 'ProductConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'ProductEdge';
      cursor: string;
      node: { __typename?: 'Product'; id: string };
    }>;
  };
};

export type ShopifyGenAllProductsQueryVariables = Exact<{
  country?: InputMaybe<ShopifyGenCountryCode>;
  filters: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShopifyGenAllProductsQuery = {
  __typename?: 'QueryRoot';
  products: {
    __typename?: 'ProductConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'ProductEdge';
      cursor: string;
      node: {
        __typename?: 'Product';
        createdAt: any;
        id: string;
        title: string;
        productType: string;
        handle: string;
        tags: Array<string>;
        onlineStoreUrl?: string | null;
        manifoldListingId?: { __typename?: 'Metafield'; value: string } | null;
        auctionFloorPrice?: { __typename?: 'Metafield'; value: string } | null;
        editionSize?: { __typename?: 'Metafield'; value: string } | null;
        artistName?: { __typename?: 'Metafield'; value: string } | null;
        launchDate?: { __typename?: 'Metafield'; value: string } | null;
        cryptoPrice?: { __typename?: 'Metafield'; value: string } | null;
        closingDate?: { __typename?: 'Metafield'; value: string } | null;
        releaseType?: { __typename?: 'Metafield'; value: string } | null;
        framingOffered?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        unframedDispatchDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        framedDispatchDate?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        collectionSet?: {
          __typename?: 'Metafield';
          value: string;
          type: string;
        } | null;
        maximumSalesCapacity?: {
          __typename?: 'Metafield';
          value: string;
        } | null;
        priceRange: {
          __typename?: 'ProductPriceRange';
          maxVariantPrice: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
        featuredImage?: {
          __typename?: 'Image';
          altText?: string | null;
          url: string;
        } | null;
        variants: {
          __typename?: 'ProductVariantConnection';
          edges: Array<{
            __typename?: 'ProductVariantEdge';
            node: {
              __typename?: 'ProductVariant';
              title: string;
              price: { __typename?: 'MoneyV2'; amount: any };
            };
          }>;
        };
      };
    }>;
  };
};

export type ShopifyGenProductPriceTagsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  country?: InputMaybe<ShopifyGenCountryCode>;
}>;

export type ShopifyGenProductPriceTagsQuery = {
  __typename?: 'QueryRoot';
  node?:
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | {
        __typename?: 'Product';
        tags: Array<string>;
        priceRange: {
          __typename?: 'ProductPriceRange';
          maxVariantPrice: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
      }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant' }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null;
};

export type ShopifyGenProductsPriceQueryVariables = Exact<{
  country?: InputMaybe<ShopifyGenCountryCode>;
  filters: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShopifyGenProductsPriceQuery = {
  __typename?: 'QueryRoot';
  products: {
    __typename?: 'ProductConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'ProductEdge';
      cursor: string;
      node: {
        __typename?: 'Product';
        id: string;
        priceRange: {
          __typename?: 'ProductPriceRange';
          maxVariantPrice: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
      };
    }>;
  };
};

export type ShopifyGenGetProductQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  variantCount?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ShopifyGenGetProductQuery = {
  __typename?: 'QueryRoot';
  product?: {
    __typename?: 'Product';
    availableForSale: boolean;
    title: string;
    tags: Array<string>;
    totalInventory?: number | null;
    description: string;
    priceRange: {
      __typename?: 'ProductPriceRange';
      minVariantPrice: {
        __typename?: 'MoneyV2';
        amount: any;
        currencyCode: ShopifyGenCurrencyCode;
      };
      maxVariantPrice: {
        __typename?: 'MoneyV2';
        amount: any;
        currencyCode: ShopifyGenCurrencyCode;
      };
    };
    featuredImage?: { __typename?: 'Image'; url: string } | null;
    variants: {
      __typename?: 'ProductVariantConnection';
      edges: Array<{
        __typename?: 'ProductVariantEdge';
        node: {
          __typename?: 'ProductVariant';
          id: string;
          sku?: string | null;
          priceV2: {
            __typename?: 'MoneyV2';
            amount: any;
            currencyCode: ShopifyGenCurrencyCode;
          };
        };
      }>;
    };
  } | null;
};

export type ShopifyGenAllProductsCountQueryVariables = Exact<{
  country?: InputMaybe<ShopifyGenCountryCode>;
  filters: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShopifyGenAllProductsCountQuery = {
  __typename?: 'QueryRoot';
  products: {
    __typename?: 'ProductConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Array<{
      __typename?: 'ProductEdge';
      cursor: string;
      node: {
        __typename?: 'Product';
        productType: string;
        editionSize?: { __typename?: 'Metafield'; value: string } | null;
      };
    }>;
  };
};

export type ShopifyGenProductsByTagQueryVariables = Exact<{
  country?: InputMaybe<ShopifyGenCountryCode>;
  filters: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ShopifyGenProductsByTagQuery = {
  __typename?: 'QueryRoot';
  products: {
    __typename?: 'ProductConnection';
    edges: Array<{
      __typename?: 'ProductEdge';
      node: {
        __typename?: 'Product';
        createdAt: any;
        id: string;
        title: string;
        productType: string;
        tags: Array<string>;
        handle: string;
        onlineStoreUrl?: string | null;
        editionSize?: { __typename?: 'Metafield'; value: string } | null;
        artistName?: { __typename?: 'Metafield'; value: string } | null;
        launchDate?: { __typename?: 'Metafield'; value: string } | null;
        manifoldListingId?: { __typename?: 'Metafield'; value: string } | null;
        auctionFloorPrice?: { __typename?: 'Metafield'; value: string } | null;
        cryptoPrice?: { __typename?: 'Metafield'; value: string } | null;
        closingDate?: { __typename?: 'Metafield'; value: string } | null;
        releaseType?: { __typename?: 'Metafield'; value: string } | null;
        priceRange: {
          __typename?: 'ProductPriceRange';
          maxVariantPrice: { __typename?: 'MoneyV2'; amount: any };
        };
        featuredImage?: {
          __typename?: 'Image';
          altText?: string | null;
          url: string;
        } | null;
        variants: {
          __typename?: 'ProductVariantConnection';
          edges: Array<{
            __typename?: 'ProductVariantEdge';
            node: {
              __typename?: 'ProductVariant';
              title: string;
              price: { __typename?: 'MoneyV2'; amount: any };
            };
          }>;
        };
      };
    }>;
  };
};

export type ShopifyGenGiftCardsQueryVariables = Exact<{
  filters: Scalars['String']['input'];
}>;

export type ShopifyGenGiftCardsQuery = {
  __typename?: 'QueryRoot';
  collection?: {
    __typename?: 'Collection';
    products: {
      __typename?: 'ProductConnection';
      edges: Array<{
        __typename?: 'ProductEdge';
        node: {
          __typename?: 'Product';
          id: string;
          title: string;
          description: string;
          tags: Array<string>;
          variants: {
            __typename?: 'ProductVariantConnection';
            edges: Array<{
              __typename?: 'ProductVariantEdge';
              node: {
                __typename?: 'ProductVariant';
                id: string;
                price: { __typename?: 'MoneyV2'; amount: any };
              };
            }>;
          };
        };
      }>;
    };
  } | null;
};

export type ShopifyGenVariantIDsToSlugsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ShopifyGenVariantIDsToSlugsQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | { __typename?: 'Product' }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | {
        __typename?: 'ProductVariant';
        id: string;
        product: { __typename?: 'Product'; handle: string };
      }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenVariantAvailabilityQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ShopifyGenVariantAvailabilityQuery = {
  __typename?: 'QueryRoot';
  nodes: Array<
    | { __typename?: 'AppliedGiftCard' }
    | { __typename?: 'Article' }
    | { __typename?: 'Blog' }
    | { __typename?: 'Cart' }
    | { __typename?: 'CartLine' }
    | { __typename?: 'Collection' }
    | { __typename?: 'Comment' }
    | { __typename?: 'Company' }
    | { __typename?: 'CompanyContact' }
    | { __typename?: 'CompanyLocation' }
    | { __typename?: 'ComponentizableCartLine' }
    | { __typename?: 'ExternalVideo' }
    | { __typename?: 'GenericFile' }
    | { __typename?: 'Location' }
    | { __typename?: 'MailingAddress' }
    | { __typename?: 'Market' }
    | { __typename?: 'MediaImage' }
    | { __typename?: 'MediaPresentation' }
    | { __typename?: 'Menu' }
    | { __typename?: 'MenuItem' }
    | { __typename?: 'Metafield' }
    | { __typename?: 'Metaobject' }
    | { __typename?: 'Model3d' }
    | { __typename?: 'Order' }
    | { __typename?: 'Page' }
    | { __typename?: 'Product' }
    | { __typename?: 'ProductOption' }
    | { __typename?: 'ProductOptionValue' }
    | { __typename?: 'ProductVariant'; id: string; availableForSale: boolean }
    | { __typename?: 'Shop' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlan' }
    | { __typename?: 'ShopPayInstallmentsFinancingPlanTerm' }
    | { __typename?: 'ShopPayInstallmentsProductVariantPricing' }
    | { __typename?: 'ShopPolicy' }
    | { __typename?: 'TaxonomyCategory' }
    | { __typename?: 'UrlRedirect' }
    | { __typename?: 'Video' }
    | null
  >;
};

export type ShopifyGenUpdateCartWithProductsMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  lines: Array<ShopifyGenCartLineUpdateInput> | ShopifyGenCartLineUpdateInput;
}>;

export type ShopifyGenUpdateCartWithProductsMutation = {
  __typename?: 'Mutation';
  cartLinesUpdate?: { __typename: 'CartLinesUpdatePayload' } | null;
};

export const CreateCartWithProductsDocument = gql`
  mutation CreateCartWithProducts(
    $country: CountryCode!
    $lineItems: [CartLineInput!]!
    $customAttributes: [AttributeInput!]
  ) @inContext(country: $country) {
    cartCreate(
      input: {
        buyerIdentity: { countryCode: $country }
        lines: $lineItems
        attributes: $customAttributes
      }
    ) {
      cart {
        id
        checkoutUrl
        lines(first: 100) {
          nodes {
            id
            attributes {
              key
              value
            }
            cost {
              totalAmount {
                amount
              }
            }
            discountAllocations {
              discountedAmount {
                amount
              }
            }
          }
        }
      }
    }
  }
`;
export type ShopifyGenCreateCartWithProductsMutationFn =
  Apollo.MutationFunction<
    ShopifyGenCreateCartWithProductsMutation,
    ShopifyGenCreateCartWithProductsMutationVariables
  >;

/**
 * __useCreateCartWithProductsMutation__
 *
 * To run a mutation, you first call `useCreateCartWithProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCartWithProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCartWithProductsMutation, { data, loading, error }] = useCreateCartWithProductsMutation({
 *   variables: {
 *      country: // value for 'country'
 *      lineItems: // value for 'lineItems'
 *      customAttributes: // value for 'customAttributes'
 *   },
 * });
 */
export function useCreateCartWithProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShopifyGenCreateCartWithProductsMutation,
    ShopifyGenCreateCartWithProductsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ShopifyGenCreateCartWithProductsMutation,
    ShopifyGenCreateCartWithProductsMutationVariables
  >(CreateCartWithProductsDocument, options);
}
export type CreateCartWithProductsMutationHookResult = ReturnType<
  typeof useCreateCartWithProductsMutation
>;
export type CreateCartWithProductsMutationResult =
  Apollo.MutationResult<ShopifyGenCreateCartWithProductsMutation>;
export type CreateCartWithProductsMutationOptions = Apollo.BaseMutationOptions<
  ShopifyGenCreateCartWithProductsMutation,
  ShopifyGenCreateCartWithProductsMutationVariables
>;
export const GetCollectionByIdDocument = gql`
  query getCollectionById($id: ID!) {
    collection(id: $id) {
      image {
        url
      }
      products(first: 99) {
        nodes {
          id
          title
          handle
          featuredImage {
            url
          }
          tags
          artistName: metafield(namespace: "my_fields", key: "artist_name") {
            value
          }
          maximumSalesCapacity: metafield(
            namespace: "custom"
            key: "maximum_sales_capacity"
          ) {
            value
          }
          variants(first: 100) {
            edges {
              node {
                id
                title
                availableForSale
                price {
                  amount
                }
              }
            }
          }
        }
      }
      worksSelectorDescription: metafield(
        namespace: "custom"
        key: "works_selector_description"
      ) {
        value
      }
    }
  }
`;

/**
 * __useGetCollectionByIdQuery__
 *
 * To run a query within a React component, call `useGetCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  > &
    (
      | { variables: ShopifyGenGetCollectionByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  >(GetCollectionByIdDocument, options);
}
export function useGetCollectionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  >(GetCollectionByIdDocument, options);
}
export function useGetCollectionByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetCollectionByIdQuery,
        ShopifyGenGetCollectionByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  >(GetCollectionByIdDocument, options);
}
export type GetCollectionByIdQueryHookResult = ReturnType<
  typeof useGetCollectionByIdQuery
>;
export type GetCollectionByIdLazyQueryHookResult = ReturnType<
  typeof useGetCollectionByIdLazyQuery
>;
export type GetCollectionByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCollectionByIdSuspenseQuery
>;
export type GetCollectionByIdQueryResult = Apollo.QueryResult<
  ShopifyGenGetCollectionByIdQuery,
  ShopifyGenGetCollectionByIdQueryVariables
>;
export const GetFrameVariantsByFrameProdutIdsDocument = gql`
  query getFrameVariantsByFrameProdutIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        variants(first: 100) {
          edges {
            node {
              id
              title
              price {
                amount
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFrameVariantsByFrameProdutIdsQuery__
 *
 * To run a query within a React component, call `useGetFrameVariantsByFrameProdutIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameVariantsByFrameProdutIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameVariantsByFrameProdutIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetFrameVariantsByFrameProdutIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  > &
    (
      | {
          variables: ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  >(GetFrameVariantsByFrameProdutIdsDocument, options);
}
export function useGetFrameVariantsByFrameProdutIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  >(GetFrameVariantsByFrameProdutIdsDocument, options);
}
export function useGetFrameVariantsByFrameProdutIdsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
        ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  >(GetFrameVariantsByFrameProdutIdsDocument, options);
}
export type GetFrameVariantsByFrameProdutIdsQueryHookResult = ReturnType<
  typeof useGetFrameVariantsByFrameProdutIdsQuery
>;
export type GetFrameVariantsByFrameProdutIdsLazyQueryHookResult = ReturnType<
  typeof useGetFrameVariantsByFrameProdutIdsLazyQuery
>;
export type GetFrameVariantsByFrameProdutIdsSuspenseQueryHookResult =
  ReturnType<typeof useGetFrameVariantsByFrameProdutIdsSuspenseQuery>;
export type GetFrameVariantsByFrameProdutIdsQueryResult = Apollo.QueryResult<
  ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
  ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
>;
export const GetOrderProductsForFrameUpsellDocument = gql`
  query getOrderProductsForFrameUpsell($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        framingUpsellEndTime: metafield(
          namespace: "my_fields"
          key: "framing_upsell_end_time"
        ) {
          value
          type
        }
        frames: metafield(namespace: "custom", key: "frames") {
          references(first: 10) {
            nodes {
              ... on Product {
                id
                frameName: metafield(namespace: "custom", key: "frame_name") {
                  value
                }
                frameFinish: metafield(
                  namespace: "custom"
                  key: "frame_finish"
                ) {
                  value
                }
                images(first: 2) {
                  nodes {
                    url
                  }
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      title
                      price {
                        amount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrderProductsForFrameUpsellQuery__
 *
 * To run a query within a React component, call `useGetOrderProductsForFrameUpsellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderProductsForFrameUpsellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderProductsForFrameUpsellQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetOrderProductsForFrameUpsellQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  > &
    (
      | {
          variables: ShopifyGenGetOrderProductsForFrameUpsellQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  >(GetOrderProductsForFrameUpsellDocument, options);
}
export function useGetOrderProductsForFrameUpsellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  >(GetOrderProductsForFrameUpsellDocument, options);
}
export function useGetOrderProductsForFrameUpsellSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetOrderProductsForFrameUpsellQuery,
        ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  >(GetOrderProductsForFrameUpsellDocument, options);
}
export type GetOrderProductsForFrameUpsellQueryHookResult = ReturnType<
  typeof useGetOrderProductsForFrameUpsellQuery
>;
export type GetOrderProductsForFrameUpsellLazyQueryHookResult = ReturnType<
  typeof useGetOrderProductsForFrameUpsellLazyQuery
>;
export type GetOrderProductsForFrameUpsellSuspenseQueryHookResult = ReturnType<
  typeof useGetOrderProductsForFrameUpsellSuspenseQuery
>;
export type GetOrderProductsForFrameUpsellQueryResult = Apollo.QueryResult<
  ShopifyGenGetOrderProductsForFrameUpsellQuery,
  ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
>;
export const GetProductPurchaseDetailsDocument = gql`
  query getProductPurchaseDetails($id: ID!, $country: CountryCode)
  @inContext(country: $country) {
    product(id: $id) {
      id
      title
      handle
      variants(first: 100) {
        edges {
          node {
            id
            sku
            title
            availableForSale
            requiresShipping
            price {
              amount
              currencyCode
            }
          }
        }
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      tags
      manifoldListingId: metafield(
        namespace: "custom"
        key: "manifold_listing_id"
      ) {
        value
        type
      }
      auctionFloorPrice: metafield(
        namespace: "custom"
        key: "auction_floor_price"
      ) {
        value
        type
      }
      editionSize: metafield(namespace: "my_fields", key: "edition_size") {
        value
        type
      }
      artistName: metafield(namespace: "my_fields", key: "artist_name") {
        value
        type
      }
      launchDate: metafield(namespace: "my_fields", key: "launch_date") {
        value
        type
      }
      framingOffered: metafield(
        namespace: "my_fields"
        key: "framing_offered"
      ) {
        value
        type
      }
      unframedDispatchDate: metafield(
        namespace: "my_fields"
        key: "unframed_dispatch_date"
      ) {
        value
        type
      }
      framedDispatchDate: metafield(
        namespace: "my_fields"
        key: "framed_dispatch_date"
      ) {
        value
        type
      }
      closingDate: metafield(
        namespace: "my_fields"
        key: "timed_release_closing_date"
      ) {
        value
        type
      }
      collectionSet: metafield(namespace: "custom", key: "set_collection") {
        reference {
          ... on Collection {
            image {
              url
            }
            products(first: 99) {
              nodes {
                id
                title
                handle
                featuredImage {
                  url
                }
                tags
                artistName: metafield(
                  namespace: "my_fields"
                  key: "artist_name"
                ) {
                  value
                }
                maximumSalesCapacity: metafield(
                  namespace: "custom"
                  key: "maximum_sales_capacity"
                ) {
                  value
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      title
                      availableForSale
                      price {
                        amount
                      }
                    }
                  }
                }
                frames: metafield(namespace: "custom", key: "frames") {
                  references(first: 10) {
                    nodes {
                      ... on Product {
                        id
                        frameName: metafield(
                          namespace: "custom"
                          key: "frame_name"
                        ) {
                          value
                        }
                        frameFinish: metafield(
                          namespace: "custom"
                          key: "frame_finish"
                        ) {
                          value
                        }
                        images(first: 2) {
                          nodes {
                            url
                          }
                        }
                        variants(first: 100) {
                          edges {
                            node {
                              id
                              title
                              price {
                                amount
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            worksSelectorDescription: metafield(
              namespace: "custom"
              key: "works_selector_description"
            ) {
              value
            }
          }
        }
      }
      maximumSalesCapacity: metafield(
        namespace: "custom"
        key: "maximum_sales_capacity"
      ) {
        value
      }
      frames: metafield(namespace: "custom", key: "frames") {
        references(first: 10) {
          nodes {
            ... on Product {
              id
              frameName: metafield(namespace: "custom", key: "frame_name") {
                value
              }
              frameFinish: metafield(namespace: "custom", key: "frame_finish") {
                value
              }
              images(first: 2) {
                nodes {
                  url
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    price {
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductPurchaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetProductPurchaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPurchaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPurchaseDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetProductPurchaseDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  > &
    (
      | {
          variables: ShopifyGenGetProductPurchaseDetailsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  >(GetProductPurchaseDetailsDocument, options);
}
export function useGetProductPurchaseDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  >(GetProductPurchaseDetailsDocument, options);
}
export function useGetProductPurchaseDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetProductPurchaseDetailsQuery,
        ShopifyGenGetProductPurchaseDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  >(GetProductPurchaseDetailsDocument, options);
}
export type GetProductPurchaseDetailsQueryHookResult = ReturnType<
  typeof useGetProductPurchaseDetailsQuery
>;
export type GetProductPurchaseDetailsLazyQueryHookResult = ReturnType<
  typeof useGetProductPurchaseDetailsLazyQuery
>;
export type GetProductPurchaseDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetProductPurchaseDetailsSuspenseQuery
>;
export type GetProductPurchaseDetailsQueryResult = Apollo.QueryResult<
  ShopifyGenGetProductPurchaseDetailsQuery,
  ShopifyGenGetProductPurchaseDetailsQueryVariables
>;
export const GetProductsCollectionsDocument = gql`
  query getProductsCollections($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        collections(first: 10) {
          nodes {
            title
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductsCollectionsQuery__
 *
 * To run a query within a React component, call `useGetProductsCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsCollectionsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetProductsCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  > &
    (
      | {
          variables: ShopifyGenGetProductsCollectionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  >(GetProductsCollectionsDocument, options);
}
export function useGetProductsCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  >(GetProductsCollectionsDocument, options);
}
export function useGetProductsCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetProductsCollectionsQuery,
        ShopifyGenGetProductsCollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  >(GetProductsCollectionsDocument, options);
}
export type GetProductsCollectionsQueryHookResult = ReturnType<
  typeof useGetProductsCollectionsQuery
>;
export type GetProductsCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetProductsCollectionsLazyQuery
>;
export type GetProductsCollectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetProductsCollectionsSuspenseQuery
>;
export type GetProductsCollectionsQueryResult = Apollo.QueryResult<
  ShopifyGenGetProductsCollectionsQuery,
  ShopifyGenGetProductsCollectionsQueryVariables
>;
export const SelectedProductsDocument = gql`
  query SelectedProducts($ids: [ID!]!, $country: CountryCode)
  @inContext(country: $country) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        productType
        artistName: metafield(namespace: "my_fields", key: "artist_name") {
          value
          type
        }
        launchDate: metafield(namespace: "my_fields", key: "launch_date") {
          value
          type
        }
        framingOffered: metafield(
          namespace: "my_fields"
          key: "framing_offered"
        ) {
          value
          type
        }
        unframedDispatchDate: metafield(
          namespace: "my_fields"
          key: "unframed_dispatch_date"
        ) {
          value
          type
        }
        framedDispatchDate: metafield(
          namespace: "my_fields"
          key: "framed_dispatch_date"
        ) {
          value
          type
        }
        closingDate: metafield(
          namespace: "my_fields"
          key: "timed_release_closing_date"
        ) {
          value
          type
        }
        editionSize: metafield(namespace: "my_fields", key: "edition_size") {
          value
          type
        }
        releaseType: metafield(namespace: "my_fields", key: "release_type") {
          value
        }
        cryptoPrice: metafield(
          namespace: "my_fields"
          key: "crypto_display_price"
        ) {
          value
        }
        priceRange {
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        tags
        handle
        onlineStoreUrl
        featuredImage {
          altText
          url
        }
        variants(first: 100) {
          edges {
            node {
              id
              title
              price {
                amount
              }
            }
          }
        }
        collectionSet: metafield(namespace: "custom", key: "set_collection") {
          value
          type
        }
      }
    }
  }
`;

/**
 * __useSelectedProductsQuery__
 *
 * To run a query within a React component, call `useSelectedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedProductsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSelectedProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  > &
    (
      | { variables: ShopifyGenSelectedProductsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  >(SelectedProductsDocument, options);
}
export function useSelectedProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  >(SelectedProductsDocument, options);
}
export function useSelectedProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenSelectedProductsQuery,
        ShopifyGenSelectedProductsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  >(SelectedProductsDocument, options);
}
export type SelectedProductsQueryHookResult = ReturnType<
  typeof useSelectedProductsQuery
>;
export type SelectedProductsLazyQueryHookResult = ReturnType<
  typeof useSelectedProductsLazyQuery
>;
export type SelectedProductsSuspenseQueryHookResult = ReturnType<
  typeof useSelectedProductsSuspenseQuery
>;
export type SelectedProductsQueryResult = Apollo.QueryResult<
  ShopifyGenSelectedProductsQuery,
  ShopifyGenSelectedProductsQueryVariables
>;
export const AllProductsIDsDocument = gql`
  query AllProductsIDs($filters: String!, $limit: Int!, $after: String) {
    products(query: $filters, first: $limit, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

/**
 * __useAllProductsIDsQuery__
 *
 * To run a query within a React component, call `useAllProductsIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsIDsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllProductsIDsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  > &
    (
      | { variables: ShopifyGenAllProductsIDsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  >(AllProductsIDsDocument, options);
}
export function useAllProductsIDsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  >(AllProductsIDsDocument, options);
}
export function useAllProductsIDsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenAllProductsIDsQuery,
        ShopifyGenAllProductsIDsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  >(AllProductsIDsDocument, options);
}
export type AllProductsIDsQueryHookResult = ReturnType<
  typeof useAllProductsIDsQuery
>;
export type AllProductsIDsLazyQueryHookResult = ReturnType<
  typeof useAllProductsIDsLazyQuery
>;
export type AllProductsIDsSuspenseQueryHookResult = ReturnType<
  typeof useAllProductsIDsSuspenseQuery
>;
export type AllProductsIDsQueryResult = Apollo.QueryResult<
  ShopifyGenAllProductsIDsQuery,
  ShopifyGenAllProductsIDsQueryVariables
>;
export const AllProductsDocument = gql`
  query AllProducts(
    $country: CountryCode
    $filters: String!
    $limit: Int!
    $after: String
  ) @inContext(country: $country) {
    products(query: $filters, first: $limit, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          createdAt
          id
          title
          productType
          handle
          manifoldListingId: metafield(
            namespace: "custom"
            key: "manifold_listing_id"
          ) {
            value
          }
          auctionFloorPrice: metafield(
            namespace: "custom"
            key: "auction_floor_price"
          ) {
            value
          }
          editionSize: metafield(namespace: "my_fields", key: "edition_size") {
            value
          }
          artistName: metafield(namespace: "my_fields", key: "artist_name") {
            value
          }
          launchDate: metafield(namespace: "my_fields", key: "launch_date") {
            value
          }
          cryptoPrice: metafield(
            namespace: "my_fields"
            key: "crypto_display_price"
          ) {
            value
          }
          closingDate: metafield(
            namespace: "my_fields"
            key: "timed_release_closing_date"
          ) {
            value
          }
          releaseType: metafield(namespace: "my_fields", key: "release_type") {
            value
          }
          framingOffered: metafield(
            namespace: "my_fields"
            key: "framing_offered"
          ) {
            value
            type
          }
          unframedDispatchDate: metafield(
            namespace: "my_fields"
            key: "unframed_dispatch_date"
          ) {
            value
            type
          }
          framedDispatchDate: metafield(
            namespace: "my_fields"
            key: "framed_dispatch_date"
          ) {
            value
            type
          }
          collectionSet: metafield(namespace: "custom", key: "set_collection") {
            value
            type
          }
          maximumSalesCapacity: metafield(
            namespace: "custom"
            key: "maximum_sales_capacity"
          ) {
            value
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          tags
          onlineStoreUrl
          featuredImage {
            altText
            url
          }
          variants(first: 100) {
            edges {
              node {
                title
                price {
                  amount
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useAllProductsQuery__
 *
 * To run a query within a React component, call `useAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  > &
    (
      | { variables: ShopifyGenAllProductsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  >(AllProductsDocument, options);
}
export function useAllProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  >(AllProductsDocument, options);
}
export function useAllProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenAllProductsQuery,
        ShopifyGenAllProductsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  >(AllProductsDocument, options);
}
export type AllProductsQueryHookResult = ReturnType<typeof useAllProductsQuery>;
export type AllProductsLazyQueryHookResult = ReturnType<
  typeof useAllProductsLazyQuery
>;
export type AllProductsSuspenseQueryHookResult = ReturnType<
  typeof useAllProductsSuspenseQuery
>;
export type AllProductsQueryResult = Apollo.QueryResult<
  ShopifyGenAllProductsQuery,
  ShopifyGenAllProductsQueryVariables
>;
export const ProductPriceTagsDocument = gql`
  query ProductPriceTags($id: ID!, $country: CountryCode)
  @inContext(country: $country) {
    node(id: $id) {
      ... on Product {
        priceRange {
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        tags
      }
    }
  }
`;

/**
 * __useProductPriceTagsQuery__
 *
 * To run a query within a React component, call `useProductPriceTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useProductPriceTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  > &
    (
      | { variables: ShopifyGenProductPriceTagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  >(ProductPriceTagsDocument, options);
}
export function useProductPriceTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  >(ProductPriceTagsDocument, options);
}
export function useProductPriceTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenProductPriceTagsQuery,
        ShopifyGenProductPriceTagsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  >(ProductPriceTagsDocument, options);
}
export type ProductPriceTagsQueryHookResult = ReturnType<
  typeof useProductPriceTagsQuery
>;
export type ProductPriceTagsLazyQueryHookResult = ReturnType<
  typeof useProductPriceTagsLazyQuery
>;
export type ProductPriceTagsSuspenseQueryHookResult = ReturnType<
  typeof useProductPriceTagsSuspenseQuery
>;
export type ProductPriceTagsQueryResult = Apollo.QueryResult<
  ShopifyGenProductPriceTagsQuery,
  ShopifyGenProductPriceTagsQueryVariables
>;
export const ProductsPriceDocument = gql`
  query ProductsPrice(
    $country: CountryCode
    $filters: String!
    $limit: Int!
    $after: String
  ) @inContext(country: $country) {
    products(query: $filters, first: $limit, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

/**
 * __useProductsPriceQuery__
 *
 * To run a query within a React component, call `useProductsPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsPriceQuery({
 *   variables: {
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProductsPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  > &
    (
      | { variables: ShopifyGenProductsPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  >(ProductsPriceDocument, options);
}
export function useProductsPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  >(ProductsPriceDocument, options);
}
export function useProductsPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenProductsPriceQuery,
        ShopifyGenProductsPriceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  >(ProductsPriceDocument, options);
}
export type ProductsPriceQueryHookResult = ReturnType<
  typeof useProductsPriceQuery
>;
export type ProductsPriceLazyQueryHookResult = ReturnType<
  typeof useProductsPriceLazyQuery
>;
export type ProductsPriceSuspenseQueryHookResult = ReturnType<
  typeof useProductsPriceSuspenseQuery
>;
export type ProductsPriceQueryResult = Apollo.QueryResult<
  ShopifyGenProductsPriceQuery,
  ShopifyGenProductsPriceQueryVariables
>;
export const GetProductDocument = gql`
  query GetProduct($id: ID, $variantCount: Int) {
    product(id: $id) {
      availableForSale
      title
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      tags
      totalInventory
      description
      featuredImage {
        url
      }
      variants(first: $variantCount) {
        edges {
          node {
            id
            sku
            priceV2 {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      variantCount: // value for 'variantCount'
 *   },
 * });
 */
export function useGetProductQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >(GetProductDocument, options);
}
export function useGetProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >(GetProductDocument, options);
}
export function useGetProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGetProductQuery,
        ShopifyGenGetProductQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >(GetProductDocument, options);
}
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<
  typeof useGetProductLazyQuery
>;
export type GetProductSuspenseQueryHookResult = ReturnType<
  typeof useGetProductSuspenseQuery
>;
export type GetProductQueryResult = Apollo.QueryResult<
  ShopifyGenGetProductQuery,
  ShopifyGenGetProductQueryVariables
>;
export const AllProductsCountDocument = gql`
  query AllProductsCount(
    $country: CountryCode
    $filters: String!
    $limit: Int!
    $after: String
  ) @inContext(country: $country) {
    products(query: $filters, first: $limit, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          productType
          editionSize: metafield(namespace: "my_fields", key: "edition_size") {
            value
          }
        }
      }
    }
  }
`;

/**
 * __useAllProductsCountQuery__
 *
 * To run a query within a React component, call `useAllProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsCountQuery({
 *   variables: {
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAllProductsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  > &
    (
      | { variables: ShopifyGenAllProductsCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  >(AllProductsCountDocument, options);
}
export function useAllProductsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  >(AllProductsCountDocument, options);
}
export function useAllProductsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenAllProductsCountQuery,
        ShopifyGenAllProductsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  >(AllProductsCountDocument, options);
}
export type AllProductsCountQueryHookResult = ReturnType<
  typeof useAllProductsCountQuery
>;
export type AllProductsCountLazyQueryHookResult = ReturnType<
  typeof useAllProductsCountLazyQuery
>;
export type AllProductsCountSuspenseQueryHookResult = ReturnType<
  typeof useAllProductsCountSuspenseQuery
>;
export type AllProductsCountQueryResult = Apollo.QueryResult<
  ShopifyGenAllProductsCountQuery,
  ShopifyGenAllProductsCountQueryVariables
>;
export const ProductsByTagDocument = gql`
  query ProductsByTag($country: CountryCode, $filters: String!, $limit: Int)
  @inContext(country: $country) {
    products(query: $filters, first: $limit) {
      edges {
        node {
          createdAt
          id
          title
          productType
          editionSize: metafield(namespace: "my_fields", key: "edition_size") {
            value
          }
          artistName: metafield(namespace: "my_fields", key: "artist_name") {
            value
          }
          launchDate: metafield(namespace: "my_fields", key: "launch_date") {
            value
          }
          manifoldListingId: metafield(
            namespace: "custom"
            key: "manifold_listing_id"
          ) {
            value
          }
          auctionFloorPrice: metafield(
            namespace: "custom"
            key: "auction_floor_price"
          ) {
            value
          }
          cryptoPrice: metafield(
            namespace: "my_fields"
            key: "crypto_display_price"
          ) {
            value
          }
          closingDate: metafield(
            namespace: "my_fields"
            key: "timed_release_closing_date"
          ) {
            value
          }
          releaseType: metafield(namespace: "my_fields", key: "release_type") {
            value
          }
          priceRange {
            maxVariantPrice {
              amount
            }
          }
          tags
          handle
          onlineStoreUrl
          featuredImage {
            altText
            url
          }
          variants(first: 10) {
            edges {
              node {
                title
                price {
                  amount
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useProductsByTagQuery__
 *
 * To run a query within a React component, call `useProductsByTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByTagQuery({
 *   variables: {
 *      country: // value for 'country'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductsByTagQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  > &
    (
      | { variables: ShopifyGenProductsByTagQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  >(ProductsByTagDocument, options);
}
export function useProductsByTagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  >(ProductsByTagDocument, options);
}
export function useProductsByTagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenProductsByTagQuery,
        ShopifyGenProductsByTagQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  >(ProductsByTagDocument, options);
}
export type ProductsByTagQueryHookResult = ReturnType<
  typeof useProductsByTagQuery
>;
export type ProductsByTagLazyQueryHookResult = ReturnType<
  typeof useProductsByTagLazyQuery
>;
export type ProductsByTagSuspenseQueryHookResult = ReturnType<
  typeof useProductsByTagSuspenseQuery
>;
export type ProductsByTagQueryResult = Apollo.QueryResult<
  ShopifyGenProductsByTagQuery,
  ShopifyGenProductsByTagQueryVariables
>;
export const GiftCardsDocument = gql`
  query GiftCards($filters: String!) {
    collection(handle: $filters) {
      products(first: 100) {
        edges {
          node {
            id
            title
            description
            tags
            variants(first: 5) {
              edges {
                node {
                  id
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGiftCardsQuery__
 *
 * To run a query within a React component, call `useGiftCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGiftCardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  > &
    (
      | { variables: ShopifyGenGiftCardsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  >(GiftCardsDocument, options);
}
export function useGiftCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  >(GiftCardsDocument, options);
}
export function useGiftCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenGiftCardsQuery,
        ShopifyGenGiftCardsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  >(GiftCardsDocument, options);
}
export type GiftCardsQueryHookResult = ReturnType<typeof useGiftCardsQuery>;
export type GiftCardsLazyQueryHookResult = ReturnType<
  typeof useGiftCardsLazyQuery
>;
export type GiftCardsSuspenseQueryHookResult = ReturnType<
  typeof useGiftCardsSuspenseQuery
>;
export type GiftCardsQueryResult = Apollo.QueryResult<
  ShopifyGenGiftCardsQuery,
  ShopifyGenGiftCardsQueryVariables
>;
export const VariantIDsToSlugsDocument = gql`
  query VariantIDsToSlugs($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        product {
          handle
        }
      }
    }
  }
`;

/**
 * __useVariantIDsToSlugsQuery__
 *
 * To run a query within a React component, call `useVariantIDsToSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantIDsToSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantIDsToSlugsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVariantIDsToSlugsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  > &
    (
      | { variables: ShopifyGenVariantIDsToSlugsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  >(VariantIDsToSlugsDocument, options);
}
export function useVariantIDsToSlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  >(VariantIDsToSlugsDocument, options);
}
export function useVariantIDsToSlugsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenVariantIDsToSlugsQuery,
        ShopifyGenVariantIDsToSlugsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  >(VariantIDsToSlugsDocument, options);
}
export type VariantIDsToSlugsQueryHookResult = ReturnType<
  typeof useVariantIDsToSlugsQuery
>;
export type VariantIDsToSlugsLazyQueryHookResult = ReturnType<
  typeof useVariantIDsToSlugsLazyQuery
>;
export type VariantIDsToSlugsSuspenseQueryHookResult = ReturnType<
  typeof useVariantIDsToSlugsSuspenseQuery
>;
export type VariantIDsToSlugsQueryResult = Apollo.QueryResult<
  ShopifyGenVariantIDsToSlugsQuery,
  ShopifyGenVariantIDsToSlugsQueryVariables
>;
export const VariantAvailabilityDocument = gql`
  query VariantAvailability($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        availableForSale
      }
    }
  }
`;

/**
 * __useVariantAvailabilityQuery__
 *
 * To run a query within a React component, call `useVariantAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantAvailabilityQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVariantAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  > &
    (
      | {
          variables: ShopifyGenVariantAvailabilityQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  >(VariantAvailabilityDocument, options);
}
export function useVariantAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  >(VariantAvailabilityDocument, options);
}
export function useVariantAvailabilitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShopifyGenVariantAvailabilityQuery,
        ShopifyGenVariantAvailabilityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  >(VariantAvailabilityDocument, options);
}
export type VariantAvailabilityQueryHookResult = ReturnType<
  typeof useVariantAvailabilityQuery
>;
export type VariantAvailabilityLazyQueryHookResult = ReturnType<
  typeof useVariantAvailabilityLazyQuery
>;
export type VariantAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useVariantAvailabilitySuspenseQuery
>;
export type VariantAvailabilityQueryResult = Apollo.QueryResult<
  ShopifyGenVariantAvailabilityQuery,
  ShopifyGenVariantAvailabilityQueryVariables
>;
export const UpdateCartWithProductsDocument = gql`
  mutation UpdateCartWithProducts(
    $cartId: ID!
    $lines: [CartLineUpdateInput!]!
  ) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      __typename
    }
  }
`;
export type ShopifyGenUpdateCartWithProductsMutationFn =
  Apollo.MutationFunction<
    ShopifyGenUpdateCartWithProductsMutation,
    ShopifyGenUpdateCartWithProductsMutationVariables
  >;

/**
 * __useUpdateCartWithProductsMutation__
 *
 * To run a mutation, you first call `useUpdateCartWithProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartWithProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartWithProductsMutation, { data, loading, error }] = useUpdateCartWithProductsMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useUpdateCartWithProductsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShopifyGenUpdateCartWithProductsMutation,
    ShopifyGenUpdateCartWithProductsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ShopifyGenUpdateCartWithProductsMutation,
    ShopifyGenUpdateCartWithProductsMutationVariables
  >(UpdateCartWithProductsDocument, options);
}
export type UpdateCartWithProductsMutationHookResult = ReturnType<
  typeof useUpdateCartWithProductsMutation
>;
export type UpdateCartWithProductsMutationResult =
  Apollo.MutationResult<ShopifyGenUpdateCartWithProductsMutation>;
export type UpdateCartWithProductsMutationOptions = Apollo.BaseMutationOptions<
  ShopifyGenUpdateCartWithProductsMutation,
  ShopifyGenUpdateCartWithProductsMutationVariables
>;
export const namedOperations = {
  Query: {
    getCollectionById: 'getCollectionById',
    getFrameVariantsByFrameProdutIds: 'getFrameVariantsByFrameProdutIds',
    getOrderProductsForFrameUpsell: 'getOrderProductsForFrameUpsell',
    getProductPurchaseDetails: 'getProductPurchaseDetails',
    getProductsCollections: 'getProductsCollections',
    SelectedProducts: 'SelectedProducts',
    AllProductsIDs: 'AllProductsIDs',
    AllProducts: 'AllProducts',
    ProductPriceTags: 'ProductPriceTags',
    ProductsPrice: 'ProductsPrice',
    GetProduct: 'GetProduct',
    AllProductsCount: 'AllProductsCount',
    ProductsByTag: 'ProductsByTag',
    GiftCards: 'GiftCards',
    VariantIDsToSlugs: 'VariantIDsToSlugs',
    VariantAvailability: 'VariantAvailability',
  },
  Mutation: {
    CreateCartWithProducts: 'CreateCartWithProducts',
    UpdateCartWithProducts: 'UpdateCartWithProducts',
  },
};

export async function queryGetCollectionById(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetCollectionByIdQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetCollectionByIdQuery,
    ShopifyGenGetCollectionByIdQueryVariables
  >({
    errorPolicy: 'all',
    query: GetCollectionByIdDocument,
    variables,
  });

  return result;
}

export async function queryGetFrameVariantsByFrameProdutIds(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetFrameVariantsByFrameProdutIdsQuery,
    ShopifyGenGetFrameVariantsByFrameProdutIdsQueryVariables
  >({
    errorPolicy: 'all',
    query: GetFrameVariantsByFrameProdutIdsDocument,
    variables,
  });

  return result;
}

export async function queryGetOrderProductsForFrameUpsell(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetOrderProductsForFrameUpsellQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetOrderProductsForFrameUpsellQuery,
    ShopifyGenGetOrderProductsForFrameUpsellQueryVariables
  >({
    errorPolicy: 'all',
    query: GetOrderProductsForFrameUpsellDocument,
    variables,
  });

  return result;
}

export async function queryGetProductPurchaseDetails(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetProductPurchaseDetailsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetProductPurchaseDetailsQuery,
    ShopifyGenGetProductPurchaseDetailsQueryVariables
  >({
    errorPolicy: 'all',
    query: GetProductPurchaseDetailsDocument,
    variables,
  });

  return result;
}

export async function queryGetProductsCollections(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetProductsCollectionsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetProductsCollectionsQuery,
    ShopifyGenGetProductsCollectionsQueryVariables
  >({
    errorPolicy: 'all',
    query: GetProductsCollectionsDocument,
    variables,
  });

  return result;
}

export async function querySelectedProducts(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenSelectedProductsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenSelectedProductsQuery,
    ShopifyGenSelectedProductsQueryVariables
  >({
    errorPolicy: 'all',
    query: SelectedProductsDocument,
    variables,
  });

  return result;
}

export async function queryAllProductsIDs(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenAllProductsIDsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenAllProductsIDsQuery,
    ShopifyGenAllProductsIDsQueryVariables
  >({
    errorPolicy: 'all',
    query: AllProductsIDsDocument,
    variables,
  });

  return result;
}

export async function queryAllProducts(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenAllProductsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenAllProductsQuery,
    ShopifyGenAllProductsQueryVariables
  >({
    errorPolicy: 'all',
    query: AllProductsDocument,
    variables,
  });

  return result;
}

export async function queryProductPriceTags(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenProductPriceTagsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenProductPriceTagsQuery,
    ShopifyGenProductPriceTagsQueryVariables
  >({
    errorPolicy: 'all',
    query: ProductPriceTagsDocument,
    variables,
  });

  return result;
}

export async function queryProductsPrice(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenProductsPriceQueryVariables,
) {
  const result = await client.query<
    ShopifyGenProductsPriceQuery,
    ShopifyGenProductsPriceQueryVariables
  >({
    errorPolicy: 'all',
    query: ProductsPriceDocument,
    variables,
  });

  return result;
}

export async function queryGetProduct(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGetProductQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGetProductQuery,
    ShopifyGenGetProductQueryVariables
  >({
    errorPolicy: 'all',
    query: GetProductDocument,
    variables,
  });

  return result;
}

export async function queryAllProductsCount(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenAllProductsCountQueryVariables,
) {
  const result = await client.query<
    ShopifyGenAllProductsCountQuery,
    ShopifyGenAllProductsCountQueryVariables
  >({
    errorPolicy: 'all',
    query: AllProductsCountDocument,
    variables,
  });

  return result;
}

export async function queryProductsByTag(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenProductsByTagQueryVariables,
) {
  const result = await client.query<
    ShopifyGenProductsByTagQuery,
    ShopifyGenProductsByTagQueryVariables
  >({
    errorPolicy: 'all',
    query: ProductsByTagDocument,
    variables,
  });

  return result;
}

export async function queryGiftCards(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenGiftCardsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenGiftCardsQuery,
    ShopifyGenGiftCardsQueryVariables
  >({
    errorPolicy: 'all',
    query: GiftCardsDocument,
    variables,
  });

  return result;
}

export async function queryVariantIDsToSlugs(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenVariantIDsToSlugsQueryVariables,
) {
  const result = await client.query<
    ShopifyGenVariantIDsToSlugsQuery,
    ShopifyGenVariantIDsToSlugsQueryVariables
  >({
    errorPolicy: 'all',
    query: VariantIDsToSlugsDocument,
    variables,
  });

  return result;
}

export async function queryVariantAvailability(
  client: ApolloClient<NormalizedCacheObject>,
  variables: ShopifyGenVariantAvailabilityQueryVariables,
) {
  const result = await client.query<
    ShopifyGenVariantAvailabilityQuery,
    ShopifyGenVariantAvailabilityQueryVariables
  >({
    errorPolicy: 'all',
    query: VariantAvailabilityDocument,
    variables,
  });

  return result;
}
